import React, { useState, useEffect } from "react";
import AdminNavbar from "../Navbars/AdminNavbar.js";
import Sidebar from "../Sidebar/Sidebar";
import { AxiosResponse } from 'axios';
import { UserApis } from '../../apis/userApi';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { convertUTCDateToLocalDate } from '../Reusable/functions';
import { NavLink } from 'react-router-dom';
//@ts-ignore
import Modal from 'react-awesome-modal';
import { SvgElement, icontypesEnum } from '../assets/svgElement';
import { SuperAdminApis } from '../../apis/superAdminApi';
import BulkDeliveryPhotos from './BulkDeliveryPhotos';
import { STATUSTYPES } from '../Reusable/Status';
import { CURRENCYCODE } from '../Reusable/CurrencyCode';
import { COUNTRYCODE } from '../Reusable/CountryCode';
import AdminSidebar from '../Sidebar/AdminSidebar';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Oval } from 'react-loader-spinner';
import { MdDelete } from "react-icons/md";
import { FaEye } from "react-icons/fa";
import Select from 'react-select';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { MdDownload } from "react-icons/md";
import * as XLSX from 'xlsx';
import SearchableSelect, { SelectOption } from '../Reusable/SearchableSelect';

// Static dropdown option sets for the create-shipment form.
const SERVICE_OPTIONS: SelectOption[] = [
  { value: 'DOME', label: 'Domestic Express' },
  { value: 'ED', label: 'Express Documents' },
  { value: 'EN', label: 'Express Non Documents' },
  { value: 'DOMS', label: 'Domestic Saver' },
  { value: 'SKYSAV', label: 'SkySaver' },
  { value: 'AF', label: 'Air Freight' },
  { value: 'Cargo', label: 'Cargo' },
  { value: 'DG', label: 'Dangerous Goods' },
  { value: 'HV', label: 'Heavy Shipment' },
];

const PICKUP_OPTIONS: SelectOption[] = [
  { value: 'true', label: 'Yes' },
  { value: 'false', label: 'No' },
];

const SHIPMENT_TERM_OPTIONS: SelectOption[] = [
  { value: 'DDU', label: 'DDU' },
  { value: 'DDP', label: 'DDP' },
];

const INCOTERM_OPTIONS: SelectOption[] = [
  { value: 'CIF', label: 'CIF' },
  { value: 'CFR', label: 'CFR' },
  { value: 'FOB', label: 'FOB' },
  { value: 'DE', label: 'DE' },
];

const BUSINESS_TYPE_OPTIONS: SelectOption[] = [
  { value: 'B2C', label: 'B2C' },
  { value: 'B2B', label: 'B2B' },
  { value: 'C2C', label: 'C2C' },
];

// "NG" is not an ISO currency code, but it is the value the form has always
// submitted by default, so it stays at the top of the list.
const CURRENCY_OPTIONS: SelectOption[] = [
  { value: 'NG', label: 'NG' },
  ...CURRENCYCODE.map((currency: any) => ({
    value: currency?.CurrencyCode,
    // Full name so the currency is searchable by name; the narrow control
    // still shows just the code.
    label: `${currency?.CurrencyCode} — ${currency?.CurrencyName}`,
    shortLabel: currency?.CurrencyCode,
  })),
];

const GOODS_ORIGIN_OPTIONS: SelectOption[] = COUNTRYCODE.map((country: any) => ({
  value: country?.CountryCode,
  label: country?.CountrynName,
}));

const exportToExcel = (data: any) => {
  let exp = data?.map((shipment: any) => ({
    'Sender Name': shipment.SenderName,
    'Sender Address 1': shipment.SenderAdd1,
    'Sender City': shipment.SenderAddCity,
    'Sender State': shipment.SenderAddState,
    'Sender Phone': shipment.SenderPhone,
    'Sender Email': shipment.SenderEmail,
    'Receiver Name': shipment.ReceiverName,
    'Receiver Address 1': shipment.ReceiverAdd1,
    'Receiver City': shipment.ReceiverAddCity,
    'Receiver State': shipment.ReceiverAddState,
    'Receiver Phone': shipment.ReceiverPhone,
    'Receiver Email': shipment.ReceiverEmail,
    'Goods Description': shipment.GoodsDescription,
    'Shipment Status': shipment.Status,
    'Weight': shipment.Weight,
    'Number of Items': shipment.NoOfItems,
    'Shipment Number': shipment.ShipmentNumber,
    'Label URL': shipment.LabelURL,
    'Payment Status': shipment.payment_status,
    'Freight Cost': shipment.FreightCost,
    'Freight Cost Currency': shipment.FreightCostCurrencyCode,
  }));

  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(exp);
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Manifests');
  XLSX.writeFile(workbook, 'Shipments.xlsx');
};

function Shipments() {
  let [showScreen, setShowScreen] = React.useState<any>(1);
  const navigate = useNavigate();
  const userLoginData = useSelector((state: any) => state.data.login.value);

  // ── Create on behalf of a customer ──────────────────────────────
  // Staff with `can_create_shipment_for_customer` can book against an existing
  // cash/credit account, so the shipment and its invoice land on that customer
  // instead of the staff account they are logged into.
  const canCreateForCustomer = React.useMemo(() => {
    if (userLoginData?.data?.role === 'admin') return true;
    try {
      const perms = userLoginData?.data?.permissions ? JSON.parse(userLoginData.data.permissions) : [];
      return Array.isArray(perms) && perms.includes('can_create_shipment_for_customer');
    } catch {
      return false;
    }
  }, [userLoginData]);

  const [cashCustomers, setCashCustomers] = React.useState<any[]>([]);
  const [creditCustomers, setCreditCustomers] = React.useState<any[]>([]);
  const [onBehalfCustomer, setOnBehalfCustomer] = React.useState<any>(null);
  // Which picker the selection came from, so the other one clears.
  const [onBehalfType, setOnBehalfType] = React.useState<'cash' | 'credit' | ''>('');
  const isCreditCustomer = onBehalfCustomer?.customer_type === 'credit';
  const [shipmentRateType, setShipmentRateType] = React.useState<string>('fixed');
  const [specialUnitType, setSpecialUnitType] = React.useState<string>('');

  // How many cartons/kegs. Special rates are banded by quantity AND multiplied by it,
  // so this is the difference between one carton and fifty — they used to bill the same.
  const [specialQuantity, setSpecialQuantity] = React.useState<string>('1');

  let [shipmentData, setShipmentData] = React.useState<any>({
    // These four are rendered as controlled, required inputs, so they start empty
    // and are either typed in or filled from the selected customer's account.
    SenderName: "",
    SenderEmail: "",
    SenderCountryCode: '+234',
    SenderAdd1: '',
    SenderAddCity: 'empty',
    SenderAddState: '',
    SenderAddPostcode: 'empty',
    SenderTaxID: '',
    SenderPhone: '',
    senderLga: 'empty',
    ReceiverName: "",
    ReceiverEmail: "",
    ReceiverCountryCode: '+234',
    ReceiverAdd1: 'no address',
    ReceiverAddCity: 'empty',
    ReceiverAddState: '',
    ReceiverAddPostcode: 'empty',
    ReceiverTaxID: '',
    recieverLga: 'empty',
    ReceiverPhone: '0',
    BookPickUP: false,
    ServiceTypeName: "",
    NoOfItems: "",
    HarmonisedCode: '',
    CubicL: '0',
    CubicW: '0',
    CubicH: '0',
    CubicWeight: '0',
    DeadWeight: '0',
    CustomValue: '0',
    CustomCurrencyCode: 'NG',
    CODAmount: '0',
    CODCurrencyCode: 'NG',
    GoodsDescription: "",
    ShipmentTerm: "DDU",
    Incoterms: 'CFR',
    BusinessType: 'B2C',
    SenderRef1: '',
    SenderRef2: '',
    GoodsOriginCountryCode: 'NG',
    ReasonExport: '',
    DeliveryInstructions: '',
    Notes: '',
    CPCCode: "0",
    SKUNumber: "0",
    ATENumber: '0',
    ProductURL: '',
    GoodsValue: '0',
    GoodsCurrencyCode: 'NG',
    DutyValue: '0',
    DutyCurrencyCode: 'NG',
    EORINumber: '0',
    FreightCost: '',
    FreightCostCurrencyCode: 'NG',
    TotalGSTAmount: '0',
    TotalGSTCurrencyCode: 'NG',
  });

  const [shipmentInfo, setShipmentInfo] = React.useState<any>([]);
  const [shipmentInfos, setShipmentInfos] = React.useState<any>([]);

  // Updated: countryFrom removed, countryTo kept
  const [countryTo, setCountryTo] = React.useState<any>([]);

  const [eventDateTime, setEventDateTime] = React.useState<string>(() => {
    // Default to current datetime in local timezone format for datetime-local input
    const now = new Date();
    const offset = now.getTimezoneOffset();
    const localDate = new Date(now.getTime() - offset * 60 * 1000);
    return localDate.toISOString().slice(0, 16);
  });

  // Updated: Now these reference ZoneState
  const [stateFrom, setStateFrom] = React.useState<any>([]);
  const [stateTo, setStateTo] = React.useState<any>([]);
  const [lgaFrom, setLgaFrom] = React.useState<any>([]);
  const [lgaTo, setLgaTo] = React.useState<any>([]);

  // Service type for cash customers (domestic, express, export)
  const [serviceType, setServiceType] = React.useState<string>('domestic');

  // ── Food items tariff ────────────────────────────────────────────────
  // Priced by destination and what is in the box, not by zone — so picking Food
  // swaps the usual country/state inputs for these two, and the pair chosen
  // decides the rate. Cosmetics never appear under a UK destination, because no
  // rate exists for that and it must not be bookable.
  const [foodOptions, setFoodOptions] = React.useState<any[]>([]);
  const [foodDestination, setFoodDestination] = React.useState<string>('');
  const [foodCommodity, setFoodCommodity] = React.useState<string>('');

  React.useEffect(() => {
    SuperAdminApis.getFoodRateOptions(onBehalfCustomer?.email)
      .then((res: any) => {
        if (res?.data?.status) setFoodOptions(res.data.data.destinations || []);
      })
      .catch(() => setFoodOptions([]));
  }, [onBehalfCustomer]);

  // What may be sent to the chosen destination. Driven by the rates that exist, so
  // an unpriced combination is never offered.
  const foodCommodityOptions = React.useMemo(
    () => foodOptions.find((d: any) => d.key === foodDestination)?.commodities ?? [],
    [foodOptions, foodDestination],
  );

  // Changing destination can invalidate the item type — cosmetics are carried to the
  // USA but not the UK, and leaving a stale value would quote the wrong thing.
  React.useEffect(() => {
    if (foodCommodity && !foodCommodityOptions.some((c: any) => c.key === foodCommodity)) {
      setFoodCommodity('');
    }
  }, [foodCommodityOptions, foodCommodity]);
  const [totalCostData, setTotalCostData] = React.useState<any>(null);

  // Updated: countryFromData removed, always Nigeria (1)
  const [countryToData, setCountryToData] = React.useState<any>('1'); // Default to Nigeria

  // Anything other than Nigeria is an export. Nigerian states and LGAs mean nothing to
  // a parcel going to the UK, and export is priced per half-kilo by destination country
  // without ever looking at a state — so the pickers are emptied rather than offering a
  // choice that cannot be right.
  const isExport = String(countryToData) !== '1';
  const [stateFromData, setStateFromData] = React.useState<any>('');
  const [stateToData, setStateToData] = React.useState<any>('');
  const [lgaFromData, setLgaFromData] = React.useState<any>('');
  const [lgaToData, setLgaToData] = React.useState<any>('');

  let [statusModal, setStatusModal] = React.useState<boolean>(false);
  let [massStatusModal, setMassStatusModal] = React.useState<boolean>(false);
  let [exportModal, setExportModal] = React.useState<boolean>(false);
  let [officeModal, setOfficeModal] = React.useState<boolean>(false);
  let [riderModal, setRiderModal] = React.useState<boolean>(false);
  let [deleteModal, setDeleteModal] = React.useState<boolean>(false);
  let [shipmentId, setShipmentId] = React.useState<any>([]);
  let [notesData, setNotesData] = React.useState<any>("empty");
  let [delieveryInstruction, setDelieveryInstruction] = React.useState<any>("empty");
  let [shipmentStatus, setShipmentStatus] = React.useState<any>('');
  let [shipmentStatusId, setShipmentStatusId] = React.useState<any>('');
  let [shipmentOffice, setShipmentOffice] = React.useState<any>('');
  let [shipmentRider, setShipmentRider] = React.useState<any>('');
  let [shipmentVehicle, setShipmentvehicle] = React.useState<any>('');
  let [riders, setRiders] = React.useState<any>([]);
  let [vehicle, setVehicle] = React.useState<any>([]);
  let [loading, setLoading] = React.useState<boolean>(false);
  const [loader, setLoader] = React.useState<boolean>(false);
  const [loader2, setLoader2] = React.useState<boolean>(false);
  const [from, setFrom] = React.useState('');
  const [to, setTo] = React.useState('');

  const toggleStatus = React.useCallback((data: any) => {
    setStatusModal(true);
    setShipmentId(data)
  }, [shipmentId, statusModal]);

  const [shipid, setShipId] = React.useState<any>({
    shipids: [],
  });

  const selectShipment = (e: any, datas: any) => {
    const { value, checked } = e.target;
    const { shipids } = shipid;

    if (checked) {
      setBarcodeValues((prev) => [...prev, value]);
      setShipId({
        shipids: [...shipids, value],
      });
    } else {
      setBarcodeValues((prev) => prev.filter((e: any) => e !== value));
      setShipId({
        shipids: shipids.filter((e: any) => e !== value)
      });
    }
  };


  const BATCH_SIZE = 50;
  const BATCH_DELAY_MS = 300; // breathing room between batches

  const [uploadProgress, setUploadProgress] = useState<{
    show: boolean;
    total: number;
    processed: number;
    successful: number;
    skipped: number;
    failed: number;
    currentBatch: number;
    totalBatches: number;
    failedBatches: number[];
    failedRows: Array<{ row: any[]; reason: string; batchNumber: number }>; // ← new
    header: string[];
    done: boolean;
  }>({
    show: false,
    total: 0,
    processed: 0,
    successful: 0,
    skipped: 0,
    failed: 0,
    currentBatch: 0,
    totalBatches: 0,
    failedBatches: [],
    failedRows: [],
    header: [],
    done: false,
  });

  const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

  const [barcodeValues, setBarcodeValues] = useState<string[]>([]);
  const [currentInput, setCurrentInput] = useState<string>("");
  const [showShipment, setShowShipment] = useState<boolean>(false);
  const [viewType, setViewType] = useState<any>('');
  let [percentage, setPercentage] = React.useState<any>(0);


  const [stateFromName, setStateFromName] = React.useState<string>('');
  const [stateToName, setStateToName] = React.useState<string>('');

  // Add helper function for LGA service type
  const getLgaServiceType = React.useCallback((currentWeight: string): string => {
    if (!currentWeight) return 'domestic';
    const weightNum = parseFloat(currentWeight);
    return weightNum >= 20 ? 'bulk' : 'domestic';
  }, []);

  // Add helper function to load LGAs
  const loadLgasForState = React.useCallback((stateId: any, stateName: string, direction: 'from' | 'to') => {
    if (!stateName || !shipmentData?.CubicWeight) return;

    const lgaServiceType = getLgaServiceType(shipmentData.CubicWeight);

    // Credit customers get their own LGA set, keyed by their email as client_id.
    const clientId = onBehalfCustomer?.customer_type === 'credit' ? onBehalfCustomer.email : '';

    SuperAdminApis.getLgasByState(stateName, lgaServiceType, clientId)
      .then((response: AxiosResponse<any>) => {
        if (response?.data?.status) {
          const lgas = response?.data?.data || [];
          if (direction === 'from') {
            setLgaFrom(lgas);
          } else {
            setLgaTo(lgas);
          }
        } else {
          if (direction === 'from') {
            setLgaFrom([]);
          } else {
            setLgaTo([]);
          }
        }
      })
      .catch((error) => {
        console.error(`Error loading LGAs ${direction}:`, error);
        if (direction === 'from') {
          setLgaFrom([]);
        } else {
          setLgaTo([]);
        }
      });
  }, [shipmentData?.CubicWeight, getLgaServiceType, onBehalfCustomer]);

  // Add helper for LGA rate info display
  const getLgaRateInfo = (lga: any) => {
    if (!lga.onforwarding_value && !lga.add_1kg_value) return '';
    return ` (Base: ₦${parseFloat(lga.onforwarding_value || 0).toLocaleString()}, +₦${parseFloat(lga.add_1kg_value || 0).toLocaleString()}/kg)`;
  };

  // Option lists for the searchable dropdowns on the create-shipment form.
  const stateFromOptions: SelectOption[] = React.useMemo(
    () => (stateFrom?.data || []).map((state: any) => ({
      value: String(state?.id),
      label: `${state?.state_name}${state?.zone_number ? ` (Zone ${state?.zone_number})` : ''}`,
    })),
    [stateFrom]
  );

  const stateToOptions: SelectOption[] = React.useMemo(
    () => (isExport ? [] : (stateTo?.data || []).map((state: any) => ({
      value: String(state?.id),
      label: `${state?.state_name}${state?.zone_number ? ` (Zone ${state?.zone_number})` : ''}`,
    }))),
    [stateTo, isExport]
  );

  const lgaFromOptions: SelectOption[] = React.useMemo(
    () => (lgaFrom || []).map((lga: any) => ({
      value: lga?.lga_name,
      label: `${lga?.lga_name}${getLgaRateInfo(lga)}`,
      shortLabel: lga?.lga_name,
    })),
    [lgaFrom]
  );

  const lgaToOptions: SelectOption[] = React.useMemo(
    () => (isExport ? [] : (lgaTo || []).map((lga: any) => ({
      value: lga?.lga_name,
      label: `${lga?.lga_name}${getLgaRateInfo(lga)}`,
      shortLabel: lga?.lga_name,
    }))),
    [lgaTo, isExport]
  );

  const destinationCountryOptions: SelectOption[] = React.useMemo(
    () => [
      { value: '1', label: 'Nigeria (Domestic)' },
      ...(countryTo?.data || [])
        .filter((country: any) => country?.id !== 1)
        .map((country: any) => ({ value: String(country?.id), label: country?.country_name })),
    ],
    [countryTo]
  );

  const [scannerStats, setScannerStats] = useState({
    total: 0,
    valid: 0,
    invalid: 0,
    duplicates: 0
  });

  const [validationResults, setValidationResults] = useState<{ [key: string]: 'valid' | 'invalid' | 'duplicate' }>({});
  const [isValidating, setIsValidating] = useState(false);
  const [validationTimeout, setValidationTimeout] = useState<NodeJS.Timeout | null>(null);
  const [templateInfoModal, setTemplateInfoModal] = React.useState<boolean>(false);

  // ── Restore docket numbers ───────────────────────────────────────────
  // The bulk import used to store the client's docket in manifest_id, which the
  // manifest flow overwrites with the manifest's own id — so the docket is lost on
  // every shipment that has since been manifested. This puts it back from a sheet of
  // shipment number -> docket number, into the dedicated docket_number column.
  //
  // Parsed in the browser and posted in batches, like the shipment import above. One
  // request carrying the whole sheet (64,918 rows) killed the worker; the browser
  // reported that as a CORS error.
  const DOCKET_BATCH_SIZE = 1000;

  const [docketModal, setDocketModal] = React.useState<boolean>(false);
  const [docketFile, setDocketFile] = React.useState<File | null>(null);
  const [docketPairs, setDocketPairs] = React.useState<
    { number: string; docket: string; date: string; account_code: string }[] | null
  >(null);
  const [docketParseError, setDocketParseError] = React.useState<string>('');
  const [docketResult, setDocketResult] = React.useState<any>(null);
  const [docketBusy, setDocketBusy] = React.useState<string>('');
  const [docketProgress, setDocketProgress] = React.useState<{ done: number; total: number }>({ done: 0, total: 0 });

  /** Header spellings accepted for each column, lower-cased. */
  const DOCKET_SHIPMENT_HEADERS = [
    'shipment number', 'shipmentnumber', 'shipment no', 'shipment_no',
    'connote #', 'connote', 'connote no', 'waybill', 'waybill number',
    'shipment', 'tracking number',
  ];
  const DOCKET_DOCKET_HEADERS = [
    'docket number', 'docket #', 'docket', 'docketnumber', 'docket_no',
    'docket no', 'docket_number',
  ];

  // Both optional. A sheet may correct only dockets, only dates, only account
  // codes, or any combination — a column that is absent leaves that field alone.
  const DOCKET_DATE_HEADERS = [
    'date', 'shipment date', 'created date', 'cmanifest date', 'manifest date',
  ];
  const DOCKET_ACCOUNT_HEADERS = [
    'account code', 'account', 'accountcode', 'account_code', 'account no', 'account number',
  ];

  /** Read the sheet into pairs. Nothing is sent until the operator asks. */
  const parseDocketFile = React.useCallback(async (file: File) => {
    setDocketParseError('');
    setDocketResult(null);
    setDocketPairs(null);

    try {
      const workbook = XLSX.read(await file.arrayBuffer(), { type: 'array' });
      const rows: any[][] = XLSX.utils.sheet_to_json(
        workbook.Sheets[workbook.SheetNames[0]],
        { header: 1, defval: '', raw: false },
      );

      if (!rows || rows.length < 2) {
        setDocketParseError('That file has no data rows — expected a header row plus at least one shipment.');
        return;
      }

      const header = rows[0].map((h: any) => String(h).trim().toLowerCase());
      const numberCol  = header.findIndex((h: string) => DOCKET_SHIPMENT_HEADERS.includes(h));
      const docketCol  = header.findIndex((h: string) => DOCKET_DOCKET_HEADERS.includes(h));
      const dateCol    = header.findIndex((h: string) => DOCKET_DATE_HEADERS.includes(h));
      const accountCol = header.findIndex((h: string) => DOCKET_ACCOUNT_HEADERS.includes(h));

      if (numberCol === -1) {
        setDocketParseError(
          'Could not find a shipment number column (e.g. "Shipment Number" or "Connote #"). Found: '
          + header.filter(Boolean).join(', '),
        );
        return;
      }

      if (docketCol === -1 && dateCol === -1 && accountCol === -1) {
        setDocketParseError(
          'The sheet has nothing to update. Alongside the shipment number it needs at least one of '
          + '"Docket Number", "Date" or "Account Code". Found: ' + header.filter(Boolean).join(', '),
        );
        return;
      }

      const pairs: { number: string; docket: string; date: string; account_code: string }[] = [];
      let blank = 0;

      rows.slice(1).forEach((row) => {
        const number  = String(row[numberCol] ?? '').trim();
        const docket  = docketCol  === -1 ? '' : String(row[docketCol] ?? '').trim();
        const date    = dateCol    === -1 ? '' : String(row[dateCol] ?? '').trim();
        const account = accountCol === -1 ? '' : String(row[accountCol] ?? '').trim();

        // 'empty' is the sentinel the bulk upload writes for an unreadable cell.
        const cleanDocket  = docket.toLowerCase()  === 'empty' ? '' : docket;
        const cleanAccount = account.toLowerCase() === 'empty' ? '' : account;

        // A row with nothing to change is not worth sending.
        if (!number || (!cleanDocket && !date && !cleanAccount)) {
          blank++;
          return;
        }

        pairs.push({ number, docket: cleanDocket, date, account_code: cleanAccount });
      });

      if (pairs.length === 0) {
        setDocketParseError('No usable rows — every row was missing a shipment number or a docket number.');
        return;
      }

      setDocketPairs(pairs);
      setDocketResult({
        parsed_only: true,
        rows_read: pairs.length,
        blank_rows: blank,
        // Which columns were recognised. Without this a sheet whose date header is
        // spelled differently reads as "everything already correct", and there is
        // nothing on screen to say the column was never found.
        columns: {
          number: numberCol !== -1 ? header[numberCol] : null,
          docket: docketCol !== -1 ? header[docketCol] : null,
          date: dateCol !== -1 ? header[dateCol] : null,
          account_code: accountCol !== -1 ? header[accountCol] : null,
        },
        sheet_headers: header.filter(Boolean),
      });
    } catch (err: any) {
      setDocketParseError('Could not read that file: ' + (err?.message || 'unknown error'));
    }
  }, []);

  /**
   * Run every batch through the backend.
   *
   * Batches are sequential, not parallel: this writes to the shipments table and a
   * burst of concurrent updates is how the earlier version died. Totals are summed
   * here so the screen reports the whole sheet, not the last chunk.
   */
  const runDocketUpload = React.useCallback(async (commit: boolean) => {
    if (!docketPairs?.length) {
      toast.warn('Choose a file and let it read first');
      return;
    }

    const batches: { number: string; docket: string }[][] = [];
    for (let i = 0; i < docketPairs.length; i += DOCKET_BATCH_SIZE) {
      batches.push(docketPairs.slice(i, i + DOCKET_BATCH_SIZE));
    }

    setDocketBusy(commit ? 'apply' : 'check');
    setDocketProgress({ done: 0, total: docketPairs.length });

    const totals: any = {
      committed: commit,
      rows_read: 0, matched: 0, not_found: 0,
      will_set: 0, will_overwrite: 0, already_correct: 0, updated: 0,
      not_found_samples: [], overwrite_samples: [],
      failed_batches: 0,
    };

    for (let i = 0; i < batches.length; i++) {
      try {
        const res: any = await SuperAdminApis.updateDocketNumbers(batches[i], commit);
        const d = res?.data?.data;

        if (d) {
          ['rows_read', 'matched', 'not_found', 'will_set', 'will_overwrite', 'already_correct', 'updated']
            .forEach((k) => { totals[k] += d[k] || 0; });

          // Samples are capped so a 65-batch run cannot build a list too long to render.
          if (totals.not_found_samples.length < 60) {
            totals.not_found_samples.push(...(d.not_found_samples || []).slice(0, 10));
          }
          if (totals.overwrite_samples.length < 60) {
            totals.overwrite_samples.push(...(d.overwrite_samples || []).slice(0, 10));
          }
        }
      } catch (e) {
        // One bad batch does not abandon the sheet. Each batch is independent and
        // idempotent, so the rest still land and a re-run fixes whatever failed.
        totals.failed_batches++;
      }

      setDocketProgress({ done: Math.min((i + 1) * DOCKET_BATCH_SIZE, docketPairs.length), total: docketPairs.length });
      setDocketResult({ ...totals });
    }

    setDocketBusy('');

    if (totals.failed_batches > 0) {
      toast.warn(`${totals.failed_batches} batch(es) failed. Press ${commit ? 'Apply' : 'Check the file'} again to retry those rows.`);
    } else if (commit) {
      toast.success(`Updated the docket number on ${totals.updated.toLocaleString()} shipment(s).`);
    } else {
      toast.success('Check complete — nothing was saved.');
    }
  }, [docketPairs]);

  const templateInfo = {
    requiredColumns: [
      { name: 'Date', description: 'Shipment creation date (YYYY-MM-DD HH:MM:SS)' },
      { name: 'Sender', description: 'Sender full name (required)' },
      { name: 'Sender Address', description: 'Complete sender address (required)' },
      { name: 'Sender Town', description: 'Sender city/town (required)' },
      { name: 'Sender State', description: 'Sender state (required)' },
      { name: 'Receiver', description: 'Receiver full name (required)' },
      { name: 'Receiver Address', description: 'Complete receiver address (required)' },
      { name: 'Receiver Town', description: 'Receiver city/town (required)' },
      { name: 'Receiver State', description: 'Receiver state (required)' },
      { name: 'Receiver Phone', description: 'Receiver phone number (required)' },
      { name: 'Wgt (KG)', description: 'Package weight in kilograms (required)' },
      { name: 'No.of Items', description: 'Number of items in shipment (required)' },
      { name: 'Type', description: 'Service type (DOME, EN, ED, etc.)' },
      { name: 'Goods Desc.', description: 'Description of goods being shipped (required)' }
    ],
    optionalColumns: [
      { name: 'Account Code', description: "The client's own account code. Leave blank if they have not supplied one." },
      { name: 'Docket #', description: 'Docket number for the consignment. Can be added later under Update Docket Numbers.' },
      { name: 'Sender Ref.', description: "The client's own reference for the shipment." },
    ],
    serviceTypes: [
      { code: 'DOME', name: 'Domestic Express' },
      { code: 'ED', name: 'Express Documents' },
      { code: 'EN', name: 'Express Non Documents' },
      { code: 'DOMS', name: 'Domestic Saver' },
      { code: 'SKYSAV', name: 'SkySaver' },
      { code: 'AF', name: 'Air Freight' },
      { code: 'Cargo', name: 'Cargo' },
      { code: 'DG', name: 'Dangerous Goods' },
      { code: 'HV', name: 'Heavy Shipment' }
    ]
  };

  const downloadTemplate = React.useCallback(async (templateType: 'excel' | 'csv' = 'excel') => {
    try {
      let response;
      let fileName;
      let mimeType;

      if (templateType === 'excel') {
        response = await SuperAdminApis.downloadShipmentTemplate();
        fileName = `shipment_upload_template_${new Date().toISOString().split('T')[0]}.xlsx`;
        mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      } else {
        response = await SuperAdminApis.downloadSimpleTemplate();
        fileName = `shipment_upload_template_${new Date().toISOString().split('T')[0]}.csv`;
        mimeType = 'text/csv';
      }

      const blob = new Blob([response.data], { type: mimeType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      toast.success(`${templateType.toUpperCase()} template downloaded successfully!`);
    } catch (error: any) {
      console.error('Template download error:', error);
      toast.error(`Failed to download template: ${error.message}`);
    }
  }, []);

  const validateShipmentNumbers = React.useCallback(async (barcodes: string[]) => {
    if (barcodes.length === 0) {
      setScannerStats({ total: 0, valid: 0, invalid: 0, duplicates: 0 });
      setValidationResults({});
      return;
    }

    setIsValidating(true);

    try {
      const duplicateCheck: { [key: string]: number } = {};
      const newValidationResults: { [key: string]: 'valid' | 'invalid' | 'duplicate' } = {};

      barcodes.forEach(barcode => {
        if (barcode.trim()) {
          duplicateCheck[barcode] = (duplicateCheck[barcode] || 0) + 1;
        }
      });

      Object.keys(duplicateCheck).forEach(barcode => {
        if (duplicateCheck[barcode] > 1) {
          newValidationResults[barcode] = 'duplicate';
        }
      });

      const uniqueBarcodes = barcodes.filter((barcode, index, arr) =>
        arr.indexOf(barcode) === index && barcode.trim() !== ''
      );

      if (uniqueBarcodes.length > 0) {
        const response = await SuperAdminApis.validateShipmentNumbers(uniqueBarcodes);

        if (response?.data?.status) {
          const validShipments = response.data?.data?.validShipments || [];
          const invalidShipments = response.data.data.invalidShipments || [];

          validShipments.forEach((shipment: string) => {
            if (newValidationResults[shipment] !== 'duplicate') {
              newValidationResults[shipment] = 'valid';
            }
          });

          invalidShipments.forEach((shipment: string) => {
            if (newValidationResults[shipment] !== 'duplicate') {
              newValidationResults[shipment] = 'invalid';
            }
          });
        }
      }

      const stats = {
        total: barcodes.filter(b => b.trim()).length,
        valid: Object.values(newValidationResults).filter(status => status === 'valid').length,
        invalid: Object.values(newValidationResults).filter(status => status === 'invalid').length,
        duplicates: Object.values(newValidationResults).filter(status => status === 'duplicate').length
      };

      setValidationResults(newValidationResults);
      setScannerStats(stats);
    } catch (error) {
      console.error('Validation error:', error);
      toast.error('Failed to validate shipment numbers');
    } finally {
      setIsValidating(false);
    }
  }, []);

  const handleBarcodeListChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    const updatedValues = newValue
      .split("\n")
      .map((item) => item.trim())
      .filter((item) => item !== "");

    setBarcodeValues(updatedValues);

    if (validationTimeout) {
      clearTimeout(validationTimeout);
    }

    const timeout = setTimeout(() => {
      validateShipmentNumbers(updatedValues);
    }, 500);

    setValidationTimeout(timeout);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentInput(e.target.value);
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" || e.keyCode === 13) {
      e.preventDefault();
      const value = currentInput.trim();
      if (value && !barcodeValues.includes(value)) {
        const newBarcodeValues = [...barcodeValues, value];
        setBarcodeValues(newBarcodeValues);
        setCurrentInput("");
        validateShipmentNumbers(newBarcodeValues);
      } else {
        setCurrentInput("");
      }
    }
  };

  const handleAddBarcode = React.useCallback(() => {
    const value = currentInput.trim();
    if (value && !barcodeValues.includes(value)) {
      const newBarcodeValues = [...barcodeValues, value];
      setBarcodeValues(newBarcodeValues);
      setCurrentInput("");
      validateShipmentNumbers(newBarcodeValues);
    } else if (value) {
      setCurrentInput("");
    }
  }, [currentInput, barcodeValues, validateShipmentNumbers]);

  const handleBarcodeFormSubmit = React.useCallback((e: React.FormEvent) => {
    e.preventDefault();
    handleAddBarcode();
  }, [handleAddBarcode]);

  const getValidationColor = (barcode: string) => {
    const status = validationResults[barcode];
    switch (status) {
      case 'valid': return 'text-green-600 bg-green-50';
      case 'invalid': return 'text-red-600 bg-red-50';
      case 'duplicate': return 'text-yellow-600 bg-yellow-50';
      default: return 'text-gray-600 bg-gray-50';
    }
  };

  const updateShipment = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    let eventCode = '';
    setLoading(true)

    STATUSTYPES?.filter((data: any) => data?.EventName == shipmentStatus)?.map((datas: any, index: any) => {
      setShipmentStatusId(datas?.EventCode)
      eventCode = datas?.EventCode
    });

    let shiData = shipmentId;

    let shipment = [
      {
        "ThirdPartyToken": "",
        "SenderDetails": {
          "SenderName": shiData?.SenderName ? shiData?.SenderName : 'null',
          "SenderCompanyName": shiData?.SenderCompanyName ? shiData?.SenderCompanyName : "null",
          "SenderCountryCode": shiData?.SenderCountryCode ? shiData?.SenderCountryCode : "null",
          "SenderAdd1": shiData?.SenderAdd1 ? shiData?.SenderAdd1 : "null",
          "SenderAdd2": shiData?.SenderAdd2 ? shiData?.SenderAdd2 : 'null',
          "SenderAdd3": shiData?.SenderAdd3 ? shiData?.SenderAdd3 : 'null',
          "SenderAddCity": shiData?.SenderAddCity ? shiData?.SenderAddCity : 'null',
          "SenderAddState": shiData?.SenderAddState ? shiData?.SenderAddState : 'null',
          "SenderAddPostcode": shiData?.SenderAddPostcode ? shiData?.SenderAddPostcode : 'null',
          "SenderPhone": shiData?.SenderPhone ? shiData?.SenderPhone : 'null',
          "SenderEmail": shiData?.SenderEmail ? shiData?.SenderEmail : 'null',
          "SenderFax": shiData?.SenderFax ? shiData?.SenderFax : 'null',
          "SenderKycType": shiData?.SenderKycType ? shiData?.SenderKycType : 'null',
          "SenderKycNumber": shiData?.SenderKycNumber ? shiData?.SenderKycNumber : 'null',
          "SenderReceivingCountryTaxID": shiData?.SenderReceivingCountryTaxID ? shiData?.SenderReceivingCountryTaxID : 'null'
        },
        "ReceiverDetails": {
          "ReceiverName": shiData?.ReceiverName ? shiData?.ReceiverName : 'null',
          "ReceiverCompanyName": shiData?.ReceiverCompanyName ? shiData?.ReceiverCompanyName : 'null',
          "ReceiverCountryCode": shiData?.ReceiverCountryCode ? shiData?.ReceiverCountryCode : 'null',
          "ReceiverAdd1": shiData?.ReceiverAdd1 ? shiData?.ReceiverAdd1 : 'null',
          "ReceiverAdd2": shiData?.ReceiverAdd2 ? shiData?.ReceiverAdd2 : 'null',
          "ReceiverAdd3": shiData?.ReceiverAdd3 ? shiData?.ReceiverAdd3 : 'null',
          "ReceiverAddCity": shiData?.ReceiverAddCity ? shiData?.ReceiverAddCity : 'null',
          "ReceiverAddState": shiData?.ReceiverAddState ? shiData?.ReceiverAddState : 'null',
          "ReceiverAddPostcode": shiData?.ReceiverAddPostcode ? shiData?.ReceiverAddPostcode : 'null',
          "ReceiverMobile": shiData?.ReceiverMobile ? shiData?.ReceiverMobile : 'null',
          "ReceiverPhone": shiData?.ReceiverPhone ? shiData?.ReceiverPhone : 'null',
          "ReceiverEmail": shiData?.ReceiverEmail ? shiData?.ReceiverEmail : 'null',
          "ReceiverAddResidential": shiData?.ReceiverAddResidential ? shiData?.ReceiverAddResidential : 'null',
          "ReceiverFax": shiData?.ReceiverFax ? shiData?.ReceiverFax : 'null',
          "ReceiverKycType": shiData?.ReceiverKycType ? shiData?.ReceiverKycType : 'null',
          "ReceiverKycNumber": shiData?.ReceiverKycNumber ? shiData?.ReceiverKycNumber : 'null'
        },
        "PackageDetails": {
          "GoodsDescription": shiData?.GoodsDescription ? shiData?.GoodsDescription : 'null',
          "CustomValue": shiData?.CustomValue ? +shiData?.CustomValue : 0,
          "CustomCurrencyCode": shiData?.CustomCurrencyCode ? shiData?.CustomCurrencyCode : 'null',
          "InsuranceValue": shiData?.InsuranceValue ? +shiData?.InsuranceValue : 0,
          "InsuranceCurrencyCode": shiData?.InsuranceCurrencyCode ? shiData?.InsuranceCurrencyCode : 'null',
          "ShipmentTerm": shiData?.ShipmentTerm ? shiData?.ShipmentTerm : 'null',
          "GoodsOriginCountryCode": shiData?.GoodsOriginCountryCode ? shiData?.GoodsOriginCountryCode : 'null',
          "DeliveryInstructions": shiData?.DeliveryInstructions ? shiData?.DeliveryInstructions : 'null',
          "Weight": shiData?.Weight ? +shiData?.Weight : 0,
          "WeightMeasurement": shiData?.WeightMeasurement ? shiData?.WeightMeasurement : 'null',
          "NoOfItems": shiData?.NoOfItems ? +shiData?.NoOfItems : 0,
          "CubicL": shiData?.CubicL ? +shiData?.CubicL : 0,
          "CubicW": shiData?.CubicW ? +shiData?.CubicW : 0,
          "CubicH": shiData?.CubicH ? +shiData?.CubicH : 0,
          "CubicWeight": shiData?.CubicWeight ? +shiData?.CubicWeight : 0,
          "ServiceTypeName": shiData?.ServiceTypeName ? shiData?.ServiceTypeName : 'null',
          "BookPickUP": false,
          "AlternateRef": shiData?.AlternateRef ? shiData?.AlternateRef : 'null',
          "SenderRef1": shiData?.SenderRef1 ? shiData?.SenderRef1 : 'null',
          "SenderRef2": shiData?.SenderRef2 ? shiData?.SenderRef2 : 'null',
          "SenderRef3": shiData?.SenderRef3 ? shiData?.SenderRef3 : 'null',
          "DeliveryAgentCode": shiData?.DeliveryAgentCode ? shiData?.DeliveryAgentCode : 'null',
          "DeliveryRouteCode": shiData?.DeliveryRouteCode ? shiData?.DeliveryRouteCode : 'null',
          "BusinessType": shiData?.BusinessType ? shiData?.BusinessType : 'B2B',
          "ShipmentResponseItem": [
            {
              "ItemAlt": "null",
              "ItemNoOfPcs": shiData?.NoOfItems ? +shiData?.NoOfItems : 0,
              "ItemCubicL": shiData?.CubicL ? +shiData?.CubicL : 0,
              "ItemCubicW": shiData?.CubicW ? +shiData?.CubicW : 0,
              "ItemCubicH": shiData?.CubicH ? +shiData?.CubicH : 0,
              "ItemWeight": shiData?.Weight ? +shiData?.Weight : 0,
              "ItemCubicWeight": shiData?.CubicWeight ? +shiData?.CubicWeight : 0,
              "ItemDescription": shiData?.GoodsDescription ? shiData?.GoodsDescription : 'null',
              "ItemCustomValue": shiData?.CustomValue ? +shiData?.CustomValue : 0,
              "ItemCustomCurrencyCode": shiData?.CustomCurrencyCode ? shiData?.CustomCurrencyCode : 'null',
              "Notes": shiData?.Notes ? shiData?.Notes : 'null'
            }
          ],
          "CODAmount": shiData?.CODAmount ? +shiData?.CODAmount : 0,
          "CODCurrencyCode": shiData?.CODCurrencyCode ? shiData?.CODCurrencyCode : 'null',
          "Bag": shiData?.Bag ? +shiData?.Bag : 0,
          "Notes": shiData?.Notes ? shiData?.Notes : 'null',
          "OriginLocCode": shiData?.OriginLocCode ? shiData?.OriginLocCode : 'null',
          "BagNumber": shiData?.BagNumber ? shiData?.BagNumber : 'null',
          "DeadWeight": shiData?.DeadWeight ? +shiData?.DeadWeight : 0,
          "ReasonExport": shiData?.ReasonExport ? shiData?.ReasonExport : 'null',
          "DestTaxes": shiData?.DestTaxes ? +shiData?.DestTaxes : 0,
          "Security": shiData?.Security ? +shiData?.Security : 0,
          "Surcharge": shiData?.Surcharge ? +shiData?.Surcharge : 0,
          "ReceiverTaxID": shiData?.ReceiverTaxID ? shiData?.ReceiverTaxID : 'null',
          "OrderNumber": shiData?.OrderNumber ? +shiData?.OrderNumber : 0,
          "Incoterms": shiData?.Incoterms ? shiData?.Incoterms : 'null',
          "ClearanceReference": shiData?.ClearanceReference ? shiData?.ClearanceReference : 'null'
        }
      }
    ];

    let data = {
      'id': shipmentId?.id,
      "Status": (shipmentStatus !== '' ? shipmentStatus : shipmentId?.status),
      "status_id": eventCode,
      "del_instruction": delieveryInstruction,
      'shiData': shipment
    }

    // Capture before we reset shipmentId — needed for the in-place row update.
    const updatedId = shipmentId?.id;
    const oldStatus = shipmentId?.Status;
    const newStatus = shipmentStatus !== '' ? shipmentStatus : oldStatus;

    SuperAdminApis.updateShipmentStatus(data)
      .then((response: any) => {
        if (response?.data) {
          if (response?.data?.status) {
            toast.success(response?.data?.message);
            setStatusModal(false)
            setShipmentStatus('')
            setLoading(false)
            setShipmentId([])

            // Update the changed row in place. Preserves current page, search,
            // viewType, and scroll position — no full refetch.
            setShipmentInfo((prev: any) => {
              if (!prev) return prev;
              const next = { ...prev };
              ['out_bound', 'in_bound'].forEach((bucket) => {
                if (next[bucket]?.data?.length) {
                  next[bucket] = {
                    ...next[bucket],
                    data: next[bucket].data.map((row: any) =>
                      row?.id === updatedId ? { ...row, Status: newStatus } : row
                    ),
                  };
                }
              });
              return next;
            });

            // Keep the header counters consistent with the local change.
            if (oldStatus !== newStatus) {
              const wasReview = oldStatus === 'inReview';
              const wasVerified = oldStatus === 'Verified';
              const isReview = newStatus === 'inReview';
              const isVerified = newStatus === 'Verified';

              setPending((n: any) => Math.max(0, (Number(n) || 0) + (isReview ? 1 : 0) - (wasReview ? 1 : 0)));
              setVerified((n: any) => Math.max(0, (Number(n) || 0) + (isVerified ? 1 : 0) - (wasVerified ? 1 : 0)));
              setOthers((n: any) => Math.max(0, (Number(n) || 0)
                + (!isReview && !isVerified ? 1 : 0)
                - (!wasReview && !wasVerified ? 1 : 0)
              ));
            }
          }
        }
      }).catch((err: any) => {
        console.log(err);
        setStatusModal(false)

        // 🔄 Handle transition blocked errors
        if (err?.response?.data?.error === 'INVALID_STATUS_TRANSITION') {
          const workflowInfo = err.response.data.workflow_info;
          const allowedNames = workflowInfo?.allowed_next?.map((s: any) => s.name).join(', ');

          toast.error(
            `${err.response.data.message}${allowedNames ? ` Allowed: ${allowedNames}` : ''}`
          );
        } else {
          toast.error(err?.response?.data?.message || 'Failed to update shipment status.');
        }

        setLoading(false);
      })
  }, [shipmentData, statusModal, shipmentInfo, viewType, shipmentId, shipmentStatus, delieveryInstruction, loading]);

  const updateMultipleShipment = React.useCallback(async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Validate inputs first
      if (!shipmentStatus) {
        toast.error('Please select a status');
        setLoading(false);
        return;
      }

      if (barcodeValues.length === 0) {
        toast.error('Please add at least one shipment number');
        setLoading(false);
        return;
      }

      const BATCH_SIZE = 20;
      const batches = [];

      for (let i = 0; i < barcodeValues.length; i += BATCH_SIZE) {
        batches.push(barcodeValues.slice(i, i + BATCH_SIZE));
      }

      let totalUpdated = 0;
      let totalSkipped = 0;
      let totalNotFound = 0;
      let totalErrors = 0;
      let message = '';
      let allThirdPartyResults: any[] = [];
      let totalTransitionBlocked = 0;
      let allBlockedShipments: any[] = [];

      for (let batchIndex = 0; batchIndex < batches.length; batchIndex++) {
        const batch = batches[batchIndex];

        let data = {
          "Status": shipmentStatus,
          "status_id": STATUSTYPES.find((data) => data?.EventName === shipmentStatus)?.EventCode || '',
          "del_instruction": delieveryInstruction,
          'notes': notesData,
          'shipmentIds': JSON.stringify(batch),
          'event_datetime': eventDateTime,
        };

        // Wrap individual batch call in try-catch
        try {
          const response: any = await SuperAdminApis.updateMultipleShipmentStatus(data);

          // Check if response exists
          if (!response) {
            console.error('No response from API for batch', batchIndex + 1);
            totalErrors += batch.length;
            continue; // Skip to next batch instead of failing completely
          }

          // Check if response.data exists
          if (!response.data) {
            console.error('Response has no data for batch', batchIndex + 1, response);
            totalErrors += batch.length;
            continue;
          }

          // Check status
          if (!response.data.status) {
            console.error('Batch failed:', response.data.message);
            totalErrors += batch.length;
            continue;
          }

          // Accumulate results
          const responseData = response.data.data;
          if (responseData) {
            totalTransitionBlocked += responseData.transition_blocked_count || 0;
            if (responseData.transition_blocked_shipments?.length) {
              allBlockedShipments.push(...responseData.transition_blocked_shipments);
            }
            totalUpdated += responseData.updated_count || 0;
            totalSkipped += responseData.skipped_count || 0;
            totalNotFound += responseData.not_found_count || 0;
            totalErrors += responseData.error_count || 0;
            message = response.data.message || '';

            if (responseData.third_party_api) {
              allThirdPartyResults.push(responseData.third_party_api);
            }
          }

        } catch (batchError: any) {
          console.error('Error processing batch', batchIndex + 1, batchError);

          // Log detailed error info
          if (batchError.response) {
            console.error('API Error Response:', batchError.response.data);
          }

          totalErrors += batch.length;
          // Continue to next batch instead of stopping entirely
          continue;
        }

        // Update progress
        const percentage = ((batchIndex + 1) / batches.length) * 100;
        setPercentage(percentage.toFixed(1));
      }

      // Build success message
      if (totalUpdated > 0 || totalTransitionBlocked > 0) {
        let successMessage = totalUpdated > 0
          ? `Updated ${totalUpdated} shipment(s) successfully.`
          : '';
        if (totalSkipped > 0) {
          successMessage += ` ${totalSkipped} skipped (older event date).`;
        }
        if (totalTransitionBlocked > 0) {
          // Show the reason from the first blocked shipment
          const firstBlocked = allBlockedShipments[0];
          successMessage += ` ${totalTransitionBlocked} blocked: ${firstBlocked?.reason || 'Invalid status transition.'}`;
        }
        if (totalNotFound > 0) {
          successMessage += ` ${totalNotFound} not found.`;
        }
        if (totalErrors > 0) {
          successMessage += ` ${totalErrors} errors.`;
        }

        if (totalUpdated > 0) {
          toast.success(successMessage);
        } else {
          toast.warn(successMessage);
        }
      } else if (totalErrors > 0) {
        toast.error(`Failed to update shipments. ${totalErrors} error(s) occurred.`);
      } else {
        toast.warn(message || 'No shipments were updated.');
      }

      // Log third-party API results
      console.log('Third-party API batch results:', allThirdPartyResults);

      setMassStatusModal(false);
      setShipmentStatus('');
      setLoading(false);
      setBarcodeValues([]);
      setShipmentId([]);

      // Update successful rows in place. Skip anything the backend reported
      // as transition-blocked. Preserves current page, search, viewType.
      if (totalUpdated > 0) {
        const submittedNumbers = new Set(barcodeValues);
        const blockedNumbers = new Set(
          allBlockedShipments.map((b: any) => b?.number).filter(Boolean)
        );
        const newStatus = shipmentStatus;

        let pendingDelta = 0;
        let verifiedDelta = 0;
        let othersDelta = 0;

        const patchBucket = (bucket: any) => {
          if (!bucket?.data?.length) return bucket;
          return {
            ...bucket,
            data: bucket.data.map((row: any) => {
              const numberMatches =
                submittedNumbers.has(row?.ShipmentNumber) ||
                submittedNumbers.has(row?.SenderRef1);
              if (!numberMatches) return row;
              if (blockedNumbers.has(row?.ShipmentNumber)) return row;
              if (row?.Status === newStatus) return row;

              const oldS = row?.Status;
              if (oldS === 'inReview') pendingDelta--;
              else if (oldS === 'Verified') verifiedDelta--;
              else othersDelta--;

              if (newStatus === 'inReview') pendingDelta++;
              else if (newStatus === 'Verified') verifiedDelta++;
              else othersDelta++;

              return { ...row, Status: newStatus };
            }),
          };
        };

        setShipmentInfo((prev: any) => {
          if (!prev) return prev;
          return {
            ...prev,
            out_bound: patchBucket(prev.out_bound),
            in_bound: patchBucket(prev.in_bound),
          };
        });

        if (pendingDelta || verifiedDelta || othersDelta) {
          setPending((n: any) => Math.max(0, (Number(n) || 0) + pendingDelta));
          setVerified((n: any) => Math.max(0, (Number(n) || 0) + verifiedDelta));
          setOthers((n: any) => Math.max(0, (Number(n) || 0) + othersDelta));
        }
      }

    } catch (error: any) {
      console.error('Update multiple shipment error:', error);
      toast.error(`Error: ${error?.message || 'An unexpected error occurred'}`);
    } finally {
      setMassStatusModal(false);
      setShipmentStatus('');
      setLoading(false);
      setShipmentId([]);
      setBarcodeValues([]);
    }
  }, [shipmentData, statusModal, notesData, viewType, barcodeValues, shipid, shipmentInfo, shipmentId, shipmentStatus, delieveryInstruction, loading, eventDateTime]);


  const updateShipmentOffice = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const updatedId = shipmentId?.id;
    const newOffice = shipmentOffice !== '' ? shipmentOffice : shipmentId?.office;

    let data = {
      'id': updatedId,
      "office": newOffice
    }

    SuperAdminApis.updateShipmentOffice(data)
      .then((response: any) => {
        if (response?.data) {
          if (response?.data?.status) {
            toast.success(response?.data?.message);
            setOfficeModal(false)
            setShipmentOffice('')

            // Update the changed row in place — preserves current page,
            // search, and viewType. No full refetch.
            setShipmentInfo((prev: any) => {
              if (!prev) return prev;
              const next = { ...prev };
              ['out_bound', 'in_bound'].forEach((bucket) => {
                if (next[bucket]?.data?.length) {
                  next[bucket] = {
                    ...next[bucket],
                    data: next[bucket].data.map((row: any) =>
                      row?.id === updatedId ? { ...row, office: newOffice } : row
                    ),
                  };
                }
              });
              return next;
            });
          }
        }
      }).catch((err: any) => {
        console.log(err);
      })
  }, [shipmentData, officeModal, viewType, shipmentInfo, shipmentId, shipmentOffice]);

  const [total, setTotal] = React.useState<any>('');
  const [pending, setPending] = React.useState<any>('');
  const [verified, setVerified] = React.useState<any>('');
  const [others, setOthers] = React.useState<any>('');
  const [fleetData, setFleetData] = React.useState<any>('');
  const [localState, setLocalState] = React.useState<any>([]);

  const accumulatedFailedRows: Array<{ row: any[]; reason: string; batchNumber: number }> = [];

  const updateShipmentRider = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    let data = {
      'id': shipmentId?.id,
      "rider": (shipmentRider !== '' ? shipmentRider : shipmentId?.rider),
      "fleet_id": fleetData?.id,
      "fleet_name": fleetData?.first_name,
      "vehicle_name": shipmentVehicle,
    }

    SuperAdminApis.updateShipmentRider(data)
      .then((response: any) => {
        if (response?.data) {
          if (response?.data?.status) {
            toast.success(response?.data?.message);
            setRiderModal(false)
            setShipmentRider('')
            UserApis.getAllShipmentsByUser('').then(
              (response: any) => {
                if (response?.data) {
                  setShipmentInfo(response?.data?.data);

                  SuperAdminApis.getAllShipments('', '', viewType).then(
                    (response: any) => {
                      if (response?.data) {
                        setShipmentInfo(response?.data);
                        setPending(response?.data?.out_bound?.data?.filter((e: any) => e?.Status == 'inReview')?.length)
                        setVerified(response?.data?.out_bound?.data?.filter((e: any) => e?.Status == 'Verified')?.length)
                        setOthers(response?.data?.out_bound?.data?.filter((e: any) => (e?.Status !== 'Verified' && e?.Status !== 'inReview'))?.length)
                        setTotal(response?.data?.out_bound?.data?.length)
                      }
                    }
                  ).catch(function (error) { })
                }
              }
            )
          }
        }
      }).catch((err: any) => {
        console.log(err);
      })
  }, [shipmentData, riderModal, viewType, shipmentInfo, shipmentId, shipmentVehicle, shipmentRider, shipmentInfo, pending, verified, others, total]);

  const deleteShipmnt = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    SuperAdminApis.deleteShipment(shipmentId?.id)
      .then((response: any) => {
        if (response?.data) {
          if (response?.data?.status) {
            toast.success(response?.data?.message);
            setDeleteModal(false)
            setShipmentRider('')
            UserApis.getAllShipmentsByUser('').then(
              (response: any) => {
                if (response?.data) {
                  setShipmentInfo(response?.data?.data);
                  SuperAdminApis.getAllShipments('', '', viewType).then(
                    (response: any) => {
                      if (response?.data) {
                        setShipmentInfo(response?.data);
                        setPending(response?.data?.out_bound?.data?.filter((e: any) => e?.Status == 'inReview')?.length)
                        setVerified(response?.data?.out_bound?.data?.filter((e: any) => e?.Status == 'Verified')?.length)
                        setOthers(response?.data?.out_bound?.data?.filter((e: any) => (e?.Status !== 'Verified' && e?.Status !== 'inReview'))?.length)
                        setTotal(response?.data?.out_bound?.data?.length)
                      }
                    }
                  ).catch(function (error) { })
                }
              }
            )
          }
        }
      }).catch((err: any) => {
        console.log(err);
      })
  }, [deleteModal, shipmentId, viewType, pending, verified, others, total]);

  const handleShipmentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setShipmentData({ ...shipmentData, [e.target.name]: e.target.value });
  }

  React.useEffect(() => {
    const executeAction = () => {
      SuperAdminApis.getAllShipments('', '', viewType).then(
        (response: any) => {
          if (response?.data) {
            setShipmentInfo(response?.data);
            setPending(response?.data?.stat?.inReview)
            setVerified(response?.data?.stat?.Verified)
            setOthers(response?.data?.stat?.other)
            setTotal(response?.data?.stat?.total)
            setLoader(true)
          }
        }
      )
    };

    const intervalId = setInterval(() => {
      executeAction();
    }, 300000);

    return () => clearInterval(intervalId);
  }, []);

  const [branch, setBranch] = React.useState<any>([]);

  React.useEffect(() => {
    SuperAdminApis.getAllShipments('', '', viewType).then(
      (response: any) => {
        if (response?.data) {
          setShipmentInfo(response?.data);
          setPending(response?.data?.stat?.inReview)
          setVerified(response?.data?.stat?.Verified)
          setOthers(response?.data?.stat?.other)
          setTotal(response?.data?.stat?.total)
          setLoader(true)
        }
      }
    ).catch(function (error) { })

    const query: any = {
      search: '',
    };
    SuperAdminApis.getAllRiders('', query).then(
      (response: AxiosResponse<any>) => {
        if (response?.data) {
          setRiders(response?.data?.data?.data)
        }
      }
    );

    SuperAdminApis.getAllBranch('', query).then(
      (response: AxiosResponse<any>) => {
        if (response?.data) {
          setBranch(response?.data?.data)
        }
      }
    )

    // Updated: Get states from ZoneState
    SuperAdminApis.getAllStateTo('', {}).then(
      (response: AxiosResponse<any>) => {
        if (response?.data) {
          setLocalState(response?.data)
        }
      }
    )
  }, []);

  const getAllVehicles = React.useCallback((id: any) => {
    const query: any = {
      search: '',
    };

    let rider_id = '';
    riders?.filter((e: any) => (e?.first_name == id))?.map((e: any) => { rider_id = e?.id; setFleetData(e) })
    SuperAdminApis.getAllVehicle('', query, rider_id).then(
      (response: AxiosResponse<any>) => {
        if (response?.data) {
          setVehicle(response?.data?.data?.data)
        }
      }
    ).catch(function (error) { })
  }, [vehicle, riders, fleetData]);

  const [searchText, setSearchText] = React.useState('');

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setLoader(false);
      SuperAdminApis.getAllShipments('', searchText, viewType).then(
        (response: any) => {
          if (response?.data) {
            setShipmentInfo(response?.data);
            setPending(response?.data?.stat?.inReview);
            setVerified(response?.data?.stat?.Verified);
            setOthers(response?.data?.stat?.other);
            setTotal(response?.data?.stat?.total);
            setLoader(true);
          }
        }
      ).catch(() => { setLoader(true); });
    }, 600);
    return () => clearTimeout(timer);
  }, [searchText, viewType]);

  const downloadFailedRows = React.useCallback(() => {
    if (uploadProgress.failedRows.length === 0) return;

    // Reconstruct rows: original header + an extra "Failure Reason" column
    const exportHeader = [...uploadProgress.header, 'Failure Reason', 'Batch Number'];
    const exportRows = uploadProgress.failedRows.map(f => [
      ...f.row,
      f.reason,
      f.batchNumber,
    ]);

    const aoa = [exportHeader, ...exportRows];
    const worksheet = XLSX.utils.aoa_to_sheet(aoa);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Failed Shipments');

    const timestamp = new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-');
    XLSX.writeFile(workbook, `failed_shipments_${timestamp}.xlsx`);

    toast.success(`Downloaded ${uploadProgress.failedRows.length} failed shipment(s)`);
  }, [uploadProgress.failedRows, uploadProgress.header]);

  const paginator = React.useCallback(
    (value: any) => {
      let value2 = '';
      if (value !== null) {
        value2 = value;
      } else {
        value2 = ''
      }
      setLoader(false)
      SuperAdminApis.getAllShipments(value2, searchText, viewType).then(
        (response: any) => {
          if (response?.data) {
            setShipmentInfo(response?.data);
            setLoader(true)
          }
        }
      ).catch(function (error) {
        console.log(error.response.data);
      })
    }, [shipmentInfo, searchText, loader, viewType]);

  React.useEffect(() => {
    // Updated: Get export countries from ExportRate
    SuperAdminApis.getAllCountryTo('').then(
      (response: AxiosResponse<any>) => {
        if (response?.data) {
          setCountryTo(response?.data)
        }
      }
    )
  }, []);

  // Customer pickers — only fetched for staff who hold the permission.
  React.useEffect(() => {
    if (!canCreateForCustomer) return;

    SuperAdminApis.getCustomersForDropdown('cash').then((response: any) => {
      if (response?.data?.status) setCashCustomers(response.data.data || []);
    }).catch(() => {
      // Picker is optional — the form still works without it.
    });

    SuperAdminApis.getCustomersForDropdown('credit').then((response: any) => {
      if (response?.data?.status) setCreditCustomers(response.data.data || []);
    }).catch(() => { });
  }, [canCreateForCustomer]);

  const cashCustomerOptions: SelectOption[] = React.useMemo(
    () => cashCustomers.map((customer: any) => ({
      value: customer.email,
      label: `${customer.name} — ${customer.email}`,
      shortLabel: `${customer.name} (${customer.email})`,
    })),
    [cashCustomers]
  );

  const creditCustomerOptions: SelectOption[] = React.useMemo(
    () => creditCustomers.map((customer: any) => ({
      value: customer.email,
      label: `${customer.name} — ${customer.email}`,
      shortLabel: `${customer.name} (${customer.email})`,
    })),
    [creditCustomers]
  );

  /**
   * Picking a customer prefills the sender block from their account (still
   * editable) and switches rate calculation onto their account type.
   */
  const selectOnBehalfCustomer = (type: 'cash' | 'credit', email: string) => {
    if (!email) {
      setOnBehalfCustomer(null);
      setOnBehalfType('');
      return;
    }

    const source = type === 'cash' ? cashCustomers : creditCustomers;
    const customer = source.find((c: any) => c.email === email);
    if (!customer) return;

    setOnBehalfCustomer(customer);
    setOnBehalfType(type);
    setShipmentData((prev: any) => ({
      ...prev,
      SenderName: customer.name || prev.SenderName,
      SenderEmail: customer.email,
      SenderPhone: customer.phone_number || prev.SenderPhone,
      SenderAdd1: customer.address || prev.SenderAdd1,
    }));
  };

  const clearOnBehalfCustomer = () => {
    setOnBehalfCustomer(null);
    setOnBehalfType('');
    setSpecialUnitType('');
    setShipmentData((prev: any) => ({
      ...prev,
      SenderName: '',
      SenderEmail: '',
      SenderPhone: '',
      SenderAdd1: '',
    }));
  };

  // Updated: Get states from ZoneState (removed countryFrom dependency)
  const getStateFrom = React.useCallback(
    (id: any) => {
      SuperAdminApis.getAllStateFrom('', {}).then(
        (response: AxiosResponse<any>) => {
          if (response?.data) {
            setStateFrom(response?.data)
          }
        }
      )
    }, [stateFrom]
  );

  const getStateTo = React.useCallback(
    (id: any) => {
      setCountryToData(id)
      SuperAdminApis.getAllStateTo('', {}).then(
        (response: AxiosResponse<any>) => {
          if (response?.data) {
            setStateTo(response?.data)
          }
        }
      )
    }, [stateTo, countryToData]
  );

  React.useEffect(() => {
    if (countryToData && countryToData != 1) {
      setServiceType('export');

      // A Nigerian state picked before the country was changed would otherwise be
      // submitted with an international shipment and, worse, still be sitting in the
      // box reading "Lagos (Zone 1)" on a parcel to the UK.
      setStateToData('');
      setLgaToData('');
    } else {
      setServiceType('domestic');
    }
  }, [countryToData]);

  const getLgaFrom = React.useCallback((id: any) => {
    const selectedState = stateFrom?.data?.find((data: any) => data?.id == id);
    const stateName = selectedState?.state_name;

    setStateFromData(id);
    setStateFromName(stateName);
    setLgaFromData('');
    setLgaFrom([]);

    if (!shipmentData?.CubicWeight) {
      toast.info('Please enter weight first to see available LGAs');
      return;
    }

    loadLgasForState(id, stateName, 'from');
  }, [stateFrom, shipmentData?.CubicWeight, loadLgasForState]);


  const getLgaTo = React.useCallback((id: any) => {
    const selectedState = stateTo?.data?.find((data: any) => data?.id == id);
    const stateName = selectedState?.state_name;

    setStateToData(id);
    setStateToName(stateName);
    setLgaToData('');
    setLgaTo([]);

    if (!shipmentData?.CubicWeight) {
      toast.info('Please enter weight first to see available LGAs');
      return;
    }

    loadLgasForState(id, stateName, 'to');
  }, [stateTo, shipmentData?.CubicWeight, loadLgasForState]);


  React.useEffect(() => {
    if (shipmentData?.CubicWeight && stateFromName && stateFromData) {
      const weightNum = parseFloat(shipmentData.CubicWeight);
      if ((weightNum >= 20 && lgaFrom.length > 0) || (weightNum < 20 && lgaFrom.length > 0)) {
        loadLgasForState(stateFromData, stateFromName, 'from');
      }
    }
    if (shipmentData?.CubicWeight && stateToName && stateToData) {
      const weightNum = parseFloat(shipmentData.CubicWeight);
      if ((weightNum >= 20 && lgaTo.length > 0) || (weightNum < 20 && lgaTo.length > 0)) {
        loadLgasForState(stateToData, stateToName, 'to');
      }
    }
  }, [shipmentData?.CubicWeight]);

  React.useEffect(() => {
    if (massStatusModal) {
      const now = new Date();
      const offset = now.getTimezoneOffset();
      const localDate = new Date(now.getTime() - offset * 60 * 1000);
      setEventDateTime(localDate.toISOString().slice(0, 16));
    }
  }, [massStatusModal]);

  const statusOptions = STATUSTYPES
    // ?.filter((datas: any) => (datas.EventName !== 'Proof of Delivery' && datas.EventName !== 'Out for Delivery'))
    ?.map((datas: any) => ({
      value: datas.EventName,
      label: datas.EventName,
    }));

  const defaultOptions = [
    { value: 'inReview', label: 'inReview' },
    { value: 'Verified', label: 'Verified' },
  ];

  const allOptions = [
    { value: 'All', label: 'All' },
    { value: shipmentId?.Status, label: shipmentId?.Status },
    ...defaultOptions,
    ...statusOptions,
  ];

  const handleChange = (selectedOption: any) => {
    setShipmentStatus(selectedOption?.value);
  };

  const handleSearchChange = (selectedOption: any) => {
    const val = selectedOption?.value;
    setSearchText(!val || val === 'All' ? '' : val);
  };

  const [totalCost, setTotalCost] = React.useState<any>('');

  // Updated: Calculate rate using new structure
  const calculateShipmentRate = React.useCallback(() => {
    if (!shipmentData?.CubicWeight || !stateToData) {
      return;
    }

    const cubicWeight = shipmentData?.CubicL && shipmentData?.CubicW && shipmentData?.CubicH
      ? (parseFloat(shipmentData.CubicL) * parseFloat(shipmentData.CubicW) * parseFloat(shipmentData.CubicH)) / 5000
      : 0;

    // Booking for a credit customer prices off that customer's contract rate
    // card, not the generic cash rates.
    if (isCreditCustomer) {
      const creditRateData: any = {
        client_id: onBehalfCustomer?.email,
        shipment_rate_type: shipmentRateType,
        state_from: stateFromData || null,
        state_to: stateToData,
        lga_from: lgaFromData || 'empty',
        lga_to: lgaToData || 'empty',
        weight: parseFloat(shipmentData.CubicWeight),
      };

      if (shipmentRateType !== 'special' && cubicWeight > 0) {
        creditRateData.weight = Math.max(parseFloat(shipmentData.CubicWeight), cubicWeight);
      }

      if (shipmentRateType === 'special') {
        if (!specialUnitType) return; // Can't price a special rate without the unit
        creditRateData.special_unit_type = specialUnitType;
        creditRateData.quantity = Number(specialQuantity) || 1;
      }

      UserApis.calculateCreditCustomerRate(creditRateData)
        .then((response: any) => {
          if (response?.data?.status) {
            setTotalCostData(response?.data?.data);
            setTotalCost(response?.data?.data?.total_cost);
          } else {
            toast.warn(response?.response?.data?.message || 'Rate calculation failed');
          }
        })
        .catch((err: any) => {
          console.error('Rate calculation error:', err);
        });
      return;
    }

    // Food is priced by destination and commodity, so it skips the country/state
    // payload entirely. Quiet until both are chosen — a half-filled selection is
    // not a failed quote, it is an unfinished one.
    if (serviceType === 'food') {
      if (!foodDestination || !foodCommodity) {
        setTotalCostData(null);
        setTotalCost(0);
        return;
      }

      UserApis.calculateNewShipmentRate({
        service_type: 'food',
        destination_key: foodDestination,
        commodity: foodCommodity,
        weight: parseFloat(shipmentData.CubicWeight),
        client_email: onBehalfCustomer?.email || undefined,
      })
        .then((response: any) => {
          if (response?.data?.status) {
            setTotalCostData(response?.data?.data);
            setTotalCost(response?.data?.data?.total_cost);
          } else {
            // "We don't ship cosmetics to the UK" is the message staff should read
            // out to the customer, so it is surfaced rather than swallowed.
            setTotalCostData(null);
            setTotalCost(0);
            toast.warn(response?.response?.data?.message || response?.data?.message || 'Rate calculation failed');
          }
        })
        .catch((err: any) => {
          setTotalCostData(null);
          setTotalCost(0);
          toast.warn(err?.response?.data?.message || 'Rate calculation failed');
        });
      return;
    }

    // An export is quoted on destination country and weight alone. Sending a Nigerian
    // state with it is at best ignored and at worst misleading, so it is left out.
    const rateData = {
      country_from: 1, // Always Nigeria
      country_to: countryToData,
      state_from: isExport ? null : (stateFromData || null),
      state_to: isExport ? null : stateToData,
      lga_from: isExport ? 'empty' : (lgaFromData || 'empty'),
      lga_to: isExport ? 'empty' : (lgaToData || 'empty'),
      weight: parseFloat(shipmentData.CubicWeight),
      cubic_weight: cubicWeight > 0 ? cubicWeight : null,
      service_type: serviceType
    };

    UserApis.calculateNewShipmentRate(rateData)
      .then((response: any) => {
        if (response?.data?.status) {
          setTotalCostData(response?.data?.data);
          setTotalCost(response?.data?.data?.total_cost);
        } else {
          toast.warn(response?.response?.data?.message || 'Rate calculation failed');
        }
      })
      .catch((err: any) => {
        console.error('Rate calculation error:', err);
      });
  }, [shipmentData?.CubicWeight, shipmentData?.CubicL, shipmentData?.CubicW, shipmentData?.CubicH,
    countryToData, stateFromData, stateToData, lgaFromData, lgaToData, serviceType,
    isCreditCustomer, onBehalfCustomer, shipmentRateType, specialUnitType, specialQuantity,
    foodDestination, foodCommodity]);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      calculateShipmentRate();
    }, 500);
    return () => clearTimeout(timer);
  }, [calculateShipmentRate]);

  // Updated: Submit form with new structure
  const schedule = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (isCreditCustomer && shipmentRateType === 'special' && !specialUnitType) {
      toast.warn('Select a unit type (Carton or Keg) for the special rate');
      return;
    }

    setLoader2(true);
    const cubicWeight = (shipmentData?.CubicL * shipmentData?.CubicW * shipmentData?.CubicH) / 5000;
    const formData = new FormData()

    // Booking on a customer's behalf — the backend re-resolves this account and
    // attributes the shipment, invoice and rate card to it.
    if (onBehalfCustomer?.email) {
      formData.append('on_behalf_of_email', onBehalfCustomer.email)

      if (isCreditCustomer) {
        formData.append('shipment_rate_type', shipmentRateType)
        if (shipmentRateType === 'special') {
          formData.append('special_unit_type', specialUnitType)
          formData.append('quantity', String(Number(specialQuantity) || 1))
        }
      }
    }

    // Sender Information
    formData.append('SenderName', shipmentData?.SenderName)
    formData.append('SenderEmail', shipmentData?.SenderEmail)
    formData.append('SenderCountryCode', '+234') // Always Nigeria
    formData.append('SenderAdd1', shipmentData?.SenderAdd1)
    formData.append('SenderAddCity', shipmentData?.SenderAddCity)

    // Get state name from ZoneState
    stateFrom?.data?.filter((data: any) => data?.id == stateFromData)?.map((d: any) => {
      return formData.append('SenderAddState', d?.state_name)
    })

    formData.append('SenderAddPostcode', shipmentData?.SenderAddPostcode)
    formData.append('SenderTaxID', shipmentData?.SenderTaxID)
    formData.append('SenderPhone', shipmentData?.SenderPhone)
    formData.append('SenderCompanyName', 'null')

    // LGA handling
    lgaFromData !== '' ? (
      lgaFrom?.data?.filter((data: any) => data?.id == lgaFromData)?.map((d: any) => {
        return formData.append('senderLga', d?.lga_name)
      })
    ) : formData.append('senderLga', 'empty')

    lgaToData !== '' ? (
      lgaTo?.data?.filter((data: any) => data?.id == lgaToData)?.map((d: any) => {
        return formData.append('recieverLga', d?.lga_name)
      })
    ) : formData.append('recieverLga', 'empty')

    // Service type and location data
    formData.append('service_type', serviceType);

    // Food is priced from these two rather than from zone/state, so the backend needs
    // them to bill the same figure the quote showed.
    if (serviceType === 'food') {
      formData.append('destination_key', foodDestination);
      formData.append('commodity', foodCommodity);
    }
    formData.append('country_from', '1') // Always Nigeria
    formData.append('country_to', countryToData)
    // Nothing Nigerian goes out with an international shipment. The backend prices
    // exports from the destination country and no longer asks for a state.
    if (!isExport) {
      formData.append('state_from', stateFromData || 'Lagos')
      formData.append('state_to', stateToData !== '' ? stateToData : 'Lagos')
      formData.append('lga_from', lgaFromData ? lgaFromData : 'empty')
      formData.append('lga_to', lgaToData ? lgaToData : 'empty')
    }

    // Receiver Info
    formData.append('ReceiverName', shipmentData?.ReceiverName)
    formData.append('ReceiverEmail', shipmentData?.ReceiverEmail)
    formData.append('ReceiverCountryCode', '+234') // Default Nigeria
    formData.append('ReceiverAdd1', shipmentData?.ReceiverAdd1)
    formData.append('ReceiverAddCity', shipmentData?.ReceiverAddCity)

    // Get receiver state name from ZoneState.
    //
    // Skipped entirely on an export: the receiver is not in a Nigerian state, and
    // stamping one on the record would put the parcel in the wrong manifest and the
    // wrong destination-branch column later on. The address, city and country carry
    // the destination instead.
    if (!isExport) {
      stateTo?.data?.length > 0 ? stateTo?.data?.filter((data: any) => data?.id == stateToData)?.map((d: any) => {
        return formData.append('ReceiverAddState', d?.state_name)
      }) : formData.append('ReceiverAddState', 'empty')
    }

    formData.append('ReceiverAddPostcode', shipmentData?.ReceiverAddPostcode)
    formData.append('ReceiverTaxID', shipmentData?.ReceiverTaxID)
    formData.append('ReceiverPhone', shipmentData?.ReceiverPhone)
    formData.append('ReceiverCompanyName', 'null')

    // Shipment Info
    formData.append('ServiceTypeName', shipmentData?.ServiceTypeName)
    formData.append('NoOfItems', shipmentData?.NoOfItems)
    formData.append('BookPickUP', shipmentData?.BookPickUP)
    formData.append('HarmonisedCode', shipmentData?.HarmonisedCode)
    formData.append('CubicL', shipmentData?.CubicL)
    formData.append('CubicW', shipmentData?.CubicW)
    formData.append('CubicH', shipmentData?.CubicH)
    formData.append('CubicWeight', (shipmentData?.CubicL * shipmentData?.CubicW * shipmentData?.CubicH)?.toString())
    formData.append('Weight', shipmentData?.CubicWeight)
    formData.append('WeightMeasurement', 'KG')
    formData.append('DeadWeight', cubicWeight.toString());
    formData.append('CustomValue', shipmentData?.CustomValue)
    formData.append('CustomCurrencyCode', shipmentData?.CustomCurrencyCode)
    formData.append('CODAmount', shipmentData?.CODAmount)
    formData.append('CODCurrencyCode', shipmentData?.CODCurrencyCode)
    formData.append('GoodsDescription', shipmentData?.GoodsDescription)
    formData.append('ShipmentTerm', shipmentData?.ShipmentTerm)
    formData.append('Incoterms', shipmentData?.Incoterms)
    formData.append('BusinessType', shipmentData?.BusinessType)
    formData.append('SenderRef1', shipmentData?.SenderRef1)
    formData.append('SenderRef2', shipmentData?.SenderRef2)
    formData.append('GoodsOriginCountryCode', shipmentData?.GoodsOriginCountryCode)
    formData.append('ReasonExport', shipmentData?.ReasonExport)
    formData.append('DeliveryInstructions', shipmentData?.DeliveryInstructions ? shipmentData?.DeliveryInstructions : 'empty')
    formData.append('Notes', shipmentData?.Notes)
    formData.append('CPCCode', shipmentData?.CPCCode)
    formData.append('SKUNumber', shipmentData?.SKUNumber)
    formData.append('ATENumber', shipmentData?.ATENumber)
    formData.append('ProductURL', shipmentData?.ProductURL)
    formData.append('GoodsValue', shipmentData?.GoodsValue)
    formData.append('GoodsCurrencyCode', shipmentData?.GoodsCurrencyCode)
    formData.append('DutyValue', shipmentData?.DutyValue)
    formData.append('DutyCurrencyCode', shipmentData?.DutyCurrencyCode)
    formData.append('EORINumber', shipmentData?.EORINumber)
    formData.append('FreightCost', totalCost)
    formData.append('FreightCostCurrencyCode', shipmentData?.FreightCostCurrencyCode)
    formData.append('TotalGSTAmount', shipmentData?.TotalGSTAmount)
    formData.append('TotalGSTCurrencyCode', shipmentData?.TotalGSTCurrencyCode)
    formData.append('CODAmount', shipmentData?.CODAmount)
    formData.append('origin_state', userLoginData?.data?.office)

    UserApis.createShipment(formData)
      .then((response: any) => {
        if (response?.data) {
          if (response?.data?.success) {
            setLoader2(false);
            toast.success(response?.data?.message);
            window.location.reload()
          }
        }
      }).catch((err: any) => {
        setLoader2(false);
        console.log(err);
      }).finally(() => {
        setLoader2(false);
      })
  }, [shipmentData, loader2, totalCost, loader, countryToData, stateFromData, stateToData, lgaFromData, lgaToData, serviceType, stateFrom, stateTo,
    onBehalfCustomer, isCreditCustomer, shipmentRateType, specialUnitType]);

  const [shipType, setShipType] = React.useState<any>('out_bound');
  const [fromDate, setFromDate] = React.useState('');
  const [toDate, setToDate] = React.useState('');
  const [FilterBranch, setFilterBranch] = React.useState('');
  const [userEmail, setUserEmail] = React.useState('');

  const handleExportChange = (selectedOption: any) => {
    setExportText(selectedOption ? selectedOption?.value : '');
  };
  const [exportText, setExportText] = React.useState('');

  const handleExport = (data: any) => {
    exportToExcel(data);
  };

  const uploadImg1 = async (e: any) => {
    if (!e.target.files || !e.target.files[0]) {
      toast.error('No file selected');
      return;
    }

    const file = e.target.files[0];

    // Validate extension early so we don't read junk
    const validExtensions = ['xlsx', 'xls', 'csv'];
    const ext = file.name.split('.').pop()?.toLowerCase();
    if (!ext || !validExtensions.includes(ext)) {
      toast.error('Invalid file format. Please upload .xlsx, .xls or .csv');
      e.target.value = '';
      return;
    }

    // Reset input immediately so the same file can be re-selected after a failure
    const inputEl = e.target;

    try {
      const arrayBuffer = await file.arrayBuffer();
      const workbook = XLSX.read(arrayBuffer, { type: 'array', cellDates: true });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // header: 1 returns array-of-arrays; raw: false converts dates/numbers to display strings
      const rows: any[][] = XLSX.utils.sheet_to_json(worksheet, {
        header: 1,
        defval: '',
        raw: false,
      });

      if (!rows || rows.length < 2) {
        toast.error('File appears empty or has no data rows');
        inputEl.value = '';
        return;
      }

      const header: string[] = rows[0].map((h: any) => String(h).trim());

      // Drop blank rows
      const dataRows = rows.slice(1).filter(row =>
        row.some((cell: any) => cell !== null && cell !== undefined && String(cell).trim() !== '')
      );

      if (dataRows.length === 0) {
        toast.error('No data rows found in file');
        inputEl.value = '';
        return;
      }

      // Build batches
      const batches: any[][][] = [];
      for (let i = 0; i < dataRows.length; i += BATCH_SIZE) {
        batches.push(dataRows.slice(i, i + BATCH_SIZE));
      }

      setUploadProgress({
        show: true,
        total: dataRows.length,
        processed: 0,
        successful: 0,
        skipped: 0,
        failed: 0,
        currentBatch: 0,
        totalBatches: batches.length,
        failedBatches: [],
        failedRows: [],
        header,
        done: false,
      });

      setLoader(false);

      let totalSuccessful = 0;
      let totalSkipped = 0;
      let totalFailed = 0;
      const failedBatchIndexes: number[] = [];

      for (let batchIndex = 0; batchIndex < batches.length; batchIndex++) {
        const batch = batches[batchIndex];

        try {
          const response: any = await SuperAdminApis.uploadImportExcelBatch({
            header,
            rows: batch,
            batch_number: batchIndex + 1,
            total_batches: batches.length,
          });

          if (response?.data?.status) {
            const created = response?.data?.data?.created ?? batch.length;
            const skipped = response?.data?.data?.skipped ?? 0;
            const batchErrors = response?.data?.data?.errors ?? [];

            totalSuccessful += created;
            totalSkipped += skipped;

            // Capture per-row errors returned by backend
            batchErrors.forEach((err: any) => {
              accumulatedFailedRows.push({
                row: err.row_data || [],
                reason: err.error || 'Unknown error',
                batchNumber: batchIndex + 1,
              });
              totalFailed += 1;
            });

            // Account for any rows neither created, skipped, nor in the error list
            const accountedFor = created + skipped + batchErrors.length;
            if (accountedFor < batch.length) {
              const unaccounted = batch.length - accountedFor;
              for (let i = accountedFor - batchErrors.length; i < batch.length - batchErrors.length; i++) {
                accumulatedFailedRows.push({
                  row: batch[i] || [],
                  reason: 'Row not processed (unknown reason)',
                  batchNumber: batchIndex + 1,
                });
              }
              totalFailed += unaccounted;
            }
          } else {
            // Whole batch failed at the API level — mark every row in this batch as failed
            batch.forEach(row => {
              accumulatedFailedRows.push({
                row,
                reason: response?.data?.message || 'Batch rejected by server',
                batchNumber: batchIndex + 1,
              });
            });
            totalFailed += batch.length;
            failedBatchIndexes.push(batchIndex + 1);
          }
        } catch (err: any) {
          console.error(`Batch ${batchIndex + 1} failed:`, err);
          const reason = err?.response?.data?.message || err?.message || 'Network/server error';
          batch.forEach(row => {
            accumulatedFailedRows.push({
              row,
              reason,
              batchNumber: batchIndex + 1,
            });
          });
          totalFailed += batch.length;
          failedBatchIndexes.push(batchIndex + 1);
        }

        const processed = Math.min((batchIndex + 1) * BATCH_SIZE, dataRows.length);
        setUploadProgress(prev => ({
          ...prev,
          processed,
          successful: totalSuccessful,
          skipped: totalSkipped,
          failed: totalFailed,
          currentBatch: batchIndex + 1,
          failedBatches: [...failedBatchIndexes],
          failedRows: [...accumulatedFailedRows],
        }));

        if (batchIndex < batches.length - 1) {
          await sleep(BATCH_DELAY_MS);
        }
      }

      // Final summary toast
      if (totalFailed === 0) {
        toast.success(`Uploaded ${totalSuccessful} shipment(s) successfully${totalSkipped ? `, ${totalSkipped} skipped (duplicates)` : ''}.`);
      } else if (totalSuccessful > 0) {
        toast.warn(`Uploaded ${totalSuccessful}, ${totalSkipped} skipped, ${totalFailed} failed.`);
      } else {
        toast.error(`Upload failed. ${totalFailed} row(s) could not be processed.`);
      }

      setUploadProgress(prev => ({ ...prev, done: true }));

      // Auto-close only when there's nothing failed to recover
      if (totalFailed === 0) {
        setTimeout(() => {
          setUploadProgress(prev => ({ ...prev, show: false }));
          window.location.reload();
        }, 2500);
      }
      // If there ARE failures, leave the modal open so the user can download the failed rows

    } catch (error: any) {
      console.error('Upload error:', error);
      toast.error(`Failed to process file: ${error?.message || 'Unknown error'}`);
      setUploadProgress(prev => ({ ...prev, show: false }));
      setLoader(true);
    } finally {
      inputEl.value = '';
    }
  };

  const ShipmentUploadSection = () => (
    <div className="flex flex-col gap-3">
      <div className="flex gap-2">
        <div className="flex gap-1">
          <button
            onClick={() => downloadTemplate('excel')}
            type='button'
            disabled={loader}
            className='bg-green-600 hover:bg-green-700 rounded-[12px] p-[8px] text-white text-[12px] font-medium flex items-center gap-1'
          >
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
            Download Excel Template
          </button>

          <button
            onClick={() => downloadTemplate('csv')}
            type='button'
            disabled={loader}
            className='bg-blue-600 hover:bg-blue-700 rounded-[12px] p-[8px] text-white text-[12px] font-medium flex items-center gap-1'
          >
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
            Download CSV Template
          </button>
        </div>

        <button
          onClick={() => setTemplateInfoModal(true)}
          type='button'
          className='bg-gray-600 hover:bg-gray-700 rounded-[12px] p-[8px] text-white text-[12px] font-medium flex items-center gap-1'
        >
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
          </svg>
          Template Guide
        </button>
      </div>

      <div className='mt-0.5'>
        <label className="flex flex-col items-center justify-center w-full rounded-[5px] cursor-pointer">
          <span className={"bg-[#E04343] rounded-[12px] p-[8px] text-white text-[12px] font-medium"}>
            Upload Shipment Excel File
          </span>
          <input
            id="dropzone-file"
            accept=".xlsx,.csv,.xls"
            onChange={uploadImg1}
            placeholder="upload shipment file"
            name='uploadImg1'
            type="file"
            className={"hidden mb-2 text-sm text-[#6C757D] font-medium"}
          />
        </label>
      </div>
    </div>
  );

  // Which business the report covers. Credit customers are billed through
  // CFLEX, so their shipments have to be separable from the walk-in business.
  const [reportScope, setReportScope] = React.useState<'all' | 'in_house' | 'credit' | 'credit_customer'>('all');
  const [reportCustomer, setReportCustomer] = React.useState<string>('');
  const [reportPreview, setReportPreview] = React.useState<any>(null);
  const [reportBusy, setReportBusy] = React.useState(false);

  // The credit-customer picker reuses the list the page already loads for
  // "Create on behalf of customer" — same people, no second request.

  const reportQuery = React.useCallback(() => ({
    scope: reportScope,
    credit_customer: reportScope === 'credit_customer' ? reportCustomer : undefined,
    date_from: fromDate,
    date_to: toDate,
    destination_state: FilterBranch,
    shipment_status: exportText,
    email: userEmail,
  }), [reportScope, reportCustomer, fromDate, toDate, FilterBranch, exportText, userEmail]);

  /** How many rows before anyone waits for a file. */
  const previewReport = React.useCallback(() => {
    setReportBusy(true);
    setReportPreview(null);

    SuperAdminApis.shipmentReportPreview(reportQuery())
      .then((res: any) => {
        if (res?.data?.status) setReportPreview(res.data.data);
        else toast.error(res?.data?.message || 'Could not count the shipments');
      })
      .catch((e: any) => toast.error(e?.response?.data?.message || 'Could not count the shipments'))
      .finally(() => setReportBusy(false));
  }, [reportQuery]);

  /**
   * Download the report.
   *
   * The server STREAMS a CSV, so the file is taken as a blob and saved. The old
   * version asked for every matching row as JSON and built the spreadsheet in
   * the browser, which could not survive a month of shipments — the request died
   * on the platform's time limit and the button appeared to do nothing.
   */
  const generateReport = React.useCallback(
    (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();

      if (reportScope === 'credit_customer' && !reportCustomer) {
        toast.warn('Choose which credit customer the report is for.');
        return;
      }

      setReportBusy(true);
      toast.info('Building the report. Large periods can take a minute.', { autoClose: 8000 });

      SuperAdminApis.shipmentReportExport(reportQuery())
        .then((response: any) => {
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv' }));
          const link = document.createElement('a');
          link.href = url;

          // Named for what it contains, so a folder of these stays readable.
          const label = reportScope === 'credit_customer' ? reportCustomer.replace(/[^a-z0-9]+/gi, '-') : reportScope;
          link.setAttribute('download', `shipment-report-${label}-${fromDate || 'all'}-to-${toDate || 'all'}.csv`);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);

          setExportModal(false);
          setReportPreview(null);
        })
        .catch(() => toast.error('Could not build the report. Try a shorter date range.'))
        .finally(() => setReportBusy(false));
    }, [reportScope, reportCustomer, reportQuery, fromDate, toDate]);

  // Load states when component mounts
  React.useEffect(() => {
    getStateFrom(1); // Load origin states
    getStateTo(1); // Load destination states
  }, []);



  return (
    <>
      <AdminSidebar title="Shipment" />
      <div className="relative md:ml-64 bg-[#FAFAFA] ">
        <AdminNavbar title="Shipments" />

        <div className={showScreen === 1 ? "block " : "hidden"}>
          <div className=' lg:px-10 pb-6 px-6 pt-5 bg-[#FAFAFA] min-h-screen'>

            {
              userLoginData?.data?.role == 'fleet' ?
                ''
                :
                <div className='grid lg:grid-cols-4 grid-cols-1 lg:divide-x-2 lg:divide-dotted lg:space-y-0 space-y-5'>
                  <div className='bg-white rounded-[8px] pl-[26px] pt-[17px] pb-[18px] '>
                    <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="17.5" cy="17.5" r="17.25" fill="black" stroke="white" stroke-width="0.5" />
                      <path d="M26.88 11.3665L18.63 6.84966C18.4371 6.74313 18.2204 6.68726 18 6.68726C17.7796 6.68726 17.5629 6.74313 17.37 6.84966L9.12 11.3665C8.91357 11.4795 8.7413 11.6459 8.62123 11.8482C8.50115 12.0506 8.4377 12.2815 8.4375 12.5169V21.4831C8.4377 21.7184 8.50115 21.9493 8.62123 22.1517C8.7413 22.3541 8.91357 22.5205 9.12 22.6334L17.37 27.1503C17.5629 27.2566 17.7797 27.3124 18 27.3124C18.2203 27.3124 18.4371 27.2566 18.63 27.1503L26.88 22.6334C27.0864 22.5205 27.2587 22.3541 27.3788 22.1517C27.4988 21.9493 27.5623 21.7184 27.5625 21.4831V12.5169C27.5623 12.2815 27.4988 12.0506 27.3788 11.8482C27.2587 11.6459 27.0864 11.4795 26.88 11.3665ZM17.9062 7.83591C17.9338 7.82082 17.9648 7.8129 17.9963 7.8129C18.0277 7.8129 18.0587 7.82082 18.0863 7.83591L25.9228 12.125L22.7409 13.8659L14.8172 9.52904L17.9062 7.83591ZM17.4375 25.9062L9.65625 21.6472C9.6275 21.6306 9.60367 21.6066 9.5872 21.5778C9.57073 21.549 9.5622 21.5163 9.5625 21.4831V13.1244L17.4375 17.4369V25.9062ZM10.0772 12.125L13.6462 10.1703L21.5691 14.5072L18 16.46L10.0772 12.125ZM26.4375 21.4831C26.4378 21.5163 26.4293 21.549 26.4128 21.5778C26.3963 21.6066 26.3725 21.6306 26.3438 21.6472L18.5625 25.9062V17.435L21.9375 15.5872V19.25C21.9375 19.3992 21.9968 19.5422 22.1023 19.6477C22.2077 19.7532 22.3508 19.8125 22.5 19.8125C22.6492 19.8125 22.7923 19.7532 22.8977 19.6477C23.0032 19.5422 23.0625 19.3992 23.0625 19.25V14.9722L26.4375 13.1244V21.4831Z" fill="white" />
                    </svg>
                    <h1 className='mt-5 text-[20px] font-bold text-[#1C1C1C]'>{total}</h1>
                    <h3 className='mt-1 text-[12px] text-[#808080]'>Total</h3>
                  </div>
                  <div className='bg-white rounded-[8px] pl-[26px] pt-[17px] pb-[18px]'>
                    <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="17.5" cy="17.5" r="17.25" fill="#DBFFE5" stroke="#149E49" stroke-width="0.5" />
                      <path d="M26.88 11.3665L18.63 6.84966C18.4371 6.74313 18.2204 6.68726 18 6.68726C17.7796 6.68726 17.5629 6.74313 17.37 6.84966L9.12 11.3665C8.91357 11.4795 8.7413 11.6459 8.62123 11.8482C8.50115 12.0506 8.4377 12.2815 8.4375 12.5169V21.4831C8.4377 21.7184 8.50115 21.9493 8.62123 22.1517C8.7413 22.3541 8.91357 22.5205 9.12 22.6334L17.37 27.1503C17.5629 27.2566 17.7797 27.3124 18 27.3124C18.2203 27.3124 18.4371 27.2566 18.63 27.1503L26.88 22.6334C27.0864 22.5205 27.2587 22.3541 27.3788 22.1517C27.4988 21.9493 27.5623 21.7184 27.5625 21.4831V12.5169C27.5623 12.2815 27.4988 12.0506 27.3788 11.8482C27.2587 11.6459 27.0864 11.4795 26.88 11.3665ZM17.9062 7.83591C17.9338 7.82082 17.9648 7.8129 17.9963 7.8129C18.0277 7.8129 18.0587 7.82082 18.0863 7.83591L25.9228 12.125L22.7409 13.8659L14.8172 9.52904L17.9062 7.83591ZM17.4375 25.9062L9.65625 21.6472C9.6275 21.6306 9.60367 21.6066 9.5872 21.5778C9.57073 21.549 9.5622 21.5163 9.5625 21.4831V13.1244L17.4375 17.4369V25.9062ZM10.0772 12.125L13.6462 10.1703L21.5691 14.5072L18 16.46L10.0772 12.125ZM26.4375 21.4831C26.4378 21.5163 26.4293 21.549 26.4128 21.5778C26.3963 21.6066 26.3725 21.6306 26.3438 21.6472L18.5625 25.9062V17.435L21.9375 15.5872V19.25C21.9375 19.3992 21.9968 19.5422 22.1023 19.6477C22.2077 19.7532 22.3508 19.8125 22.5 19.8125C22.6492 19.8125 22.7923 19.7532 22.8977 19.6477C23.0032 19.5422 23.0625 19.3992 23.0625 19.25V14.9722L26.4375 13.1244V21.4831Z" fill="#149E49" />
                    </svg>

                    <h1 className='mt-5 text-[20px] font-bold text-[#1C1C1C]'>{total}</h1>
                    <h3 className='mt-1 text-[12px] text-[#808080]'>Successful</h3>
                  </div>

                  <div className='bg-white rounded-[8px] pl-[26px] pt-[17px] pb-[18px]'>
                    <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="17.5" cy="17.5" r="17.25" fill="#FFF0D7" stroke="#F59E0B" stroke-width="0.5" />
                      <path d="M26.88 11.3665L18.63 6.84966C18.4371 6.74313 18.2204 6.68726 18 6.68726C17.7796 6.68726 17.5629 6.74313 17.37 6.84966L9.12 11.3665C8.91357 11.4795 8.7413 11.6459 8.62123 11.8482C8.50115 12.0506 8.4377 12.2815 8.4375 12.5169V21.4831C8.4377 21.7184 8.50115 21.9493 8.62123 22.1517C8.7413 22.3541 8.91357 22.5205 9.12 22.6334L17.37 27.1503C17.5629 27.2566 17.7797 27.3124 18 27.3124C18.2203 27.3124 18.4371 27.2566 18.63 27.1503L26.88 22.6334C27.0864 22.5205 27.2587 22.3541 27.3788 22.1517C27.4988 21.9493 27.5623 21.7184 27.5625 21.4831V12.5169C27.5623 12.2815 27.4988 12.0506 27.3788 11.8482C27.2587 11.6459 27.0864 11.4795 26.88 11.3665ZM17.9062 7.83591C17.9338 7.82082 17.9648 7.8129 17.9963 7.8129C18.0277 7.8129 18.0587 7.82082 18.0863 7.83591L25.9228 12.125L22.7409 13.8659L14.8172 9.52904L17.9062 7.83591ZM17.4375 25.9062L9.65625 21.6472C9.6275 21.6306 9.60367 21.6066 9.5872 21.5778C9.57073 21.549 9.5622 21.5163 9.5625 21.4831V13.1244L17.4375 17.4369V25.9062ZM10.0772 12.125L13.6462 10.1703L21.5691 14.5072L18 16.46L10.0772 12.125ZM26.4375 21.4831C26.4378 21.5163 26.4293 21.549 26.4128 21.5778C26.3963 21.6066 26.3725 21.6306 26.3438 21.6472L18.5625 25.9062V17.435L21.9375 15.5872V19.25C21.9375 19.3992 21.9968 19.5422 22.1023 19.6477C22.2077 19.7532 22.3508 19.8125 22.5 19.8125C22.6492 19.8125 22.7923 19.7532 22.8977 19.6477C23.0032 19.5422 23.0625 19.3992 23.0625 19.25V14.9722L26.4375 13.1244V21.4831Z" fill="#F59E0B" />
                    </svg>

                    <h1 className='mt-5 text-[20px] font-bold text-[#1C1C1C]'>{pending}</h1>
                    <h3 className='mt-1 text-[12px] text-[#808080]'>In Review</h3>
                  </div>

                  <div className='bg-white rounded-[8px] pl-[26px] pt-[17px] pb-[18px]'>
                    <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="17.5" cy="17.5" r="17.25" fill="#FFEAEF" stroke="#EE1D52" stroke-width="0.5" />
                      <path d="M26.88 11.3665L18.63 6.84966C18.4371 6.74313 18.2204 6.68726 18 6.68726C17.7796 6.68726 17.5629 6.74313 17.37 6.84966L9.12 11.3665C8.91357 11.4795 8.7413 11.6459 8.62123 11.8482C8.50115 12.0506 8.4377 12.2815 8.4375 12.5169V21.4831C8.4377 21.7184 8.50115 21.9493 8.62123 22.1517C8.7413 22.3541 8.91357 22.5205 9.12 22.6334L17.37 27.1503C17.5629 27.2566 17.7797 27.3124 18 27.3124C18.2203 27.3124 18.4371 27.2566 18.63 27.1503L26.88 22.6334C27.0864 22.5205 27.2587 22.3541 27.3788 22.1517C27.4988 21.9493 27.5623 21.7184 27.5625 21.4831V12.5169C27.5623 12.2815 27.4988 12.0506 27.3788 11.8482C27.2587 11.6459 27.0864 11.4795 26.88 11.3665ZM17.9062 7.83591C17.9338 7.82082 17.9648 7.8129 17.9963 7.8129C18.0277 7.8129 18.0587 7.82082 18.0863 7.83591L25.9228 12.125L22.7409 13.8659L14.8172 9.52904L17.9062 7.83591ZM17.4375 25.9062L9.65625 21.6472C9.6275 21.6306 9.60367 21.6066 9.5872 21.5778C9.57073 21.549 9.5622 21.5163 9.5625 21.4831V13.1244L17.4375 17.4369V25.9062ZM10.0772 12.125L13.6462 10.1703L21.5691 14.5072L18 16.46L10.0772 12.125ZM26.4375 21.4831C26.4378 21.5163 26.4293 21.549 26.4128 21.5778C26.3963 21.6066 26.3725 21.6306 26.3438 21.6472L18.5625 25.9062V17.435L21.9375 15.5872V19.25C21.9375 19.3992 21.9968 19.5422 22.1023 19.6477C22.2077 19.7532 22.3508 19.8125 22.5 19.8125C22.6492 19.8125 22.7923 19.7532 22.8977 19.6477C23.0032 19.5422 23.0625 19.3992 23.0625 19.25V14.9722L26.4375 13.1244V21.4831Z" fill="#EE1D52" />
                    </svg>

                    <h1 className='mt-5 text-[20px] font-bold text-[#1C1C1C]'>{others}</h1>
                    <h3 className='mt-1 text-[12px] text-[#808080]'>Failed</h3>
                  </div>

                </div>
            }


            {
              userLoginData?.data?.role == 'fleet' ?
                ''
                :
                <div className="flex justify-end gap-2 mt-5">
                  {/* Template Download Section */}
                  <div className="flex flex-col gap-2">
                    <div className="flex gap-1">
                      {/* <button
                        onClick={() => downloadTemplate('excel')}
                        type='button'
                        disabled={loader}
                        className='bg-green-600 hover:bg-green-700 rounded-[12px] p-[8px] text-white text-[12px] font-medium flex items-center gap-1'
                      >
                        <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                        Excel Template
                      </button>

                      <button
                        onClick={() => downloadTemplate('csv')}
                        type='button'
                        disabled={loader}
                        className='bg-blue-600 hover:bg-blue-700 rounded-[12px] p-[8px] text-white text-[12px] font-medium flex items-center gap-1'
                      >
                        <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                        CSV Template
                      </button> */}

                      <button
                        onClick={() => setTemplateInfoModal(true)}
                        type='button'
                        className='bg-purple-600 hover:bg-purple-700 rounded-[12px] p-[8px] text-white text-[12px] font-medium flex items-center gap-1'
                      >
                        <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                        </svg>
                        Guide
                      </button>
                    </div>
                  </div>

                  {/* Upload Excel File */}
                  <div className='mt-0.5 ml-2'>
                    <label className="flex flex-col items-center justify-center w-full rounded-[5px] cursor-pointer">
                      <span className={"bg-[#E04343] rounded-[12px] p-[8px] text-white text-[12px] font-medium"}>
                        Upload Import Excel File
                      </span>
                      <input
                        id="dropzone-file"
                        accept=".xlsx,.csv,.xls"
                        onChange={uploadImg1}
                        placeholder="upload brand logo"
                        name='uploadImg1'
                        type="file"
                        className={"hidden mb-2 text-sm text-[#6C757D] font-medium"}
                      />
                    </label>
                  </div>

                  <button
                    onClick={() => { setDocketModal(true); setDocketResult(null); setDocketFile(null); setDocketPairs(null); setDocketParseError(''); }}
                    type='button'
                    className='bg-[#19213D] hover:bg-[#2A3352] rounded-[12px] p-[8px] text-white text-[12px] font-medium'
                    title="Restore docket numbers on shipments already in the system"
                  >
                    Update Docket Numbers
                  </button>

                  {/* Other existing buttons */}
                  <button
                    onClick={() => { setExportModal(true) }}
                    type='button'
                    className='bg-[#E04343] rounded-[12px] p-[8px] text-white text-[12px] font-medium'
                  >
                    Generate Report
                  </button>

                  <button
                    onClick={() => { setMassStatusModal(true) }}
                    type='button'
                    className='bg-[#E04343] rounded-[12px] p-[8px] text-white text-[12px] font-medium'
                  >
                    Mass update
                  </button>

                  <BulkDeliveryPhotos />

                  <button
                    onClick={() => setShowScreen(2)}
                    type='button'
                    className='bg-[#E04343] rounded-[12px] p-[8px] text-white text-[12px] font-medium'
                  >
                    + Create Shipment
                  </button>
                </div>
            }


            <div className={'md:flex ' + ((userLoginData?.data?.role == 'fleet') ? ' justify-end' : ' justify-between') + ' mt-5'}>
              {(userLoginData?.data?.role == 'fleet') ?
                ''
                :
                <div className='flex md:justify-between justify-start gap-2'>
                  <h3 className='text-[15px] text-[#1C1C1C] font-semibold'>All Shipments </h3>

                  <button
                    onClick={() => setShipType('in_bound')}
                    type='button'
                    className={shipType == 'in_bound' ? 'bg-[#E04343] rounded-[12px] p-[4px] border-red-100 text-[12px] text-white' : 'bg-[#ffffff] border-red-500 border rounded-[12px] p-[4px] text-[12px] text-[#E04343]'}
                  >
                    In Bound
                  </button>


                  <button
                    onClick={() => setShipType('out_bound')}
                    type='button'
                    className={shipType == 'out_bound' ? 'bg-[#E04343] rounded-[12px] p-[4px] border-red-100 text-[12px] text-white' : 'bg-[#ffffff] border-red-500 border rounded-[12px] p-[4px] text-[12px] text-[#E04343]'}
                  >
                    Out Bound
                  </button>

                </div>
              }

              <div className='flex  gap-3 md:pt-0 pt-4'>


                {
                  userLoginData?.data?.role == 'fleet' ?
                    <select id="countries" onChange={(e: any) => setSearchText(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full md:w-44 p-1.5">
                      <option selected>Choose a filter</option>
                      <option value="Proof of Delivery">Proof of Delivery</option>
                      <option value="In Transit to Destination">In Transit to Destination</option>
                      <option value="Out for Delivery">Out for Delivery</option>
                      <option value="Attempted Delivery - Inaccurate / Incomplete Address">Attempted Delivery - Inaccurate / Incomplete Address</option>

                    </select>
                    :

                    <div className="flex justify-start gap-2">
                      <select onChange={(e: any) => setViewType(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full md:w-44 p-1.5">
                        <option selected>Choose a filter</option>
                        <option value="">All</option>
                        <option value="in_house">In House Shipments</option>
                        <option value="import">Imported Shipments</option>

                      </select>

                      <Select
                        className='w-[200px]'
                        options={allOptions} // Options for the dropdown
                        defaultValue={allOptions[0]} // Set default selected value
                        onChange={handleSearchChange} // Handle on change
                        classNamePrefix="select" // Add custom class prefix if you need styling
                        isSearchable // Make the dropdown searchable
                        placeholder="Filter by Status..."
                        isClearable
                      />
                    </div>



                }

                <div className="relative ">
                  <div className="absolute inset-y-0 start-0 flex items-center pl-3 pointer-events-none">

                    <svg className="w-4 h-4 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                    </svg>
                  </div>
                  <input type="text" id="simple-search" onChange={(e: any) => setSearchText(e.target.value)} className="bg-white  border border-gray-300 text-gray-900 text-sm rounded-[10px] block md:w-44 w-full pl-10 p-1.5" placeholder="Search here..." required />
                </div>




                <button
                  onClick={paginator}
                  type='button'
                  className={'bg-[#E04343] rounded-[12px] px-[10px] border-red-100 text-[12px] text-white'}
                >
                  Search
                </button>
              </div>
            </div>
            <hr className='mt-3 bg-[#C4C4C44D]' />
            {loader ?
              <div className="relative overflow-x-auto">
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 border-separate border-spacing-y-3">

                  {userLoginData?.data?.role == 'fleet' ?
                    <thead className="text-[12px] text-[#808080] bg-[#FAFAFA] ">
                      <tr>

                        <th scope="col" className="px-2 py-2">
                          S/N
                        </th>
                        <th scope="col" className="px-2 py-2">
                          Reciever&nbsp;Name
                        </th>
                        <th scope="col" className="px-2 py-2">
                          Reciever&nbsp;Phone&nbsp;Number
                        </th>
                        <th scope="col" className="px-2 py-2">
                          Reciever&nbsp;Address
                        </th>
                        <th scope="col" className="px-2 py-2">
                          Status
                        </th>

                        <th scope="col" className="px-2 py-2">
                          Shipment&nbsp;Number
                        </th>

                        {/* <th scope="col" className="px-2 py-2">
                          Fleet
                        </th>

                        <th scope="col" className="px-2 py-2">
                          Vehicle
                        </th> */}

                      </tr>
                    </thead>
                    :
                    <thead className="text-[12px] text-[#808080] bg-[#FAFAFA] ">
                      <tr>

                        <th scope="col" className="px-2 py-2">
                          S/N
                        </th>
                        {/* <th scope="col" className="px-2 py-2">
                    Run&nbsp;ID
                  </th> */}
                        <th scope="col" className="px-2 py-2">
                          Created&nbsp;By
                        </th>
                        <th scope="col" className="px-2 py-2">
                          Created&nbsp;Date
                        </th>
                        <th scope="col" className="px-2 py-2">
                          Shipment&nbsp;ID
                        </th>
                        <th scope="col" className="px-2 py-2">
                          Sender&nbsp;Ref
                        </th>


                        {/* <th scope="col" className="px-2 py-2">
                    Sender&nbsp;Ref2
                  </th> */}
                        <th scope="col" className="px-2 py-2">
                          Serv.
                        </th>

                        <th scope="col" className="px-2 py-2">
                          Recipient
                        </th>
                        {/* <th scope="col" className="px-2 py-2">
                          Sender State
                        </th>
                        <th scope="col" className="px-2 py-2">
                          Reciever State
                        </th> */}

                        {/* <th scope="col" className="px-2 py-2">
                          Fleet
                        </th>

                        <th scope="col" className="px-2 py-2">
                          Vehicle
                        </th> */}
                        <th scope="col" className="px-2 py-2">
                          Request Pickup
                        </th>

                        <th scope="col" className="px-2 py-2">
                          Department
                        </th>
                        <th scope="col" className="px-2 py-2">
                          Shipment Status
                        </th>
                        <th scope="col" className="px-2 py-2">
                          Payment Status
                        </th>
                        <th scope="col" className="px-2 py-2">
                          Action
                        </th>



                      </tr>
                    </thead>
                  }




                  <tbody className=''>

                    {
                      userLoginData?.data?.role == 'fleet' ?
                        shipmentInfo?.[shipType]?.data?.map(
                          (datas: any, index: any) => (
                            <tr className="bg-white  ">

                              <td className="px-2 py-2">
                                {index + 1}
                              </td>
                              <td className="px-6 py-4">
                                {datas?.ReceiverName}
                              </td>
                              <td className="px-6 py-4">
                                {datas?.ReceiverPhone}
                              </td>

                              <td className="px-6 py-4">
                                {datas?.ReceiverAdd1}
                              </td>

                              <td className="px-2 py-2 cursor-pointer" onClick={() => { toggleStatus(datas); setDelieveryInstruction(datas?.DeliveryInstructions); }}>
                                {(datas?.Status == 'inReview' || datas?.Status == 'InReview') ? <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#FFDDBD', color: '#F29339', borderRadius: '10px', padding: '2px 10px' }}>{datas?.Status}</b></p> : <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#C9F0D0', color: '#51CF66', borderRadius: '10px', padding: '2px 10px' }}>{datas?.Status}</b></p>}
                              </td>

                              <td className="px-6 py-4 ">
                                {datas?.ShipmentNumber ? datas?.ShipmentNumber : `Not Available`}
                              </td>

                              <td className="px-6 py-4 cursor-pointer">
                                {datas?.fleet_name ? datas?.fleet_name : "No Fleet"}
                              </td>

                              <td className="px-6 py-4" >
                                {datas?.vehicle_name ? datas?.vehicle_name : "No Vehicle"}
                              </td>

                            </tr>
                          )
                        )
                        :
                        (userLoginData?.data?.role == 'admin' ?
                          shipmentInfo?.[shipType]?.data?.map(
                            (datas: any, index: any) => (
                              <tr className="bg-white  ">

                                <td className="px-2 py-2">
                                  {index + 1}
                                </td>
                                <td className="px-6 py-4">
                                  {datas?.SenderName}
                                </td>
                                <td className="px-6 py-4">
                                  {convertUTCDateToLocalDate(datas?.created_at)}
                                </td>
                                <td className="px-6 py-4 ">
                                  {datas?.ShipmentNumber ? datas?.ShipmentNumber : `Not Available`}
                                </td>
                                <td className="px-6 py-4">
                                  {datas?.SenderRef1}
                                </td>

                                <td className="px-6 py-4">
                                  {datas?.ServiceTypeName}
                                </td>
                                <td className="px-6 py-4">
                                  {datas?.ReceiverName}
                                </td>
                                {/* <td className="px-6 py-4">
                                  {datas?.SenderAddState}
                                </td>
                                <td className="px-6 py-4">
                                  {datas?.ReceiverAddState}
                                </td> */}

                                {/* <td className="px-6 py-4 cursor-pointer" onClick={() => { setRiderModal(true); setShipmentId(datas); setDelieveryInstruction(datas?.DeliveryInstructions); }}>
                                  {datas?.fleet_name ? datas?.fleet_name : "No Fleet"}
                                </td>

                                <td className="px-6 py-4" >
                                  {datas?.vehicle_name ? datas?.vehicle_name : "No Vehicle"}
                                </td> */}

                                <td className="px-6 py-4" >
                                  {datas?.BookPickUP == 'true' ? 'Yes' : "No"}
                                </td>

                                <td className="px-6 py-4 cursor-pointer" onClick={() => { setOfficeModal(true); setShipmentId(datas) }}>
                                  {datas?.office !== '' ? <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#E6BDFF', color: '#B24BF1', borderRadius: '10px', padding: '2px 10px' }}>{(datas?.office)?.replace(/ /g, '_')}</b></p> : ''}

                                </td>
                                <td className="px-2 py-2 cursor-pointer" onClick={() => { toggleStatus(datas); }}>

                                  {(datas?.Status == 'inReview' || datas?.Status == 'InReview') ? <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#FFDDBD', color: '#F29339', borderRadius: '10px', padding: '2px 10px' }}>{datas?.Status}</b></p> : <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#C9F0D0', color: '#51CF66', borderRadius: '10px', padding: '2px 10px' }}>{datas?.Status}</b></p>}

                                </td>

                                <td className="px-2 py-2 " >
                                  {datas?.payment_status == 'successful' ? <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#C9F0D0', color: '#51CF66', borderRadius: '10px', padding: '2px 10px' }}>{datas?.payment_status}</b></p> : ''}
                                  {datas?.payment_status == 'pending' ? <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#FFDDBD', color: '#FF922B', borderRadius: '10px', padding: '2px 10px' }}>{datas?.payment_status}</b></p> : ''}
                                  {datas?.payment_status == 'failed' ? <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#E6BDFF', color: '#B24BF1', borderRadius: '10px', padding: '2px 10px' }}>{datas?.payment_status}</b></p> : ''}
                                  {datas?.payment_status == 'Missed' ? <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#CAD8FA', color: '#4979ED', borderRadius: '10px', padding: '2px 10px' }}>{datas?.payment_status}</b></p> : ''}
                                  {datas?.payment_status == 'Closed' ? <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#CAD8FA', color: '#4979ED', borderRadius: '10px', padding: '2px 10px' }}>{datas?.payment_status}</b></p> : ''}

                                </td>

                                {/* <td className="px-6 py-4 cursor-pointer"> */}


                                <td className="px-6 py-4 cursor-pointer flex justify-between gap-2 mt-4">
                                  {
                                    <NavLink to={`/admin/edit-shipment/${datas?.id}`} className="cursor-pointer">
                                      <FaEye color='#3F83F8' />
                                    </NavLink>
                                  }





                                  {
                                    datas?.ShipmentNumber ?
                                      <a href={datas?.LabelURL} target='_blank'>
                                        <MdDownload size={17} />
                                      </a>

                                      :

                                      <div className="cursor-pointer pl-1" onClick={() => { setDeleteModal(true); setShipmentId(datas) }}>
                                        <MdDelete color='red' />
                                      </div>


                                  }



                                </td>
                                {/* </td> */}
                              </tr>
                            )
                          )
                          :
                          shipmentInfo?.[shipType]?.data?.map(
                            (datas: any, index: any) => (
                              <tr className="bg-white  ">

                                <td className="px-2 py-2">
                                  {index + 1}
                                </td>
                                <td className="px-6 py-4">
                                  {datas?.SenderName}
                                </td>
                                <td className="px-6 py-4">
                                  {convertUTCDateToLocalDate(datas?.created_at)}
                                </td>
                                <td className="px-6 py-4 ">
                                  {datas?.ShipmentNumber ? datas?.ShipmentNumber : `Not Available`}
                                </td>
                                <td className="px-6 py-4">
                                  {datas?.SenderRef1}
                                </td>

                                <td className="px-6 py-4">
                                  {datas?.ServiceTypeName}
                                </td>
                                <td className="px-6 py-4">
                                  {datas?.ReceiverName}
                                </td>
                                {/* <td className="px-6 py-4">
                                  {datas?.SenderAddState}
                                </td>
                                <td className="px-6 py-4">
                                  {datas?.ReceiverAddState}
                                </td> */}

                                {/* <td className="px-6 py-4 cursor-pointer" onClick={() => { setRiderModal(true); setShipmentId(datas); setDelieveryInstruction(datas?.DeliveryInstructions); }}>
                                  {datas?.fleet_name ? datas?.fleet_name : "No Fleet"}
                                </td>

                                <td className="px-6 py-4" >
                                  {datas?.vehicle_name ? datas?.vehicle_name : "No Vehicle"}
                                </td> */}

                                <td className="px-6 py-4" >
                                  {datas?.BookPickUP == 'true' ? 'Yes' : "No"}
                                </td>

                                <td className="px-6 py-4 cursor-pointer" onClick={() => { setOfficeModal(true); setShipmentId(datas) }}>
                                  {datas?.office !== '' ? <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#E6BDFF', color: '#B24BF1', borderRadius: '10px', padding: '2px 10px' }}>{(datas?.office)?.replace(/ /g, '_')}</b></p> : ''}

                                </td>

                                <td className="px-2 py-2 cursor-pointer" onClick={() => { toggleStatus(datas) }}>
                                  {(datas?.Status == 'inReview' || datas?.Status == 'InReview') ? <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#FFDDBD', color: '#F29339', borderRadius: '10px', padding: '2px 10px' }}>{datas?.Status}</b></p> : <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#C9F0D0', color: '#51CF66', borderRadius: '10px', padding: '2px 10px' }}>{datas?.Status}</b></p>}

                                </td>

                                <td className="px-2 py-2 " >
                                  {datas?.payment_status == 'successful' ? <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#C9F0D0', color: '#51CF66', borderRadius: '10px', padding: '2px 10px' }}>{datas?.payment_status}</b></p> : ''}
                                  {datas?.payment_status == 'pending' ? <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#FFDDBD', color: '#FF922B', borderRadius: '10px', padding: '2px 10px' }}>{datas?.payment_status}</b></p> : ''}
                                  {datas?.payment_status == 'failed' ? <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#E6BDFF', color: '#B24BF1', borderRadius: '10px', padding: '2px 10px' }}>{datas?.payment_status}</b></p> : ''}
                                  {datas?.payment_status == 'Missed' ? <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#CAD8FA', color: '#4979ED', borderRadius: '10px', padding: '2px 10px' }}>{datas?.payment_status}</b></p> : ''}
                                  {datas?.payment_status == 'Closed' ? <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#CAD8FA', color: '#4979ED', borderRadius: '10px', padding: '2px 10px' }}>{datas?.payment_status}</b></p> : ''}
                                </td>

                                <td className="px-6 py-4 cursor-pointer flex justify-between gap-2 mt-4">
                                  {
                                    shipType == 'in_bound' ?
                                      ''
                                      :
                                      <NavLink to={`/admin/edit-shipment/${datas?.id}`} className="cursor-pointer">
                                        <FaEye color='#3F83F8' />
                                      </NavLink>
                                  }





                                  {
                                    datas?.ShipmentNumber ?
                                      <a href={datas?.LabelURL} target='_blank'>
                                        <MdDownload size={17} />
                                      </a>

                                      :

                                      (shipType == 'in_bound' ?
                                        ''
                                        :
                                        <div className="cursor-pointer pl-1" onClick={() => { setDeleteModal(true); setShipmentId(datas) }}>
                                          <MdDelete color='red' />
                                        </div>
                                      )

                                  }



                                </td>




                              </tr>
                            )
                          )
                        )

                    }

                  </tbody>

                </table>
              </div>
              :
              <div className='flex justify-center my-3 mt-20 pb-10'>
                <Oval
                  visible={true}
                  height="80"
                  width="80"
                  color="#E04343"
                  secondaryColor="#FF3B300D"
                  ariaLabel="oval-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                />
              </div>
            }

            <div className='m-4 flex justify-end mt-20'>
              {
                shipmentInfo?.[shipType]?.links?.filter(((item: any, idx: any) => idx < 1000)).map(
                  (datas: any, index: any) => (
                    <button onClick={() => paginator(datas?.label == 'Next &raquo;' ? datas?.url?.charAt(datas?.url?.length - 1) : (datas?.label === '&laquo; Previous') ? datas?.url?.charAt(datas?.url?.length - 1) : datas?.label)} disabled={datas?.active} className={'mx-1 py-1 px-2 ' + ((datas?.active == false || datas?.url == null) ? 'bg-gray-300 text-black ' : 'bg-[#E04343] text-white')}>
                      {datas?.label == '&laquo; Previous' ? '< Previous' : (datas?.label === 'Next &raquo;') ? 'Next  >' : datas?.label}
                    </button>
                  )
                )
              }

            </div>

          </div>
        </div>
        <div>
          <form onSubmit={schedule}>
            <div className={showScreen === 2 ? "block " : "hidden"}>
              <div className='lg:px-10 pb-6 px-6 bg-[#FAFAFA] min-h-screen'>

                {/* Create on behalf of an existing customer — permission gated */}
                {canCreateForCustomer && (
                  <div className='bg-white rounded-[10px] py-[20px] md:px-[35px] px-[16px] mt-[8px] mb-4 border-l-4 border-[#19213D]'>
                    <div className='flex flex-wrap justify-between items-start gap-2 mb-3'>
                      <div>
                        <h3 className='text-[16px] font-semibold'>Create On Behalf Of Customer</h3>
                        <p className='text-xs text-gray-500 mt-1 max-w-2xl'>
                          Pick an existing account and this shipment — and its invoice — is billed to that
                          customer instead of your staff account. Leave both empty to book it under your own account
                          as before.
                        </p>
                      </div>
                      {onBehalfCustomer && (
                        <button
                          type='button'
                          onClick={clearOnBehalfCustomer}
                          className='text-[12px] text-[#E04343] hover:underline'
                        >
                          Clear customer
                        </button>
                      )}
                    </div>

                    <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                      <div>
                        <label className="block mb-2 text-sm font-semibold text-[#19213D]">Cash Customer</label>
                        <SearchableSelect
                          name='cash_customer'
                          options={cashCustomerOptions}
                          value={onBehalfType === 'cash' ? onBehalfCustomer?.email : ''}
                          onChange={(e) => selectOnBehalfCustomer('cash', e.target.value)}
                          placeholder='Search cash customers by name, email or phone'
                          isClearable
                        />
                      </div>

                      <div>
                        <label className="block mb-2 text-sm font-semibold text-[#19213D]">Credit Customer</label>
                        <SearchableSelect
                          name='credit_customer'
                          options={creditCustomerOptions}
                          value={onBehalfType === 'credit' ? onBehalfCustomer?.email : ''}
                          onChange={(e) => selectOnBehalfCustomer('credit', e.target.value)}
                          placeholder='Search credit customers by name, email or phone'
                          isClearable
                        />
                      </div>
                    </div>

                    {onBehalfCustomer && (
                      <div className={`mt-4 p-3 rounded-lg text-[13px] ${isCreditCustomer ? 'bg-purple-50 border border-purple-200' : 'bg-blue-50 border border-blue-200'}`}>
                        <p className='font-semibold'>
                          Billing to: {onBehalfCustomer.name}{' '}
                          <span className={`ml-2 text-[11px] px-2 py-0.5 rounded-full ${isCreditCustomer ? 'bg-purple-100 text-purple-800' : 'bg-blue-100 text-blue-800'}`}>
                            {isCreditCustomer ? 'Credit Customer' : 'Cash Customer'}
                          </span>
                        </p>
                        <p className='text-gray-600 mt-1'>
                          {onBehalfCustomer.email}
                          {onBehalfCustomer.phone_number ? ` · ${onBehalfCustomer.phone_number}` : ''}
                        </p>
                        <p className='text-gray-500 text-[11px] mt-1'>
                          Sender details below were filled from this account — edit them if the actual shipper differs.
                          The shipment still goes to {onBehalfCustomer.email}'s account.
                        </p>
                      </div>
                    )}

                    {/* Credit customers are priced off their own rate card, which
                        requires the rate type the shipment is booked under. */}
                    {isCreditCustomer && (
                      <div className='mt-4'>
                        <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                          Rate Type <span className='text-red-600'>*</span>
                        </label>
                        <div className='grid grid-cols-2 md:grid-cols-5 gap-2'>
                          {[
                            { value: 'fixed', label: 'Fixed', hint: 'Exact weight' },
                            { value: 'bulk', label: 'Bulk', hint: 'Rate × Weight' },
                            { value: 'flat', label: 'Flat', hint: 'Fixed range' },
                            { value: 'multiplier', label: 'Multiplier', hint: 'Rate × Weight' },
                            { value: 'special', label: 'Special', hint: 'Unit-based' },
                          ].map((rate) => (
                            <label
                              key={rate.value}
                              className={`flex items-center space-x-2 p-3 border-2 rounded-lg cursor-pointer transition-all ${shipmentRateType === rate.value ? 'border-purple-600 bg-purple-50' : 'border-gray-200'}`}
                            >
                              <input
                                type="radio"
                                name="shipmentRateType"
                                value={rate.value}
                                checked={shipmentRateType === rate.value}
                                onChange={(e) => setShipmentRateType(e.target.value)}
                                className="w-4 h-4 text-purple-600"
                              />
                              <div>
                                <p className='font-semibold text-[13px]'>{rate.label}</p>
                                <p className='text-[11px] text-gray-500'>{rate.hint}</p>
                              </div>
                            </label>
                          ))}
                        </div>

                        {shipmentRateType === 'special' && (
                          <div className='mt-3 grid grid-cols-1 md:grid-cols-3 gap-4'>
                            <div>
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Unit Type <span className='text-red-600'>*</span>
                              </label>
                              <SearchableSelect
                                name='special_unit_type'
                                options={[
                                  { value: 'Carton', label: 'Carton' },
                                  { value: 'Keg', label: 'Keg' },
                                ]}
                                value={specialUnitType}
                                onChange={(e) => setSpecialUnitType(e.target.value)}
                                placeholder='--Select Unit Type--'
                              />
                            </div>

                            {/* The card is banded by quantity and the price multiplies
                                by it, so this drives both which band applies and the
                                total. Whole units only — half a carton is not a thing. */}
                            <div>
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Number of {specialUnitType ? `${specialUnitType.toLowerCase()}s` : 'units'}
                                <span className='text-red-600'> *</span>
                              </label>
                              <input
                                type='number'
                                min='1'
                                step='1'
                                value={specialQuantity}
                                onChange={(e) => setSpecialQuantity(e.target.value)}
                                className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-2.5"
                              />
                              <p className='text-[11px] text-gray-500 mt-1'>
                                The rate band and the total both depend on this.
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}

                {/* Weight Entry Reminder */}
                {countryToData === '1' && (
                  <div className='mb-6 bg-yellow-50 border-l-4 border-yellow-500 rounded-lg p-4'>
                    <div className='flex items-start space-x-3'>
                      <svg className="w-5 h-5 text-yellow-600 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                      </svg>
                      <div>
                        <p className='font-semibold text-sm text-yellow-800'>LGA Rate System</p>
                        <p className='text-xs text-yellow-700 mt-1'>
                          Enter weight in "Shipments Information" section to see correct LGAs:
                        </p>
                        <ul className='text-xs text-yellow-700 mt-2 ml-4 list-disc space-y-1'>
                          <li><strong>Weight 0.5-10kg:</strong> Domestic LGA rates</li>
                          <li><strong>Weight 20kg+:</strong> Bulk LGA rates</li>
                          <li>LGAs will auto-reload when weight crosses 20kg threshold</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                )}

                {/* Service Type Selection - Only for domestic shipments */}
                {countryToData === '1' && (
                  <div className='bg-white rounded-[10px] py-[20px] md:px-[35px] mt-[8px] mb-4'>
                    <h3 className='text-[16px] font-semibold mb-3'>Service Type (Domestic Only)</h3>
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                      <label className={`flex items-center space-x-3 p-4 border-2 rounded-lg cursor-pointer transition-all ${serviceType === 'domestic' ? 'border-[#E04343] bg-red-50' : 'border-gray-200'}`}>
                        <input
                          type="radio"
                          name="serviceTypeRadio"
                          value="domestic"
                          checked={serviceType === 'domestic'}
                          onChange={(e) => setServiceType(e.target.value)}
                          className="w-4 h-4 text-[#E04343]"
                        />
                        <div>
                          <p className='font-semibold text-sm'>Domestic</p>
                          <p className='text-xs text-gray-500'>Standard delivery</p>
                        </div>
                      </label>

                      <label className={`flex items-center space-x-3 p-4 border-2 rounded-lg cursor-pointer transition-all ${serviceType === 'express' ? 'border-[#E04343] bg-red-50' : 'border-gray-200'}`}>
                        <input
                          type="radio"
                          name="serviceTypeRadio"
                          value="express"
                          checked={serviceType === 'express'}
                          onChange={(e) => setServiceType(e.target.value)}
                          className="w-4 h-4 text-[#E04343]"
                        />
                        <div>
                          <p className='font-semibold text-sm'>Express</p>
                          <p className='text-xs text-gray-500'>Fast delivery</p>
                        </div>
                      </label>
                    </div>
                  </div>
                )}


                {/* Service Type Selection - UPDATED */}
                <div className='bg-white rounded-[10px] py-[20px] md:px-[35px] mt-[8px] mb-4'>
                  <h3 className='text-[16px] font-semibold mb-3'>Service Type</h3>
                  <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
                    <label className={`flex items-center space-x-3 p-4 border-2 rounded-lg cursor-pointer transition-all ${serviceType === 'domestic' ? 'border-[#E04343] bg-red-50' : 'border-gray-200'}`}>
                      <input
                        type="radio"
                        name="serviceTypeRadio"
                        value="domestic"
                        checked={serviceType === 'domestic'}
                        onChange={(e) => setServiceType(e.target.value)}
                        className="w-4 h-4 text-[#E04343]"
                      />
                      <div>
                        <p className='font-semibold text-sm'>Domestic</p>
                        <p className='text-xs text-gray-500'>Nigeria to Nigeria</p>
                      </div>
                    </label>

                    <label className={`flex items-center space-x-3 p-4 border-2 rounded-lg cursor-pointer transition-all ${serviceType === 'express' ? 'border-[#E04343] bg-red-50' : 'border-gray-200'}`}>
                      <input
                        type="radio"
                        name="serviceTypeRadio"
                        value="express"
                        checked={serviceType === 'express'}
                        onChange={(e) => setServiceType(e.target.value)}
                        className="w-4 h-4 text-[#E04343]"
                      />
                      <div>
                        <p className='font-semibold text-sm'>Express</p>
                        <p className='text-xs text-gray-500'>Fast delivery</p>
                      </div>
                    </label>

                    <label className={`flex items-center space-x-3 p-4 border-2 rounded-lg cursor-pointer transition-all ${serviceType === 'export' ? 'border-[#E04343] bg-red-50' : 'border-gray-200'}`}>
                      <input
                        type="radio"
                        name="serviceTypeRadio"
                        value="export"
                        checked={serviceType === 'export'}
                        onChange={(e) => setServiceType(e.target.value)}
                        className="w-4 h-4 text-[#E04343]"
                      />
                      <div>
                        <p className='font-semibold text-sm'>Export</p>
                        <p className='text-xs text-gray-500'>International</p>
                      </div>
                    </label>

                    <label className={`flex items-center space-x-3 p-4 border-2 rounded-lg cursor-pointer transition-all ${serviceType === 'food' ? 'border-[#E04343] bg-red-50' : 'border-gray-200'}`}>
                      <input
                        type="radio"
                        name="serviceTypeRadio"
                        value="food"
                        checked={serviceType === 'food'}
                        onChange={(e) => setServiceType(e.target.value)}
                        className="w-4 h-4 text-[#E04343]"
                      />
                      <div>
                        <p className='font-semibold text-sm'>Food</p>
                        <p className='text-xs text-gray-500'>Food, fish & cosmetics</p>
                      </div>
                    </label>
                  </div>

                  {/* Food is priced by destination and item type rather than by zone,
                      so these replace the usual country/state inputs. */}
                  {serviceType === 'food' && (
                    <div className='mt-4 pt-4 border-t border-gray-200 grid grid-cols-1 md:grid-cols-2 gap-4'>
                      <div>
                        <label className='block mb-2 text-sm font-semibold text-[#19213D]'>
                          Destination <span className='text-red-600'>*</span>
                        </label>
                        <select
                          value={foodDestination}
                          onChange={(e) => setFoodDestination(e.target.value)}
                          className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-2.5"
                        >
                          <option value=''>Where is it going?</option>
                          {foodOptions.map((d: any) => (
                            <option key={d.key} value={d.key}>{d.label}</option>
                          ))}
                        </select>
                      </div>

                      <div>
                        <label className='block mb-2 text-sm font-semibold text-[#19213D]'>
                          Item type <span className='text-red-600'>*</span>
                        </label>
                        <select
                          value={foodCommodity}
                          onChange={(e) => setFoodCommodity(e.target.value)}
                          disabled={!foodDestination}
                          className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-2.5 disabled:bg-gray-100"
                        >
                          <option value=''>{foodDestination ? 'What is being sent?' : 'Choose a destination first'}</option>
                          {foodCommodityOptions.map((c: any) => (
                            <option key={c.key} value={c.key}>{c.label}</option>
                          ))}
                        </select>
                        {foodDestination && (
                          <p className='text-[11px] text-gray-500 mt-1'>
                            Only what we carry to that destination is listed.
                          </p>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                {/* Export Service Type Indicator */}
                {countryToData != '1' && (
                  <div className='bg-blue-50 border-l-4 border-blue-500 rounded-[10px] py-[20px] md:px-[35px] mt-[8px] mb-4'>
                    <div className='flex items-center space-x-3'>
                      <svg className="w-6 h-6 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <div>
                        <p className='font-semibold text-sm text-blue-800'>International Export</p>
                        <p className='text-xs text-blue-600'>This shipment is being sent internationally</p>
                      </div>
                    </div>
                  </div>
                )}

                {/* Rate Summary Card */}
                {totalCostData && (
                  <div className='bg-white rounded-[10px] py-[20px] md:px-[35px] mb-4 border-l-4 border-[#E04343]'>
                    <div className='flex justify-between items-center mb-3'>
                      <h3 className='text-[16px] font-semibold text-[#E04343]'>Calculated Rate</h3>
                      <span className='text-xs bg-blue-100 text-blue-800 px-3 py-1 rounded-full font-semibold'>
                        {totalCostData?.service_type}
                      </span>
                    </div>

                    <div className='grid grid-cols-2 md:grid-cols-4 gap-4'>
                      {totalCostData?.zone && (
                        <div>
                          <p className='text-xs text-gray-500'>Zone</p>
                          <p className='text-sm font-semibold'>Zone {totalCostData.zone}</p>
                        </div>
                      )}
                      {totalCostData?.category && (
                        <div>
                          <p className='text-xs text-gray-500'>Category</p>
                          <p className='text-sm font-semibold'>{totalCostData.category}</p>
                        </div>
                      )}
                      {totalCostData?.country && (
                        <div>
                          <p className='text-xs text-gray-500'>Destination</p>
                          <p className='text-sm font-semibold'>{totalCostData.country}</p>
                        </div>
                      )}
                      <div>
                        <p className='text-xs text-gray-500'>Chargeable Weight</p>
                        <p className='text-sm font-semibold'>{totalCostData?.actual_weight} kg</p>
                      </div>
                      {totalCostData?.base_cost !== undefined && (
                        <div>
                          <p className='text-xs text-gray-500'>Base Cost</p>
                          <p className='text-sm font-semibold'>
                            {new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(totalCostData?.base_cost || 0)}
                          </p>
                        </div>
                      )}
                      {totalCostData?.lga_charges !== undefined && totalCostData?.lga_charges > 0 && (
                        <div>
                          <p className='text-xs text-gray-500'>LGA Charges</p>
                          <p className='text-sm font-semibold text-yellow-700'>
                            {new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(totalCostData?.lga_charges || 0)}
                          </p>
                        </div>
                      )}
                      {totalCostData?.onforwarding_charge !== undefined && totalCostData?.onforwarding_charge > 0 && (
                        <div>
                          <p className='text-xs text-gray-500'>Onforwarding</p>
                          <p className='text-sm font-semibold'>
                            {new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(totalCostData?.onforwarding_charge || 0)}
                          </p>
                        </div>
                      )}
                      <div>
                        <p className='text-xs text-gray-500'>Subtotal</p>
                        <p className='text-sm font-semibold'>
                          {new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(totalCostData?.subtotal || 0)}
                        </p>
                      </div>
                      <div>
                        <p className='text-xs text-gray-500'>VAT (7.5%)</p>
                        <p className='text-sm font-semibold'>
                          {new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(totalCostData?.tax || 0)}
                        </p>
                      </div>
                      <div className='md:col-span-2'>
                        <p className='text-xs text-gray-500'>Total Cost</p>
                        <p className='text-lg font-bold text-[#E04343]'>
                          {new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(totalCostData?.total_cost || 0)}
                        </p>
                      </div>
                    </div>
                  </div>
                )}

                {/* Sender Information */}
                <div className="px-6 lg:mt-5 bg-white pt-[24px] rounded-[10px]">
                  <div className="flex justify-between items-center mb-4">
                    <span className="font-[700] text-[#19213D] lg:text-[14px] text-[12px] bg-[#EBEFF6] md:px-[12px] py-[12px] rounded-[13px]">Sender Information</span>
                    <div className="flex items-center space-x-2 bg-green-50 px-3 py-2 rounded-lg">
                      <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <span className="text-xs font-semibold text-green-800">Origin: Nigeria</span>
                    </div>
                  </div>

                  <div className="flex flex-col lg:flex-row lg:justify-between max-w-screen-xl mx-auto mt-5">
                    <div className="relative flex flex-col min-w-0 break-words w-full">
                      <div className="flex-auto py-10 pt-0">
                        <div className="flex flex-wrap">

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Name <span className='text-red-600'>*</span>
                              </label>
                              <input
                                type="text"
                                className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                placeholder="Enter Name"
                                name="SenderName"
                                value={shipmentData?.SenderName || ''}
                                onChange={handleShipmentChange}
                                required
                              />
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Email <span className='text-red-600'>*</span>
                              </label>
                              <input
                                type="email"
                                className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                placeholder="Enter Email"
                                name="SenderEmail"
                                value={shipmentData?.SenderEmail || ''}
                                onChange={handleShipmentChange}
                                required
                              />
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Phone Number <span className='text-red-600'>*</span>
                              </label>
                              <input
                                // `tel` not `number`: a prefilled account number with a
                                // leading "+" or spaces is rejected by a number input and
                                // would silently render blank.
                                type="tel"
                                className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                placeholder="Enter Phone Number"
                                name="SenderPhone"
                                value={shipmentData?.SenderPhone || ''}
                                onChange={handleShipmentChange}
                                required
                              />
                            </div>
                          </div>

                          <div className="w-full lg:w-12/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Address <span className='text-red-600'>*</span>
                              </label>
                              <input
                                type="text"
                                className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                placeholder="Enter Address"
                                name="SenderAdd1"
                                value={shipmentData?.SenderAdd1 || ''}
                                onChange={handleShipmentChange}
                                required
                              />
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                City <span className='text-red-600'>*</span>
                              </label>
                              <input
                                type="text"
                                className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                placeholder="Enter City"
                                name="SenderAddCity"
                                onChange={handleShipmentChange}
                                required
                              />
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                State <span className="text-xs text-gray-500">(Optional)</span>
                              </label>
                              <SearchableSelect
                                name='SenderAddState'
                                options={stateFromOptions}
                                value={stateFromData || ''}
                                onChange={(e) => getLgaFrom(e.target.value)}
                                placeholder="Select State (Optional)"
                                disabled={!shipmentData?.CubicWeight}
                                isClearable
                              />
                              {!shipmentData?.CubicWeight && (
                                <p className='text-xs text-orange-500 mt-1'>⚠️ Enter weight first</p>
                              )}
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                LGA <span className="text-xs text-gray-500">(Optional)</span>
                              </label>
                              <SearchableSelect
                                name='senderLga'
                                options={lgaFromOptions}
                                value={lgaFromData || ''}
                                onChange={(e) => {
                                  const lgaName = e.target.value;
                                  setShipmentData({
                                    ...shipmentData,
                                    senderLga: lgaName
                                  });
                                  setLgaFromData(lgaName);
                                }}
                                placeholder="Select LGA (Optional)"
                                disabled={!stateFromData || lgaFrom.length === 0}
                                isClearable
                              />
                              {stateFromData && lgaFrom.length === 0 && (
                                <p className='text-xs text-gray-500 mt-1'>No LGAs for this weight/state combo</p>
                              )}
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Post Code
                              </label>
                              <input
                                type="text"
                                className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                placeholder="Enter Post Code"
                                name="SenderAddPostcode"
                                onChange={handleShipmentChange}
                              />
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Tax ID
                              </label>
                              <input
                                type="text"
                                className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                placeholder="Enter Tax ID"
                                name="SenderTaxID"
                                onChange={handleShipmentChange}
                              />
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Receiver Information */}
                <div className="px-6 lg:mt-5 bg-white pt-[24px] rounded-[10px]">
                  <div className="flex justify-between">
                    <span className="font-[700] text-[#19213D] lg:text-[14px] text-[12px] bg-[#EBEFF6] pl-[12px] py-[12px] pr-[40px] rounded-[13px]">Receiver Information</span>
                  </div>

                  <div className="flex flex-col lg:flex-row lg:justify-between max-w-screen-xl mx-auto mt-5">
                    <div className="relative flex flex-col min-w-0 break-words w-full">
                      <div className="flex-auto py-10 pt-0">
                        <div className="flex flex-wrap">

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Name <span className='text-red-600'>*</span>
                              </label>
                              <input
                                type="text"
                                className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                placeholder="Enter Name"
                                name="ReceiverName"
                                onChange={handleShipmentChange}
                                required
                              />
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Email <span className='text-red-600'>*</span>
                              </label>
                              <input
                                type="email"
                                className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                placeholder="Enter Email"
                                name="ReceiverEmail"
                                onChange={handleShipmentChange}
                                required
                              />
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Destination Country <span className='text-red-600'>*</span>
                              </label>
                              <SearchableSelect
                                name='ReceiverCountryCode'
                                options={destinationCountryOptions}
                                value={countryToData || ''}
                                onChange={(e: any) => { handleShipmentChange(e); getStateTo(e.target.value) }}
                                placeholder="Select Country"
                                required
                              />
                            </div>
                          </div>

                          <div className="w-full lg:w-12/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Address <span className='text-red-600'>*</span>
                              </label>
                              <input
                                type="text"
                                className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                placeholder="Enter Address"
                                name="ReceiverAdd1"
                                onChange={handleShipmentChange}
                                required
                              />
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                City <span className='text-red-600'>*</span>
                              </label>
                              <input
                                type="text"
                                className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                placeholder="Enter City"
                                name="ReceiverAddCity"
                                onChange={handleShipmentChange}
                                required
                              />
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                State
                              </label>
                              <SearchableSelect
                                name='ReceiverAddState'
                                options={stateToOptions}
                                value={stateToData || ''}
                                onChange={(e) => getLgaTo(e.target.value)}
                                placeholder={isExport ? 'Not required for international' : 'Select State *'}
                                disabled={isExport || !shipmentData?.CubicWeight}
                                isClearable
                              />
                              {isExport ? (
                                <p className='text-xs text-gray-500 mt-1'>
                                  Not needed — export is priced by destination country.
                                </p>
                              ) : !shipmentData?.CubicWeight && (
                                <p className='text-xs text-orange-500 mt-1'>⚠️ Enter weight first</p>
                              )}
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                LGA <span className="text-xs text-gray-500">(Optional)</span>
                              </label>
                              <SearchableSelect
                                name='recieverLga'
                                options={lgaToOptions}
                                value={lgaToData || ''}
                                onChange={(e) => {
                                  const lgaName = e.target.value;
                                  setShipmentData({
                                    ...shipmentData,
                                    recieverLga: lgaName
                                  });
                                  setLgaToData(lgaName);
                                }}
                                placeholder={isExport ? 'Not required for international' : 'Select LGA (Optional)'}
                                disabled={isExport || !stateToData || lgaTo.length === 0}
                                isClearable
                              />
                              {stateToData && lgaTo.length === 0 && (
                                <p className='text-xs text-gray-500 mt-1'>No LGAs for this weight/state combo</p>
                              )}
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Post Code
                              </label>
                              <input
                                type="text"
                                className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                placeholder="Enter Post Code"
                                name="ReceiverAddPostcode"
                                onChange={handleShipmentChange}
                              />
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Tax ID
                              </label>
                              <input
                                type="text"
                                className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                placeholder="Enter Tax ID"
                                name="ReceiverTaxID"
                                onChange={handleShipmentChange}
                              />
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Phone Number <span className='text-red-600'>*</span>
                              </label>
                              <input
                                type="number"
                                className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                placeholder="Enter Phone Number"
                                name="ReceiverPhone"
                                onChange={handleShipmentChange}
                                required
                              />
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Shipments Information */}
                <div className="px-6 lg:mt-5 bg-white pt-[24px] rounded-[10px]">
                  <div className="flex justify-between">
                    <span className="font-[700] text-[#19213D] lg:text-[14px] text-[12px] bg-[#EBEFF6] pl-[12px] py-[12px] pr-[40px] rounded-[13px]">Shipments Information</span>
                  </div>

                  <div className="flex flex-col lg:flex-row lg:justify-between max-w-screen-xl mx-auto mt-5">
                    <div className="relative flex flex-col min-w-0 break-words w-full">
                      <div className="flex-auto py-10 pt-0">
                        <div className="flex flex-wrap">

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Service <span className='text-red-600'>*</span>
                              </label>
                              <SearchableSelect
                                required
                                name='ServiceTypeName'
                                options={SERVICE_OPTIONS}
                                value={shipmentData?.ServiceTypeName}
                                onChange={(e: any) => handleShipmentChange(e)}
                                placeholder="Select Service"
                              />
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                No of Items <span className='text-red-600'>*</span>
                              </label>
                              <input
                                type="number"
                                className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                placeholder="Item Number"
                                name="NoOfItems"
                                onChange={handleShipmentChange}
                                required
                              />
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Harmonized Code
                              </label>
                              <input
                                type="text"
                                className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                placeholder=""
                                name="HarmonisedCode"
                                onChange={handleShipmentChange}
                              />
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Cubic Measurement (L x W x H)
                              </label>
                              <div className='flex space-x-3'>
                                <input
                                  type="number"
                                  step="0.1"
                                  className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-2"
                                  placeholder="L"
                                  name="CubicL"
                                  onChange={handleShipmentChange}
                                />
                                <span className='py-[3px]'>x</span>
                                <input
                                  type="number"
                                  step="0.1"
                                  className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-1"
                                  placeholder="W"
                                  name="CubicW"
                                  onChange={handleShipmentChange}
                                />
                                <span className='py-[3px]'>x</span>
                                <input
                                  type="number"
                                  step="0.1"
                                  className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-1"
                                  placeholder="H"
                                  name="CubicH"
                                  onChange={handleShipmentChange}
                                />
                                <span className='py-[3px]'>=</span>
                                <input
                                  type="text"
                                  className="bg-gray-100 border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-1"
                                  disabled
                                  value={shipmentData?.CubicL && shipmentData?.CubicW && shipmentData?.CubicH
                                    ? ((shipmentData.CubicL * shipmentData.CubicW * shipmentData.CubicH) / 5000).toFixed(2) + " KG"
                                    : "0 KG"}
                                />
                              </div>
                              <p className='text-xs text-gray-500 mt-1'>Formula: L × W × H ÷ 5000</p>
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Volume Weight (KG)
                              </label>
                              <input
                                type="number"
                                className="bg-gray-100 border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                placeholder=""
                                name="CubicWeight"
                                disabled
                                value={((shipmentData?.CubicL * shipmentData?.CubicW * shipmentData?.CubicH) / 5000) || 0}
                              />
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Gross Weight (KG) <span className='text-red-600'>*</span>
                              </label>
                              <input
                                type="number"
                                step="0.1"
                                className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                placeholder="Weight"
                                name="CubicWeight"
                                onChange={(e) => handleShipmentChange(e)}
                                required
                              />
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Customs Value
                              </label>
                              <div className='flex'>
                                <div className='basis-2/3'>
                                  <input
                                    type="number"
                                    className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-l-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                    placeholder=""
                                    name="CustomValue"
                                    onChange={(e) => handleShipmentChange(e)}
                                  />
                                </div>
                                <div className='basis-1/3'>
                                  <SearchableSelect
                                    name='CustomCurrencyCode'
                                    options={CURRENCY_OPTIONS}
                                    value={shipmentData?.CustomCurrencyCode}
                                    onChange={(e: any) => handleShipmentChange(e)}
                                    rounded="right"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                COD Amount
                              </label>
                              <div className='flex'>
                                <div className='basis-2/3'>
                                  <input
                                    type="number"
                                    className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-l-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                    placeholder=""
                                    name="CODAmount"
                                    onChange={handleShipmentChange}
                                  />
                                </div>
                                <div className='basis-1/3'>
                                  <SearchableSelect
                                    name='CODCurrencyCode'
                                    options={CURRENCY_OPTIONS}
                                    value={shipmentData?.CODCurrencyCode}
                                    onChange={(e: any) => handleShipmentChange(e)}
                                    rounded="right"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label htmlFor="countries" className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Request Pickup
                              </label>
                              <SearchableSelect
                                name='BookPickUP'
                                options={PICKUP_OPTIONS}
                                value={String(shipmentData?.BookPickUP ?? '')}
                                onChange={(e: any) => handleShipmentChange(e)}
                                placeholder="Select One"
                              />
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Shipment Information 2 */}
                <div className="px-6 lg:mt-5 bg-white pt-[24px] rounded-[10px]">
                  <div className="flex justify-between">
                    <span className="font-[700] text-[#19213D] lg:text-[14px] text-[12px] bg-[#EBEFF6] pl-[12px] py-[12px] pr-[40px] rounded-[13px]">Shipment Information</span>
                  </div>

                  <div className="flex flex-col lg:flex-row lg:justify-between max-w-screen-xl mx-auto mt-5">
                    <div className="relative flex flex-col min-w-0 break-words w-full">
                      <div className="flex-auto py-10 pt-0">
                        <div className="flex flex-wrap">

                          <div className="w-full lg:w-12/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label htmlFor="message" className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Description <span className='text-red-600'>*</span>
                              </label>
                              <textarea
                                required
                                onChange={(e: any) => handleShipmentChange(e)}
                                name='GoodsDescription'
                                rows={4}
                                className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                placeholder="Write your thoughts here..."
                              />
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label htmlFor="countries" className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Shipment Terms
                              </label>
                              <SearchableSelect
                                name='ShipmentTerm'
                                options={SHIPMENT_TERM_OPTIONS}
                                value={shipmentData?.ShipmentTerm}
                                onChange={(e: any) => handleShipmentChange(e)}
                                placeholder="Select One"
                              />
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label htmlFor="countries" className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Incoterms
                              </label>
                              <SearchableSelect
                                name='Incoterms'
                                options={INCOTERM_OPTIONS}
                                value={shipmentData?.Incoterms}
                                onChange={(e: any) => handleShipmentChange(e)}
                                placeholder="Select One"
                              />
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label htmlFor="countries" className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Type of Business
                              </label>
                              <SearchableSelect
                                name='BusinessType'
                                options={BUSINESS_TYPE_OPTIONS}
                                value={shipmentData?.BusinessType}
                                onChange={(e: any) => handleShipmentChange(e)}
                                placeholder="Select One"
                              />
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Customer Ref #1
                              </label>
                              <input
                                type="text"
                                className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                name="SenderRef1"
                                onChange={handleShipmentChange}
                              />
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Customer Ref #2
                              </label>
                              <input
                                type="text"
                                className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                name="SenderRef2"
                                onChange={handleShipmentChange}
                              />
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label htmlFor="countries" className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Origin of goods
                              </label>
                              <SearchableSelect
                                name='GoodsOriginCountryCode'
                                options={GOODS_ORIGIN_OPTIONS}
                                value={shipmentData?.GoodsOriginCountryCode}
                                onChange={(e: any) => handleShipmentChange(e)}
                                placeholder="Select Country"
                              />
                            </div>
                          </div>

                          <div className="w-full lg:w-12/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label htmlFor="message" className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Reason for Export
                              </label>
                              <textarea
                                onChange={(e: any) => handleShipmentChange(e)}
                                name='ReasonExport'
                                rows={4}
                                className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                placeholder="Write here..."
                              />
                            </div>
                          </div>

                          <div className="w-full lg:w-12/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label htmlFor="message" className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Notes
                              </label>
                              <textarea
                                onChange={(e: any) => handleShipmentChange(e)}
                                name='Notes'
                                rows={4}
                                className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                placeholder="Write here..."
                              />
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Additional Shipment Information */}
                <div className="px-6 lg:mt-5 bg-white pt-[24px] rounded-[10px]">
                  <div className="flex justify-between">
                    <span className="font-[700] text-[#19213D] lg:text-[14px] text-[12px] bg-[#EBEFF6] pl-[12px] py-[12px] pr-[40px] rounded-[13px]">Additional Shipment Information</span>
                  </div>

                  <div className="flex flex-col lg:flex-row lg:justify-between max-w-screen-xl mx-auto mt-5">
                    <div className="relative flex flex-col min-w-0 break-words w-full">
                      <div className="flex-auto py-10 pt-0">
                        <div className="flex flex-wrap">

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                CPC Code
                              </label>
                              <input
                                type="text"
                                className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                name="CPCCode"
                                onChange={handleShipmentChange}
                              />
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                SKU Number
                              </label>
                              <input
                                type="text"
                                className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                name="SKUNumber"
                                onChange={handleShipmentChange}
                              />
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                ATE Number
                              </label>
                              <input
                                type="text"
                                className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                name="ATENumber"
                                onChange={handleShipmentChange}
                              />
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Product URL
                              </label>
                              <input
                                type="text"
                                className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                placeholder=""
                                name="ProductURL"
                                onChange={handleShipmentChange}
                              />
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Total Cost of Goods
                              </label>
                              <div className='flex'>
                                <div className='basis-2/3'>
                                  <input
                                    type="number"
                                    className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-l-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                    placeholder=""
                                    name="GoodsValue"
                                    onChange={handleShipmentChange}
                                  />
                                </div>
                                <div className='basis-1/3'>
                                  <SearchableSelect
                                    name='GoodsCurrencyCode'
                                    options={CURRENCY_OPTIONS}
                                    value={shipmentData?.GoodsCurrencyCode}
                                    onChange={(e: any) => handleShipmentChange(e)}
                                    rounded="right"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full mb-5">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Duties
                              </label>
                              <div className='flex'>
                                <div className='basis-2/3'>
                                  <input
                                    type="number"
                                    className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-l-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                    placeholder=""
                                    name="DutyValue"
                                    onChange={handleShipmentChange}
                                  />
                                </div>
                                <div className='basis-1/3'>
                                  <SearchableSelect
                                    name='DutyCurrencyCode'
                                    options={CURRENCY_OPTIONS}
                                    value={shipmentData?.DutyCurrencyCode}
                                    onChange={(e: any) => handleShipmentChange(e)}
                                    rounded="right"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                EORI Number
                              </label>
                              <input
                                type="text"
                                className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                placeholder=""
                                name="EORINumber"
                                onChange={handleShipmentChange}
                              />
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Freight Cost
                              </label>
                              <div className='flex'>
                                <div className='basis-2/3'>
                                  <input
                                    type="number"
                                    className="bg-gray-100 border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-l-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                    placeholder=""
                                    disabled
                                    name="FreightCost"
                                    value={totalCost}
                                  />
                                </div>
                                <div className='basis-1/3'>
                                  <SearchableSelect
                                    disabled
                                    name='FreightCostCurrencyCode'
                                    options={CURRENCY_OPTIONS}
                                    value={shipmentData?.FreightCostCurrencyCode}
                                    onChange={(e: any) => handleShipmentChange(e)}
                                    rounded="right"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="w-full lg:w-4/12 lg:pr-4">
                            <div className="relative w-full">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                Total GST paid (if any)
                              </label>
                              <div className='flex'>
                                <div className='basis-2/3'>
                                  <input
                                    type="number"
                                    className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-l-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px]"
                                    placeholder=""
                                    name="TotalGSTAmount"
                                    onChange={handleShipmentChange}
                                  />
                                </div>
                                <div className='basis-1/3'>
                                  <SearchableSelect
                                    name='TotalGSTCurrencyCode'
                                    options={CURRENCY_OPTIONS}
                                    value={shipmentData?.TotalGSTCurrencyCode}
                                    onChange={(e: any) => handleShipmentChange(e)}
                                    rounded="right"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Form Actions */}
                <div className='flex justify-end mt-6'>
                  <div className='flex space-x-10'>
                    <div>
                      <button
                        type='submit'
                        disabled={loader2}
                        className='bg-[#E04343] rounded-[10px] flex justify-center gap-2 py-[5px] px-[20px] text-white disabled:opacity-50'
                      >
                        <span>Create Shipment</span>
                        {loader2 && (
                          <Oval
                            visible={true}
                            height="20"
                            width="20"
                            color="#f9adad"
                            secondaryColor="#FF3B300D"
                            ariaLabel="oval-loading"
                          />
                        )}
                      </button>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </form>
        </div>

      </div>

      <section>
        <Modal
          visible={statusModal}
          width="400"
          height="300"
          effect="fadeInUp"
          onClickAway={() => setStatusModal(false)}
        >
          <div className=" " style={{ overflow: 'auto' }}>

            <div className="container  bg-[#fff] rounded-lg p-2">

              <div className="px-3">


                <span className="flex justify-between px-2 pt-3">
                  <p className='mt-2'>Change Status</p>
                  <p className="cursor-pointer font-bold" onClick={(e) => setStatusModal(false)}><SvgElement type={icontypesEnum.CANCEL} /></p>
                </span>
                <form className="pb-4 rounded-lg" onSubmit={updateShipment}>

                  <div className="relative w-full mt-10 mb-4">
                    <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                      Status {shipmentId?.Status}
                    </label>



                    {
                      userLoginData?.data?.role == 'fleet' ?
                        <div>
                          <select id="countries" name='SenderCountryCode' defaultValue={shipmentId?.Status} onChange={(e: any) => setShipmentStatus(e?.target?.value)} className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-r-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px]  ease-linear transition-all duration-150">
                            <option selected>{shipmentId?.Status}</option>
                            <option value="Proof of Delivery">Proof of Delivery</option>
                            <option value="In Transit to Destination">In Transit to Destination</option>
                            <option value="Out for Delivery">Out for Delivery</option>
                            <option value="Attempted Delivery - Inaccurate / Incomplete Address">Attempted Delivery - Inaccurate / Incomplete Address</option>

                          </select>

                          {(shipmentStatus == 'Proof of Delivery' || shipmentId?.Status == 'Proof of Delivery') ?
                            <div className="w-full lg:w-12/12 ">
                              <div className="relative w-full mb-5">
                                <label htmlFor="message" className="block mb-2 text-sm font-semibold text-[#19213D]">Delivery Notes</label>
                                <textarea onChange={(e: any) => setDelieveryInstruction(e.target.value)} name='DeliveryInstructions' rows={3} className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]  ease-linear transition-all duration-150" placeholder="Write here..." defaultValue={shipmentId?.DeliveryInstructions}></textarea>
                              </div>
                            </div>
                            :
                            ''
                          }


                        </div>
                        :
                        <Select
                          options={allOptions} // Options for the dropdown
                          defaultValue={allOptions[0]} // Set default selected value
                          onChange={handleChange} // Handle on change
                          classNamePrefix="select" // Add custom class prefix if you need styling
                          isSearchable // Make the dropdown searchable
                          placeholder="Select a status..."
                          isClearable
                        />
                    }



                  </div>


                  <span className="flex justify-center pt-4">
                    <button
                      type="submit"
                      style={{ borderRadius: '50px', color: '#F52424' }}
                      className=" text-red-700 bg-red-200 focus:ring-4 focus:outline-none focus:ring-grredeen-300 font-medium rounded-lg text-sm w-full px-2 py-2.5 text-center "
                    >
                      <div className="flex justify-center gap-3 ">
                        <span>Update</span>
                        <Oval
                          visible={loading}
                          height="20"
                          width="20"
                          color="#E04343"
                          secondaryColor="#FCBF94"
                          ariaLabel="oval-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                        />
                      </div>
                    </button>
                  </span>

                  <span className="flex justify-center pt-4">
                    <button
                      type="button"
                      onClick={(e) => setStatusModal(false)}
                      style={{ borderRadius: '50px' }}
                      className=" text-black   focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm w-full px-2 py-1.5 text-center "
                    >
                      Cancel
                    </button>
                  </span>

                </form>
              </div>

            </div>

          </div>
        </Modal>
      </section>




      <section>
        <Modal
          visible={massStatusModal}
          width="90%"
          height="750"
          effect="fadeInUp"
          onClickAway={() => setMassStatusModal(false)}
        >

          {
            loading ?
              <div className="flex flex-col  mt-[30vh] mx-5">

                <div className="w-full bg-gray-200 rounded-full ">
                  <div className="bg-[#E04343] text-xs font-medium text-white text-center p-0.5 leading-none rounded-full" style={{ width: `${percentage}%` }}> {percentage}%</div>
                </div>

                <div className='flex justify-center mt-4'>
                  <Oval
                    visible={true}
                    height="60"
                    width="60"
                    color="#E04343"
                    secondaryColor="#FCBF94"
                    ariaLabel="oval-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                  />
                </div>


                <div className='flex justify-center mt-3'>
                  <span>Kindly wait!!!</span>
                </div>

              </div>
              :
              <div className="" style={{ height: '750px', overflow: 'auto' }}>

                <div className="container  bg-[#fff] rounded-lg p-2">

                  <div className="px-3">

                    {/* <span className="flex justify-around">
                    <h1 className=" text-xs text-red-600" style={{ fontSize: '10px' }}>Link can’t be edited in free plan. <span style={{ color: '#61A24F' }} className="font-bold text-xs">Upgrade to Pro</span></h1>
                  </span> */}
                    <span className="flex justify-between px-2 pt-3">
                      <p className='mt-2'>Multiple Shipment Status Update</p>
                      <p className="cursor-pointer font-bold" onClick={(e) => setMassStatusModal(false)}><SvgElement type={icontypesEnum.CANCEL} /></p>
                    </span>
                    <form className="pb-4 rounded-lg" onSubmit={updateMultipleShipment}>

                      <div className="relative w-full mt-10 mb-4">
                        <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                          Select Status <span className=' text-red-600'>*</span>
                        </label>



                        {
                          userLoginData?.data?.role == 'fleet' ?
                            <div>
                              <select id="countries" name='SenderCountryCode' defaultValue={shipmentId?.Status} onChange={(e: any) => setShipmentStatus(e?.target?.value)} className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-r-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px]  ease-linear transition-all duration-150">
                                <option selected>{shipmentId?.Status}</option>
                                {/* <option value="Proof of Delivery">Proof of Delivery</option> */}
                                <option value="In Transit to Destination">In Transit to Destination</option>
                                <option value="Out for Delivery">Out for Delivery</option>
                                <option value="Attempted Delivery - Inaccurate / Incomplete Address">Attempted Delivery - Inaccurate / Incomplete Address</option>

                              </select>

                              {(shipmentStatus == 'Proof of Delivery' || shipmentId?.Status == 'Proof of Delivery') ?
                                <div className="w-full lg:w-12/12 ">
                                  <div className="relative w-full mb-5">
                                    <label htmlFor="message" className="block mb-2 text-sm font-semibold text-[#19213D]">Delivery Notes</label>
                                    <textarea required={true} onChange={(e: any) => setDelieveryInstruction(e.target.value)} name='DeliveryInstructions' rows={3} className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]  ease-linear transition-all duration-150" placeholder="Write here..." defaultValue={shipmentId?.DeliveryInstructions}></textarea>
                                  </div>
                                </div>
                                :
                                ''
                              }


                            </div>
                            :
                            <Select
                              required
                              options={allOptions} // Options for the dropdown
                              defaultValue={allOptions[0]} // Set default selected value
                              onChange={handleChange} // Handle on change
                              classNamePrefix="select" // Add custom class prefix if you need styling
                              isSearchable // Make the dropdown searchable
                              placeholder="Select a status..."
                              isClearable
                            />
                        }



                      </div>


                      <div className="relative w-full mb-4">
                        <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                          Event Date & Time{' '}
                          <span className="text-gray-500 text-xs font-normal">
                            (defaults to current time)
                          </span>
                        </label>
                        <div className="flex gap-2">
                          <input
                            type="datetime-local"
                            value={eventDateTime}
                            max={(() => {
                              const now = new Date();
                              const offset = now.getTimezoneOffset();
                              return new Date(now.getTime() - offset * 60 * 1000).toISOString().slice(0, 16);
                            })()}
                            onChange={(e) => {
                              const now = new Date();
                              const offset = now.getTimezoneOffset();
                              const localNow = new Date(now.getTime() - offset * 60 * 1000).toISOString().slice(0, 16);
                              if (e.target.value <= localNow) {
                                setEventDateTime(e.target.value);
                              }
                            }}
                            className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-2 ease-linear transition-all duration-150"
                          />
                          <button
                            type="button"
                            onClick={() => {
                              const now = new Date();
                              const offset = now.getTimezoneOffset();
                              const localDate = new Date(now.getTime() - offset * 60 * 1000);
                              setEventDateTime(localDate.toISOString().slice(0, 16));
                            }}
                            className="px-3 py-2 bg-gray-100 text-gray-700 text-sm rounded-[5px] hover:bg-gray-200 whitespace-nowrap"
                          >
                            Reset to Now
                          </button>
                        </div>
                        <p className="text-xs text-gray-500 mt-1">
                          Only current or past date/time allowed.
                        </p>
                      </div>




                      {/* OPTIONAL: Add a "Reset to Now" button for convenience */}
                      {/* <div className="flex justify-end mb-4">
                        <button
                          type="button"
                          onClick={() => {
                            const now = new Date();
                            const offset = now.getTimezoneOffset();
                            const localDate = new Date(now.getTime() - offset * 60 * 1000);
                            setEventDateTime(localDate.toISOString().slice(0, 16));
                          }}
                          className="text-sm text-blue-600 hover:text-blue-800 underline"
                        >
                          Reset to Current Time
                        </button>
                      </div> */}




                      <div className="flex justify-end">
                        <button
                          type="button"
                          onClick={() => setShowShipment(!showShipment)}
                          style={{ borderRadius: '50px', color: '#F52424' }}
                          className=" text-red-700 bg-red-200 focus:ring-4 focus:outline-none focus:ring-grredeen-300 font-medium rounded-lg text-sm  px-2 py-1.5 text-center "
                        >{showShipment ? "Hide" : 'Show'} Shipments</button>
                      </div>


                      <div className={showShipment ? "" : 'hidden'}>
                        {loader ?
                          <div className="relative py-5 overflow-x-auto max-h-[50vh] overflow-auto" >
                            <table className="w-full text-sm text-left rtl:text-right text-gray-500 border-separate border-spacing-y-3">


                              <thead className="text-[12px] text-[#808080] bg-[#FAFAFA] ">
                                <tr>

                                  <th scope="col" className="px-2 py-2"></th>

                                  <th scope="col" className="px-2 py-2">
                                    S/N
                                  </th>

                                  <th scope="col" className="px-2 py-2">
                                    Created&nbsp;By
                                  </th>
                                  <th scope="col" className="px-2 py-2">
                                    Created&nbsp;Date
                                  </th>
                                  <th scope="col" className="px-2 py-2">
                                    Shipment&nbsp;ID
                                  </th>


                                  <th scope="col" className="px-2 py-2">
                                    Recipient
                                  </th>
                                  <th scope="col" className="px-2 py-2">
                                    Sender State
                                  </th>
                                  <th scope="col" className="px-2 py-2">
                                    Reciever State
                                  </th>

                                  <th scope="col" className="px-2 py-2">
                                    Fleet
                                  </th>

                                  <th scope="col" className="px-2 py-2">
                                    Vehicle
                                  </th>

                                  <th scope="col" className="px-2 py-2">
                                    Department
                                  </th>
                                  <th scope="col" className="px-2 py-2">
                                    Shipment Status
                                  </th>



                                </tr>
                              </thead>




                              <tbody className=''>

                                {

                                  shipmentInfo?.[shipType]?.data?.map(
                                    (datas: any, index: any) => (
                                      <tr className="bg-white  ">
                                        <td scope="row" className="px-6 py-4 font-medium text-[#6C757D] whitespace-nowrap">
                                          <div className="flex space-x-3">
                                            <div className="flex items-center ">
                                              <input id="default-checkbox" type="checkbox" value={datas?.ShipmentNumber} onChange={(e) => selectShipment(e, datas)} className="w-4 h-4 accent-[#E04343] bg-gray-100 border-gray-300 rounded focus:ring-[#E04343] cursor-pointer" />
                                            </div>
                                          </div>
                                        </td>
                                        <td className="px-2 py-2">
                                          {index + 1}
                                        </td>
                                        <td className="px-6 py-4">
                                          {datas?.SenderName}
                                        </td>
                                        <td className="px-6 py-4">
                                          {convertUTCDateToLocalDate(datas?.created_at)}
                                        </td>
                                        <td className="px-6 py-4 ">
                                          {datas?.ShipmentNumber ? datas?.ShipmentNumber : `Not Available`}
                                        </td>

                                        <td className="px-6 py-4">
                                          {datas?.ReceiverName}
                                        </td>
                                        <td className="px-6 py-4">
                                          {datas?.SenderAddState}
                                        </td>
                                        <td className="px-6 py-4">
                                          {datas?.ReceiverAddState}
                                        </td>

                                        <td className="px-6 py-4 cursor-pointer" onClick={() => { setRiderModal(true); setShipmentId(datas); setDelieveryInstruction(datas?.DeliveryInstructions); }}>
                                          {datas?.fleet_name ? datas?.fleet_name : "No Fleet"}
                                        </td>

                                        <td className="px-6 py-4" >
                                          {datas?.vehicle_name ? datas?.vehicle_name : "No Vehicle"}
                                        </td>

                                        <td className="px-6 py-4 cursor-pointer" onClick={() => { setOfficeModal(true); setShipmentId(datas) }}>
                                          {datas?.office !== '' ? <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#E6BDFF', color: '#B24BF1', borderRadius: '10px', padding: '2px 10px' }}>{(datas?.office)?.replace(/ /g, '_')}</b></p> : ''}

                                        </td>
                                        <td className="px-2 py-2 cursor-pointer" onClick={() => { toggleStatus(datas) }}>
                                          {(datas?.Status == 'inReview' || datas?.Status == 'InReview') ? <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#FFDDBD', color: '#F29339', borderRadius: '10px', padding: '2px 10px' }}>{datas?.Status}</b></p> : <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#C9F0D0', color: '#51CF66', borderRadius: '10px', padding: '2px 10px' }}>{datas?.Status}</b></p>}

                                        </td>


                                      </tr>
                                    )
                                  )


                                }

                              </tbody>

                            </table>
                          </div>
                          :
                          <div className='flex justify-center my-3 mt-20 pb-10'>
                            <Oval
                              visible={true}
                              height="80"
                              width="80"
                              color="#E04343"
                              secondaryColor="#FF3B300D"
                              ariaLabel="oval-loading"
                              wrapperStyle={{}}
                              wrapperClass=""
                            />
                          </div>
                        }

                        <div className='m-4 flex justify-end mt-5'>
                          {
                            shipmentInfo?.[shipType]?.links?.filter(((item: any, idx: any) => idx < 1000)).map(
                              (datas: any, index: any) => (
                                <button onClick={() => paginator(datas?.label == 'Next &raquo;' ? datas?.url?.charAt(datas?.url?.length - 1) : (datas?.label === '&laquo; Previous') ? datas?.url?.charAt(datas?.url?.length - 1) : datas?.label)} disabled={datas?.active} className={'mx-1 py-1 px-2 ' + ((datas?.active == false || datas?.url == null) ? 'bg-gray-300 text-black ' : 'bg-[#E04343] text-white')}>
                                  {datas?.label == '&laquo; Previous' ? '< Previous' : (datas?.label === 'Next &raquo;') ? 'Next  >' : datas?.label}
                                </button>
                              )
                            )
                          }

                        </div>
                      </div>



                      {/* <div className="p-4">
                        <h1 className="text-xl font-bold mb-4">Barcode Scanner</h1>
                        <div className="mb-4">
                          <label className="block text-gray-700 text-sm font-bold mb-2">
                            Add a New Barcode:
                          </label>
                          <input
                            type="text"
                            value={currentInput}
                            onChange={handleInputChange}
                            onKeyDown={handleKeyPress}
                            maxLength={12}
                            placeholder="Scan a barcode and press Enter"
                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          />
                        </div>
                        <div className="mb-4">
                          <label className="block text-gray-700 text-sm font-bold mb-2">
                            Scanned Barcodes (Editable):
                          </label>
                          <textarea
                            value={barcodeValues.join("\n")} // Display barcodes as a comma-separated string
                            onChange={(e: any) => handleBarcodeListChange(e)} // Allow editing
                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            rows={7} // Adjust the height by specifying the number of rows
                          />
                        </div>
                        <p className="text-sm text-gray-500">
                          Add a barcode and press Enter. You can also edit the list directly.
                        </p>
                      </div> */}
                      <div className="p-4 border rounded-lg bg-white">
                        <div className="flex justify-between items-center mb-4">
                          <h1 className="text-xl font-bold">Enhanced Barcode Scanner</h1>
                          {isValidating && (
                            <div className="flex items-center text-blue-600">
                              <Oval height="20" width="20" color="#3B82F6" secondaryColor="#93C5FD" />
                              <span className="ml-2 text-sm">Validating...</span>
                            </div>
                          )}
                        </div>

                        {/* Statistics Panel */}
                        <div className="grid grid-cols-4 gap-4 mb-4">
                          <div className="bg-blue-50 p-3 rounded-lg text-center">
                            <div className="text-2xl font-bold text-blue-600">{scannerStats.total}</div>
                            <div className="text-sm text-blue-800">Total Scanned</div>
                          </div>
                          <div className="bg-green-50 p-3 rounded-lg text-center">
                            <div className="text-2xl font-bold text-green-600">{scannerStats.valid}</div>
                            <div className="text-sm text-green-800">Valid</div>
                          </div>
                          <div className="bg-red-50 p-3 rounded-lg text-center">
                            <div className="text-2xl font-bold text-red-600">{scannerStats.invalid}</div>
                            <div className="text-sm text-red-800">Invalid</div>
                          </div>
                          <div className="bg-yellow-50 p-3 rounded-lg text-center">
                            <div className="text-2xl font-bold text-yellow-600">{scannerStats.duplicates}</div>
                            <div className="text-sm text-yellow-800">Duplicates</div>
                          </div>
                        </div>

                        {/* Enhanced Barcode Input with Mobile Support */}
                        <div className="mb-4">
                          <label className="block text-gray-700 text-sm font-bold mb-2">
                            Scan New Barcode: {barcodeValues.length} scanned
                          </label>

                          {/* Wrap input in a form for better mobile support */}
                          <form onSubmit={handleBarcodeFormSubmit} className="flex gap-2">
                            <input
                              type="text"
                              value={currentInput}
                              onChange={handleInputChange}
                              onKeyDown={handleKeyPress}
                              onKeyPress={handleKeyPress} // Add this for additional mobile support
                              maxLength={12}
                              placeholder="Scan a barcode and press Enter"
                              className="flex-1 px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#E04343]"
                            />

                            {/* Add visible button for mobile users */}
                            <button
                              type="button"
                              onClick={handleAddBarcode}
                              className="px-4 py-2 bg-[#E04343] text-white rounded-md hover:bg-red-600 transition-colors whitespace-nowrap"
                            >
                              Add
                            </button>
                          </form>

                          <p className="text-xs text-gray-500 mt-1">
                            Type or scan barcode, then press Enter or tap "Add"
                          </p>
                        </div>

                        {/* Enhanced Barcode List with Validation Status */}
                        <div className="mb-4">
                          <label className="block text-gray-700 text-sm font-bold mb-2">
                            Scanned Barcodes with Validation Status:
                          </label>
                          <div className="border border-gray-300 rounded-md p-2 max-h-60 overflow-y-auto">
                            {barcodeValues.length === 0 ? (
                              <div className="text-gray-500 text-center py-4">No barcodes scanned yet</div>
                            ) : (
                              <div className="space-y-1">
                                {barcodeValues.map((barcode, index) => (
                                  <div
                                    key={index}
                                    className={`flex items-center justify-between p-2 rounded ${getValidationColor(barcode)}`}
                                  >
                                    <span className="font-mono">{barcode}</span>
                                    <div className="flex items-center space-x-2">
                                      {validationResults[barcode] === 'valid' && (
                                        <span className="text-green-600">✓ Valid</span>
                                      )}
                                      {validationResults[barcode] === 'invalid' && (
                                        <span className="text-red-600">✗ Invalid</span>
                                      )}
                                      {validationResults[barcode] === 'duplicate' && (
                                        <span className="text-yellow-600">⚠ Duplicate</span>
                                      )}
                                      <button
                                        type="button"
                                        onClick={(e: any) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          const newValues = barcodeValues.filter((_, i) => i !== index);
                                          setBarcodeValues(newValues);
                                          validateShipmentNumbers(newValues);
                                        }}
                                        className="text-red-500 hover:text-red-700"
                                      >
                                        ✕
                                      </button>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Bulk Edit Textarea (fallback) */}
                        <div className="mb-4">
                          <label className="block text-gray-700 text-sm font-bold mb-2">
                            Bulk Edit (One per line):
                          </label>
                          <textarea
                            value={barcodeValues.join("\n")}
                            onChange={(e: any) => handleBarcodeListChange(e)}
                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#E04343]"
                            rows={5}
                            placeholder="Enter shipment numbers, one per line"
                          />
                        </div>

                        {/* Action Buttons */}
                        <div className="flex flex-wrap gap-2 mb-4">
                          <button
                            type="button"
                            onClick={() => {
                              setBarcodeValues([]);
                              setValidationResults({});
                              setScannerStats({ total: 0, valid: 0, invalid: 0, duplicates: 0 });
                            }}
                            className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
                          >
                            Clear All
                          </button>
                          <button
                            type="button"
                            onClick={() => validateShipmentNumbers(barcodeValues)}
                            disabled={isValidating || barcodeValues.length === 0}
                            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50"
                          >
                            Re-validate
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              const validOnly = barcodeValues.filter(barcode =>
                                validationResults[barcode] === 'valid'
                              );
                              setBarcodeValues(validOnly);
                              validateShipmentNumbers(validOnly);
                              toast.success(`Removed ${barcodeValues.length - validOnly.length} invalid/duplicate shipments`);
                            }}
                            disabled={scannerStats.invalid === 0 && scannerStats.duplicates === 0}
                            className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 disabled:opacity-50"
                          >
                            Remove Invalid ({scannerStats.invalid + scannerStats.duplicates})
                          </button>
                        </div>

                        <p className="text-sm text-gray-500">
                          Scan barcodes or type them manually. Valid shipments will be highlighted in green,
                          invalid ones in red, and duplicates in yellow. Click the ✕ to remove individual items.
                        </p>
                      </div>

                      <div>
                        <label >Notes</label>
                        <textarea
                          required
                          onChange={(e: any) => setNotesData(e.target.value)} // Allow editing
                          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          rows={4} // Adjust the height by specifying the number of rows
                        />
                      </div>





                      <span className="flex justify-center pt-4">
                        <button
                          type="submit"
                          // disabled={loading}
                          style={{ borderRadius: '50px', color: '#F52424' }}
                          className=" text-red-700 bg-red-200 focus:ring-4 focus:outline-none focus:ring-grredeen-300 font-medium rounded-lg text-sm w-full px-2 py-2.5 text-center "
                        >
                          <div className="flex justify-center gap-3 ">
                            <span>Update</span>
                            <Oval
                              visible={loading}
                              height="20"
                              width="20"
                              color="#E04343"
                              secondaryColor="#FCBF94"
                              ariaLabel="oval-loading"
                              wrapperStyle={{}}
                              wrapperClass=""
                            />
                          </div>
                        </button>
                      </span>

                      <span className="flex justify-center pt-4">
                        <button
                          type="button"
                          onClick={(e) => setStatusModal(false)}
                          style={{ borderRadius: '50px' }}
                          className=" text-black   focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm w-full px-2 py-1.5 text-center "
                        >
                          Cancel
                        </button>
                      </span>

                    </form>
                  </div>

                </div>

              </div>
          }
        </Modal>
      </section>


      <section>
        <Modal
          visible={templateInfoModal}
          width="80%"
          height="600"
          effect="fadeInUp"
          onClickAway={() => setTemplateInfoModal(false)}
        >
          <div className="" style={{ height: '600px', overflow: 'auto' }}>
            <div className="container bg-[#fff] rounded-lg p-4">
              <div className="px-3">
                <span className="flex justify-between px-2 pt-3">
                  <p className='mt-2 text-xl font-bold text-gray-800'>Shipment Upload Template Guide</p>
                  <p className="cursor-pointer font-bold" onClick={() => setTemplateInfoModal(false)}>
                    <SvgElement type={icontypesEnum.CANCEL} />
                  </p>
                </span>

                <div className="mt-6 space-y-6">
                  {/* Download Options */}
                  <div className="bg-blue-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-blue-800 mb-3">Download Options</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="bg-white p-3 rounded border">
                        <h4 className="font-medium text-green-700 mb-2">Excel Template (.xlsx)</h4>
                        <p className="text-sm text-gray-600 mb-3">
                          Formatted template with styling, sample data, and column validation.
                          Recommended for first-time users.
                        </p>
                        <button
                          onClick={() => downloadTemplate('excel')}
                          className="bg-green-600 text-white px-4 py-2 rounded text-sm hover:bg-green-700"
                        >
                          Download Excel Template
                        </button>
                      </div>
                      <div className="bg-white p-3 rounded border">
                        <h4 className="font-medium text-blue-700 mb-2">CSV Template (.csv)</h4>
                        <p className="text-sm text-gray-600 mb-3">
                          Simple comma-separated format compatible with all spreadsheet applications.
                          Lighter download.
                        </p>
                        <button
                          onClick={() => downloadTemplate('csv')}
                          className="bg-blue-600 text-white px-4 py-2 rounded text-sm hover:bg-blue-700"
                        >
                          Download CSV Template
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Required Columns */}
                  <div className="bg-red-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-red-800 mb-3">Required Columns</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      {templateInfo.requiredColumns.map((column, index) => (
                        <div key={index} className="bg-white p-3 rounded border-l-4 border-red-400">
                          <h4 className="font-medium text-gray-800">{column.name}</h4>
                          <p className="text-sm text-gray-600">{column.description}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Optional Columns */}
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-gray-800 mb-1">Optional Columns</h3>
                    <p className="text-sm text-gray-600 mb-3">
                      Include these if you have them. Leaving a column out, or leaving a cell blank,
                      is not an error.
                    </p>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      {templateInfo.optionalColumns.map((column, index) => (
                        <div key={index} className="bg-white p-3 rounded border-l-4 border-gray-300">
                          <h4 className="font-medium text-gray-800">{column.name}</h4>
                          <p className="text-sm text-gray-600">{column.description}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Service Types */}
                  <div className="bg-yellow-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-yellow-800 mb-3">Available Service Types</h3>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                      {templateInfo.serviceTypes.map((service, index) => (
                        <div key={index} className="bg-white p-3 rounded border">
                          <h4 className="font-medium text-gray-800">{service.code}</h4>
                          <p className="text-sm text-gray-600">{service.name}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Upload Instructions */}
                  <div className="bg-green-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-green-800 mb-3">Upload Instructions</h3>
                    <ol className="list-decimal list-inside space-y-2 text-sm text-gray-700">
                      <li>Download either the Excel or CSV template using the buttons above</li>
                      <li>Fill in your shipment data, ensuring all required fields are completed</li>
                      <li>Do not modify the column headers or add new columns</li>
                      <li>Use the provided service type codes (DOME, EN, ED, etc.)</li>
                      <li>Ensure phone numbers include country code (e.g., +234...)</li>
                      <li>Use YYYY-MM-DD HH:MM:SS format for dates</li>
                      <li>Leave "Connote #" column empty - it will be auto-generated</li>
                      <li>Save your file and upload using the "Upload Shipment Excel File" button</li>
                    </ol>
                  </div>

                  {/* Common Errors */}
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-gray-800 mb-3">Common Upload Errors to Avoid</h3>
                    <ul className="list-disc list-inside space-y-1 text-sm text-gray-700">
                      <li>Missing required fields (highlighted in red above)</li>
                      <li>Invalid service type codes</li>
                      <li>Incorrect date formats</li>
                      <li>Phone numbers without country codes</li>
                      <li>Special characters in text fields that may cause encoding issues</li>
                      <li>Files with modified column headers</li>
                      <li>Uploading files in unsupported formats</li>
                    </ul>
                  </div>

                  {/* Sample Data Preview */}
                  <div className="bg-indigo-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-indigo-800 mb-3">Sample Data Format</h3>
                    <div className="overflow-x-auto">
                      <table className="min-w-full text-xs border border-gray-300">
                        <thead className="bg-gray-100">
                          <tr>
                            <th className="border border-gray-300 px-2 py-1">Date</th>
                            <th className="border border-gray-300 px-2 py-1">Sender</th>
                            <th className="border border-gray-300 px-2 py-1">Sender State</th>
                            <th className="border border-gray-300 px-2 py-1">Receiver</th>
                            <th className="border border-gray-300 px-2 py-1">Receiver State</th>
                            <th className="border border-gray-300 px-2 py-1">Wgt (KG)</th>
                            <th className="border border-gray-300 px-2 py-1">Type</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="border border-gray-300 px-2 py-1">2024-01-15 10:30:00</td>
                            <td className="border border-gray-300 px-2 py-1">John Doe</td>
                            <td className="border border-gray-300 px-2 py-1">Lagos</td>
                            <td className="border border-gray-300 px-2 py-1">Jane Smith</td>
                            <td className="border border-gray-300 px-2 py-1">Abuja</td>
                            <td className="border border-gray-300 px-2 py-1">2.5</td>
                            <td className="border border-gray-300 px-2 py-1">DOME</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                {/* Close Button */}
                <div className="flex justify-center mt-6">
                  <button
                    onClick={() => setTemplateInfoModal(false)}
                    className="bg-gray-600 text-white px-6 py-2 rounded hover:bg-gray-700"
                  >
                    Close Guide
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </section>


      <section>
        <Modal
          visible={exportModal}
          width="550"
          height="500"
          effect="fadeInUp"
          onClickAway={() => setExportModal(false)}
        >
          <div className=" " style={{ height: '100%', overflow: 'auto' }}>

            <div className="container  bg-[#fff] rounded-lg p-2">

              <div className="px-3">

                {/* <span className="flex justify-around">
                    <h1 className=" text-xs text-red-600" style={{ fontSize: '10px' }}>Link can’t be edited in free plan. <span style={{ color: '#61A24F' }} className="font-bold text-xs">Upgrade to Pro</span></h1>
                  </span> */}
                <span className="flex justify-between px-2 pt-3">
                  <p className='mt-2'>Select filters for export</p>
                  <p className="cursor-pointer font-bold" onClick={(e) => setExportModal(false)}><SvgElement type={icontypesEnum.CANCEL} /></p>
                </span>

                <form onSubmit={generateReport}>
                  {/* Which business the report covers. Credit customers are
                      billed through CFLEX, so their shipments have to be
                      separable from the walk-in business. */}
                  <div className="px-4 pt-4">
                    <label className="text-[#333333] text-[12px] block mb-2">Which shipments?</label>
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
                      {[
                        ['all', 'Everything'],
                        ['in_house', 'In-house only'],
                        ['credit', 'Credit customers'],
                      ].map(([v, label]) => (
                        <button
                          key={v}
                          type="button"
                          onClick={() => { setReportScope(v as any); setReportPreview(null); }}
                          className={`px-3 py-2 rounded-md text-sm border ${reportScope === v ? 'bg-[#E04343] text-white border-[#E04343]' : 'bg-white text-gray-700 border-gray-300'}`}
                        >
                          {label}
                        </button>
                      ))}
                    </div>

                    <button
                      type="button"
                      onClick={() => { setReportScope('credit_customer'); setReportPreview(null); }}
                      className={`mt-2 w-full px-3 py-2 rounded-md text-sm border ${reportScope === 'credit_customer' ? 'bg-[#E04343] text-white border-[#E04343]' : 'bg-white text-gray-700 border-gray-300'}`}
                    >
                      One specific credit customer
                    </button>

                    {reportScope === 'credit_customer' && (
                      <select
                        value={reportCustomer}
                        onChange={(e) => { setReportCustomer(e.target.value); setReportPreview(null); }}
                        className="mt-2 bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-2"
                      >
                        <option value="">-- choose a credit customer --</option>
                        {creditCustomers.map((c: any) => (
                          <option key={c.id ?? c.email} value={c.email}>
                            {(c.name || `${c.first_name ?? ''} ${c.last_name ?? ''}`).trim()} — {c.email}
                          </option>
                        ))}
                      </select>
                    )}
                  </div>

                  <div className="flex flex-col lg:flex-row lg:justify-between max-w-screen-xl mx-auto  mt-5">
                    <div className="relative flex flex-col min-w-0 break-words w-full  ">
                      <div className="flex-auto   py-10 pt-0">
                        <div className="flex flex-wrap ">

                          <div className="lg:w-6/12 w-full lg:pr-2">
                            <div className="flex justify-between mb-3">
                              <label className="text-[#333333] text-[12px]">From</label>
                              <SvgElement type={icontypesEnum.QUESTIONMARK} />
                            </div>
                            <div className="relative mb-4">
                              <input type="date" onChange={e => setFromDate(e.target.value)} placeholder='' className=" border border-gray-300 text-gray-500 text-sm rounded-md block w-full pl-4 p-2  " />
                            </div>
                          </div>

                          <div className="lg:w-6/12 w-full pr-2">
                            <div className="flex justify-between mb-3">
                              <label className="text-[#333333] text-[12px]">To</label>
                              <SvgElement type={icontypesEnum.QUESTIONMARK} />
                            </div>
                            <div className="relative mb-4">
                              <input type="date" onChange={e => setToDate(e.target.value)} placeholder='' className=" border border-gray-300 text-gray-500 text-sm rounded-md block w-full pl-4 p-2  " />
                            </div>
                          </div>

                          <div className="lg:w-6/12 w-full pr-2">
                            <div className="relative w-full mb-5">
                              <label className="block mb-2 text-[#333333] text-[12px]">
                                Destination State
                              </label>
                              <select name="office" onChange={(e) => setFilterBranch(e.target.value)} id="countries2" className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px]  ease-linear transition-all duration-150">
                                <option selected value={''} >--select state--</option>
                                {/* {localState?.data?.map((datas: any, index: any) => (
                                  <option key={index} value={datas?.state}>{datas?.branch_name}</option>
                                )
                                )} */}


                                {localState?.data?.filter((data: any) => data?.client_id == null)?.map((state: any, index: any) => (
                                  <option key={index} value={state?.state_name}>{state?.state_name}</option>
                                ))}
                              </select>
                            </div>
                          </div>

                          <div className="lg:w-6/12 w-full pr-2">
                            <label className="block mb-2 text-[#333333] text-[12px]">
                              Shipment Status
                            </label>
                            <Select
                              className='w-full'
                              options={allOptions} // Options for the dropdown
                              defaultValue={allOptions[0]} // Set default selected value
                              onChange={handleExportChange} // Handle on change
                              classNamePrefix="select" // Add custom class prefix if you need styling
                              isSearchable // Make the dropdown searchable
                              placeholder="Filter by Status..."
                              isClearable
                            />
                          </div>
                          <div className="lg:w-12/12 w-full lg:pr-2">
                            <div className="flex justify-between mb-2">
                              <label className="text-[#333333] text-[12px] font-[400]">Email</label>
                            </div>
                            <div className="relative mb-4">
                              <input type="email" name="email" onChange={e => setUserEmail(e.target.value)} className=" border border-[#D1D1D1] text-gray-900 text-sm rounded-[5px] block w-full pl-6 p-2" placeholder="john@gmail.com" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Counting first means nobody waits minutes for a file that
                      turns out to be empty or enormous. */}
                  {reportPreview && (
                    <div className="mb-3 rounded-md bg-gray-50 border border-gray-200 px-3 py-2 text-sm text-gray-700">
                      <strong>{Number(reportPreview.total).toLocaleString()}</strong> shipment(s) match
                      {reportPreview.freight_total > 0 && (
                        <> · freight ₦{Number(reportPreview.freight_total).toLocaleString(undefined, { minimumFractionDigits: 2 })}</>
                      )}
                      {reportPreview.total === 0 && (
                        <p className="text-orange-600 mt-1">Nothing to export with these filters.</p>
                      )}
                      {reportPreview.total > 50000 && (
                        <p className="text-orange-600 mt-1">That is a very large file — consider a shorter date range.</p>
                      )}
                    </div>
                  )}

                  <div className="flex gap-2">
                    <button
                      type="button"
                      onClick={previewReport}
                      disabled={reportBusy}
                      className="text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-[30px] w-1/3 py-[10px] font-[700] text-[14px] disabled:opacity-50"
                    >
                      {reportBusy ? '…' : 'Count first'}
                    </button>
                    <button
                      type="submit"
                      disabled={reportBusy || reportPreview?.total === 0}
                      className="text-white bg-[#E04343] rounded-[30px] flex-1 transition ease-out delay-300 py-[10px] font-[700] text-[14px] disabled:opacity-50"
                    >
                      {reportBusy ? 'Working…' : 'Download Report'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </Modal>
      </section>


      <section>
        <Modal
          visible={officeModal}
          width="350"
          height="300"
          effect="fadeInUp"
          onClickAway={() => setOfficeModal(false)}
        >
          <div className=" " style={{ height: '100%', overflow: 'auto' }}>

            <div className="container  bg-[#fff] rounded-lg p-2">

              <div className="px-3">

                {/* <span className="flex justify-around">
                    <h1 className=" text-xs text-red-600" style={{ fontSize: '10px' }}>Link can’t be edited in free plan. <span style={{ color: '#61A24F' }} className="font-bold text-xs">Upgrade to Pro</span></h1>
                  </span> */}
                <span className="flex justify-between px-2 pt-3">
                  <p className='mt-2'>Change Department</p>
                  <p className="cursor-pointer font-bold" onClick={(e) => setOfficeModal(false)}><SvgElement type={icontypesEnum.CANCEL} /></p>
                </span>





                <form className="pb-4 rounded-lg" onSubmit={updateShipmentOffice}>

                  <div className="relative w-full mt-10 mb-4">
                    <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                      Department {shipmentId?.office}
                    </label>
                    <select id="countries" defaultValue={shipmentId?.office} onChange={(e: any) => setShipmentOffice(e?.target?.value)} className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-r-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px]  ease-linear transition-all duration-150">
                      <option selected>{shipmentId?.office}</option>
                      <option value="customer service">customer service</option>
                      <option value="operations">operations</option>
                      <option value="financial">financial</option>
                      <option value="rider">rider</option>
                      <option value="admin">admin</option>
                      {/* <option value="In Transit">In-Transit</option>
                      <option value="Out for Delievery">Out for Delievery</option> */}
                    </select>
                  </div>


                  <span className="flex justify-center pt-4">
                    <button
                      type="submit"
                      style={{ borderRadius: '50px', color: '#F52424' }}
                      className=" text-red-700 bg-red-200 focus:ring-4 focus:outline-none focus:ring-grredeen-300 font-medium rounded-lg text-sm w-full px-2 py-2.5 text-center "
                    >
                      Update
                    </button>
                  </span>

                  <span className="flex justify-center pt-4">
                    <button
                      type="button"
                      onClick={(e) => setStatusModal(false)}
                      style={{ borderRadius: '50px' }}
                      className=" text-black   focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm w-full px-2 py-1.5 text-center "
                    >
                      Cancel
                    </button>
                  </span>

                </form>
              </div>

            </div>

          </div>
        </Modal>
      </section>

      <section>
        <Modal
          visible={riderModal}
          width="350"
          height="400"
          effect="fadeInUp"
          onClickAway={() => setRiderModal(false)}
        >
          <div className=" " style={{ height: '100%', overflow: 'auto' }}>

            <div className="container  bg-[#fff] rounded-lg p-2">

              <div className="px-3">

                <span className="flex justify-between px-2 pt-3">
                  <p className='mt-2 font-bold'>Attach Fleet</p>
                  <p className="cursor-pointer font-bold" onClick={(e) => setRiderModal(false)}><SvgElement type={icontypesEnum.CANCEL} /></p>
                </span>


                <form className="pb-4 rounded-lg" onSubmit={updateShipmentRider}>

                  <div className="relative w-full mt-10 mb-4">
                    <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                      Select Fleet
                    </label>
                    <select id="countries" onChange={(e: any) => { setShipmentRider(e?.target?.value); getAllVehicles(e?.target?.value) }} className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-r-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px]  ease-linear transition-all duration-150">
                      <option selected>{shipmentId?.rider ? shipmentId?.rider : 'Select Fleet'}</option>

                      {riders?.map((datas: any, index: any) => (
                        <option value={datas?.first_name}>{datas?.first_name}</option>
                      )
                      )}

                      {/* <option value="In Transit">In-Transit</option>
                      <option value="Out for Delievery">Out for Delievery</option> */}
                    </select>
                  </div>


                  <div className="relative w-full mt-4 mb-4">
                    <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                      Select Vehicle
                    </label>
                    <select id="countries" onChange={(e: any) => setShipmentvehicle(e?.target?.value)} className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-r-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px]  ease-linear transition-all duration-150">
                      <option selected>{shipmentId?.vehicle_name ? shipmentId?.vehicle_name : 'Select Vehicle'}</option>

                      {vehicle?.filter((data: any) => data?.status == 'Available')?.map((datas: any, index: any) => (
                        <option value={datas?.vehicle_name}>{datas?.vehicle_name}</option>
                      )
                      )}

                      {/* <option value="In Transit">In-Transit</option>
                      <option value="Out for Delievery">Out for Delievery</option> */}
                    </select>
                  </div>


                  <span className="flex justify-center pt-4">
                    <button
                      type="submit"
                      style={{ borderRadius: '50px', color: '#F52424' }}
                      className=" text-red-700 bg-red-200 focus:ring-4 focus:outline-none focus:ring-grredeen-300 font-medium rounded-lg text-sm w-full px-2 py-2.5 text-center "
                    >
                      Update
                    </button>
                  </span>

                  <span className="flex justify-center pt-4">
                    <button
                      type="button"
                      onClick={(e) => setRiderModal(false)}
                      style={{ borderRadius: '50px' }}
                      className=" text-black   focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm w-full px-2 py-1.5 text-center "
                    >
                      Cancel
                    </button>
                  </span>

                </form>
              </div>

            </div>

          </div>
        </Modal>
      </section>

      <section>
        <Modal
          visible={deleteModal}
          width="400"
          height="200"
          effect="fadeInUp"
          onClickAway={() => setDeleteModal(false)}
        >
          <div className="p-2" style={{ overflow: 'auto' }}>
            <span className="flex justify-between px-1 mb-3">
              <p className='font-bold mt-1'>Delete Shipment</p>
              <p className="cursor-pointer font-bold" onClick={() => setDeleteModal(false)}><SvgElement type={icontypesEnum.CANCEL} /></p>

            </span>

            <form onSubmit={deleteShipmnt}>
              <div className='my-10 flex justify-center'>
                <span>Are you sure you want to delete this shipment ?</span>
              </div>
              <div className="w-full flex justify-end">
                <button type='submit' className='bg-[#E04343] text-white py-[6px] rounded w-full'>Delete Shipment</button>
              </div>
            </form>
          </div>
        </Modal>
      </section>



      <section>
        <Modal
          visible={uploadProgress.show}
          width="500"
          height="420"
          effect="fadeInUp"
          onClickAway={() => { /* prevent dismiss while uploading */ }}
        >
          <div className="p-6 bg-white rounded-lg">
            <h2 className="text-lg font-bold mb-4 text-[#19213D]">
              {uploadProgress.done ? 'Upload Complete' : 'Uploading Shipments...'}
            </h2>

            <div className="mb-4">
              <div className="flex justify-between text-sm mb-2 text-gray-700">
                <span>Progress</span>
                <span>{uploadProgress.processed} / {uploadProgress.total}</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-4 overflow-hidden">
                <div
                  className="bg-[#E04343] h-4 rounded-full transition-all duration-300"
                  style={{
                    width: `${uploadProgress.total > 0
                      ? (uploadProgress.processed / uploadProgress.total) * 100
                      : 0}%`
                  }}
                />
              </div>
              <p className="text-xs text-center mt-2 text-gray-600">
                {uploadProgress.total > 0
                  ? ((uploadProgress.processed / uploadProgress.total) * 100).toFixed(1)
                  : 0}%
              </p>
            </div>

            <div className="grid grid-cols-4 gap-2 mb-4">
              <div className="bg-blue-50 p-2 rounded text-center">
                <p className="text-xl font-bold text-blue-600">{uploadProgress.currentBatch}</p>
                <p className="text-[10px] text-blue-800">Batch</p>
              </div>
              <div className="bg-green-50 p-2 rounded text-center">
                <p className="text-xl font-bold text-green-600">{uploadProgress.successful}</p>
                <p className="text-[10px] text-green-800">Created</p>
              </div>
              <div className="bg-yellow-50 p-2 rounded text-center">
                <p className="text-xl font-bold text-yellow-600">{uploadProgress.skipped}</p>
                <p className="text-[10px] text-yellow-800">Skipped</p>
              </div>
              <div className="bg-red-50 p-2 rounded text-center">
                <p className="text-xl font-bold text-red-600">{uploadProgress.failed}</p>
                <p className="text-[10px] text-red-800">Failed</p>
              </div>
            </div>

            <p className="text-sm text-center text-gray-600">
              Batch {uploadProgress.currentBatch} of {uploadProgress.totalBatches}
            </p>

            {uploadProgress.failedBatches.length > 0 && (
              <div className="mt-3 p-2 bg-red-50 rounded text-xs text-red-700 max-h-20 overflow-auto">
                Failed batches: {uploadProgress.failedBatches.join(', ')}
              </div>
            )}

            {!uploadProgress.done && (
              <div className="flex justify-center mt-4">
                <Oval
                  visible={true}
                  height="30"
                  width="30"
                  color="#E04343"
                  secondaryColor="#FCBF94"
                  ariaLabel="oval-loading"
                />
              </div>
            )}

            {uploadProgress.done && (
              <div className="mt-4 space-y-2">
                {uploadProgress.failedRows.length > 0 ? (
                  <>
                    <div className="bg-red-50 border border-red-200 rounded p-3 text-sm text-red-800">
                      <p className="font-semibold mb-1">
                        {uploadProgress.failedRows.length} shipment(s) failed
                      </p>
                      <p className="text-xs">
                        Download the failed rows below, fix the errors, and re-upload.
                      </p>
                    </div>

                    <button
                      type="button"
                      onClick={downloadFailedRows}
                      className="w-full bg-[#E04343] hover:bg-red-600 text-white py-2 px-4 rounded font-medium text-sm flex items-center justify-center gap-2"
                    >
                      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
                      </svg>
                      Download {uploadProgress.failedRows.length} Failed Shipment(s)
                    </button>

                    <button
                      type="button"
                      onClick={() => {
                        setUploadProgress(prev => ({ ...prev, show: false }));
                        window.location.reload();
                      }}
                      className="w-full bg-gray-200 hover:bg-gray-300 text-gray-800 py-2 px-4 rounded font-medium text-sm"
                    >
                      Close & Refresh
                    </button>
                  </>
                ) : (
                  <p className="text-center text-xs text-gray-500">
                    Reloading shortly...
                  </p>
                )}
              </div>
            )}
          </div>
        </Modal>
      </section>



      <ToastContainer
        position="top-right"
        autoClose={8000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover />

      {/* ── Restore docket numbers ─────────────────────────────────────
          Two steps on purpose: Check the file reports what would change and
          writes nothing, Apply commits the same reading. This rewrites the
          grouping every docket-level charge is billed by, so a bad sheet has to
          be findable before it lands. */}
      {docketModal && (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[88vh] flex flex-col">
            <div className="flex items-center justify-between px-5 py-3 border-b">
              <div>
                <h3 className="font-semibold">Update docket numbers</h3>
                <p className="text-xs text-gray-500">Corrects the docket, date and account code on shipments already in the system</p>
              </div>
              <button onClick={() => setDocketModal(false)} className="text-gray-400 hover:text-gray-700 text-xl leading-none">
                &times;
              </button>
            </div>

            <div className="px-5 py-4 overflow-y-auto">
              <div className="bg-blue-50 border-l-4 border-blue-400 rounded-r-md px-4 py-3 mb-4">
                <p className="text-sm text-blue-900">
                  Upload a sheet with a <strong>Shipment Number</strong> column, plus any of{' '}
                  <strong>Docket Number</strong>, <strong>Date</strong> and{' '}
                  <strong>Account Code</strong>. Only the columns present are changed — leave one out
                  and that field is left exactly as it is. Shipments are matched on their shipment
                  number, or on the sender reference if that is what the sheet carries.
                </p>
                <p className="text-sm text-blue-900 mt-2">
                  Dates must be written <strong>year first</strong> — 2026/07/09 or 2026-07-09.
                  A date like 09/07/2026 is ambiguous and will be rejected rather than guessed at.
                </p>
                <p className="text-sm text-blue-900 mt-2">
                  Only the docket is written. Manifests are not touched.
                </p>
              </div>

              <label className="block border-2 border-dashed rounded-lg px-4 py-6 text-center cursor-pointer hover:border-[#E04343]">
                <input
                  type="file"
                  accept=".xlsx,.xls,.csv"
                  className="hidden"
                  disabled={docketBusy !== ''}
                  onChange={(e) => {
                    const f = e.target.files?.[0] || null;
                    setDocketFile(f);
                    if (f) parseDocketFile(f);
                  }}
                />
                <span className="text-sm text-gray-700 font-medium">
                  {docketFile ? docketFile.name : 'Choose an Excel or CSV file'}
                </span>
                <span className="block text-xs text-gray-400 mt-1">.xlsx, .xls or .csv</span>
              </label>

              {docketParseError && (
                <div className="mt-3 bg-red-50 border-l-4 border-red-500 px-3 py-2 rounded-r text-sm text-red-900">
                  {docketParseError}
                </div>
              )}

              {docketPairs && (
                <p className="mt-3 text-sm text-gray-600">
                  Read <strong>{docketPairs.length.toLocaleString()}</strong> row(s) from the file
                  {docketResult?.blank_rows > 0 && ` — ${docketResult.blank_rows.toLocaleString()} blank row(s) skipped`}.
                  {' '}They are sent in batches of {DOCKET_BATCH_SIZE.toLocaleString()}.
                </p>
              )}

              {/* Progress. A 65-batch run needs to show it is alive. */}
              {docketBusy !== '' && (
                <div className="mt-3">
                  <div className="flex justify-between text-xs text-gray-600 mb-1">
                    <span>{docketBusy === 'apply' ? 'Saving…' : 'Checking…'}</span>
                    <span>
                      {docketProgress.done.toLocaleString()} / {docketProgress.total.toLocaleString()}
                    </span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div
                      className="bg-[#E04343] h-2 rounded-full transition-all"
                      style={{ width: `${docketProgress.total ? (docketProgress.done / docketProgress.total) * 100 : 0}%` }}
                    />
                  </div>
                </div>
              )}

              {/* What the sheet was read as. A column that was not recognised is the
                  usual reason an upload reports no changes. */}
              {docketResult?.columns && (
                <div className="bg-gray-50 border rounded-md px-3 py-2.5 mb-3">
                  <p className="text-xs font-semibold text-gray-600 mb-1.5">Columns read from your sheet</p>
                  <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs">
                    {[
                      ['Shipment Number', docketResult.columns.number],
                      ['Docket Number', docketResult.columns.docket],
                      ['Date', docketResult.columns.date],
                      ['Account Code', docketResult.columns.account_code],
                    ].map(([label, found]: any) => (
                      <span key={label} className={found ? 'text-gray-700' : 'text-gray-400'}>
                        {found ? '✓' : '—'} {label}
                        {found && found.toLowerCase() !== String(label).toLowerCase() && (
                          <span className="text-gray-400"> (as “{found}”)</span>
                        )}
                      </span>
                    ))}
                  </div>

                  {(!docketResult.columns.date || !docketResult.columns.account_code) && (
                    <p className="text-[11px] text-amber-700 mt-2">
                      A column marked — was not found, so that field is left untouched. If you meant to
                      update it, rename the column in your sheet. Headers present:{' '}
                      <span className="text-gray-600">{(docketResult.sheet_headers || []).join(', ')}</span>
                    </p>
                  )}
                </div>
              )}

              {docketResult && !docketResult.parsed_only && (
                <div className="mt-4">
                  <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-3">
                    {[
                      ['Matched', docketResult.matched],
                      [docketResult.committed ? 'Updated' : 'Will set', docketResult.committed ? docketResult.updated : docketResult.will_set],
                      ['Will overwrite', docketResult.will_overwrite],
                      ['Not found', docketResult.not_found],
                    ].map(([label, value]: any, i: number) => (
                      <div key={i} className="bg-gray-50 rounded p-2.5">
                        <p className="text-[11px] text-gray-500">{label}</p>
                        <p className="text-lg font-semibold text-gray-800">{Number(value || 0).toLocaleString()}</p>
                      </div>
                    ))}
                  </div>

                  <div className="flex flex-wrap gap-4 text-xs text-gray-600 mb-3">
                    <span>Rows processed: <strong>{Number(docketResult.rows_read || 0).toLocaleString()}</strong></span>
                    <span>Already correct: <strong>{Number(docketResult.already_correct || 0).toLocaleString()}</strong></span>
                    {docketResult.skipped_rows > 0 && (
                      <span>Skipped rows: <strong>{Number(docketResult.skipped_rows).toLocaleString()}</strong></span>
                    )}
                  </div>

                  {docketResult.failed_batches > 0 && (
                    <div className="bg-red-50 border-l-4 border-red-500 px-3 py-2 rounded-r text-sm text-red-900 mb-3">
                      {docketResult.failed_batches} batch(es) failed. Every batch is independent and
                      safe to repeat, so press the same button again to retry those rows.
                    </div>
                  )}

                  {docketResult.will_overwrite > 0 && (
                    <div className="bg-amber-50 border-l-4 border-amber-500 px-3 py-2 rounded-r text-sm mb-3">
                      <p className="font-semibold text-amber-900">
                        {Number(docketResult.will_overwrite).toLocaleString()} existing value(s) will change
                      </p>
                      <p className="text-amber-800 text-xs mt-1 mb-1">
                        {docketResult.committed
                          ? 'These were replaced with what the sheet says.'
                          : 'Applying replaces these with what the sheet says.'}
                      </p>
                      {/* Named per field: a changed date moves a shipment into a
                          different invoice period, which is not the same kind of
                          change as correcting a docket. */}
                      <div className="text-amber-800 text-xs space-y-0.5">
                        {(docketResult.overwrite_samples || []).slice(0, 8).map((o: any, i: number) => (
                          <div key={`${o.number}-${o.field || 'docket'}-${i}`}>
                            <span className="font-medium">{o.number}</span>
                            {' '}{o.field || 'docket'}:{' '}
                            <span className="line-through opacity-70">{o.current}</span>
                            {' → '}
                            <span className="font-medium">{o.new}</span>
                          </div>
                        ))}
                        {docketResult.will_overwrite > (docketResult.overwrite_samples || []).length && (
                          <div className="opacity-70">
                            …and {Number(docketResult.will_overwrite - (docketResult.overwrite_samples || []).length).toLocaleString()} more.
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Dates the server refused to read. Shown separately from
                      "not found": the shipment exists, the date could not be trusted. */}
                  {docketResult.bad_dates > 0 && (
                    <div className="bg-red-50 border-l-4 border-red-500 px-3 py-2 rounded-r text-sm mb-3">
                      <p className="font-semibold text-red-900">
                        {Number(docketResult.bad_dates).toLocaleString()} row(s) skipped — the date could not be read
                      </p>
                      <p className="text-red-800 text-xs mt-1 mb-1">
                        Dates must be written year first: <strong>2026/07/09</strong> or{' '}
                        <strong>2026-07-09</strong>. Something like 09/07/2026 could be July or
                        September, so it is refused rather than guessed at. Nothing on these rows was
                        changed — fix the dates and upload again.
                      </p>
                      <div className="text-red-800 text-xs space-y-0.5">
                        {(docketResult.bad_date_samples || []).slice(0, 8).map((b: any, i: number) => (
                          <div key={`${b.number}-${i}`}>
                            <span className="font-medium">{b.number}</span>
                            {' — '}
                            <span className="font-mono">{b.value}</span>
                          </div>
                        ))}
                        {docketResult.bad_dates > (docketResult.bad_date_samples || []).length && (
                          <div className="opacity-70">
                            …and {Number(docketResult.bad_dates - (docketResult.bad_date_samples || []).length).toLocaleString()} more.
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {docketResult.not_found > 0 && (
                    <div className="bg-gray-50 rounded px-3 py-2 text-xs text-gray-600 mb-3">
                      <p className="font-medium text-gray-700 mb-1">
                        Not in the system ({Number(docketResult.not_found).toLocaleString()}) — these rows do nothing:
                      </p>
                      <p className="text-gray-500 break-words">
                        {(docketResult.not_found_samples || []).join(', ')}
                        {docketResult.not_found > (docketResult.not_found_samples || []).length && ' …'}
                      </p>
                    </div>
                  )}

                  {/* Every matched row already held these values — usually a column
                      that was not recognised, so nothing was compared. */}
                  {docketResult.matched > 0
                    && docketResult.will_set === 0
                    && docketResult.will_overwrite === 0
                    && (docketResult.updated ?? 0) === 0 && (
                    <div className="bg-blue-50 border-l-4 border-blue-400 px-3 py-2 rounded-r text-sm mb-3">
                      <p className="font-semibold text-blue-900">Nothing to change</p>
                      <p className="text-blue-800 text-xs mt-1">
                        All {Number(docketResult.matched).toLocaleString()} matched shipment(s) already hold
                        exactly what the sheet says. If you expected changes, check the columns read above —
                        a header spelled differently is not recognised, and that field is then never compared.
                      </p>
                    </div>
                  )}

                  {docketResult.committed && docketBusy === '' && (
                    <div className="bg-green-50 border-l-4 border-green-500 px-3 py-2 rounded-r text-sm text-green-900">
                      Saved. {Number(docketResult.updated || 0).toLocaleString()} shipment(s) updated.
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className="flex justify-end gap-2 px-5 py-3 border-t">
              <button
                onClick={() => setDocketModal(false)}
                disabled={docketBusy !== ''}
                className="px-4 py-2 text-sm text-gray-600 disabled:opacity-50"
              >
                Close
              </button>
              <button
                onClick={() => runDocketUpload(false)}
                disabled={!docketPairs || docketBusy !== ''}
                className="bg-gray-100 text-gray-700 px-4 py-2 rounded-md text-sm disabled:opacity-50"
              >
                {docketBusy === 'check' ? 'Checking…' : 'Check the file'}
              </button>
              <button
                onClick={() => runDocketUpload(true)}
                // Gated on a completed check: nothing writes until the operator has
                // seen what it would change.
                disabled={!docketPairs || !docketResult || docketResult.parsed_only || docketBusy !== ''}
                className="bg-[#E04343] text-white px-4 py-2 rounded-md text-sm disabled:opacity-50"
              >
                {docketBusy === 'apply' ? 'Saving…' : 'Apply'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default Shipments